/* ═══════════════════════════════════════════════════════════
   Vetts Hero Chat — client JS
   - Geen API-key in dit bestand. POST gaat naar de Azure-proxy.
   - Analyzer uit de oorspronkelijke demo, met extra normalisatie
     voor de payload naar de proxy (match schema in azure-proxy).
   ═══════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  // ── UTIL ──────────────────────────────────────────────────────────────
  function uuidv4() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  }
  function isMobile() {
    return window.innerWidth < 768;
  }

  // sessionStorage-sleutels voor de betaalde-intake-flow (v2_payment). Op module-
  // niveau zodat zowel createChatEngine als bindSection exact dezelfde sleutel
  // gebruiken (geen stille divergentie als de versie ooit bumpt).
  var PAY_STASH_KEY = "vh_pay_stash_v1";
  // Vlag: "er is NU een redirect-betaling (bv. iDEAL) in gang gezet". Alleen dan
  // hervatten we na een verse boot een afgebroken betaling.
  var PAY_REDIRECT_KEY = "vh_pay_redirect_v1";
  // Een afgebroken betaling hervatten we alleen als de stash recent is.
  var PAY_RESUME_MAX_AGE_MS = 30 * 60 * 1000;

  function parseHHMMGlobal(s, fallback) {
    if (typeof s !== "string") return fallback;
    var m = s.match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return fallback;
    var h = parseInt(m[1], 10);
    var min = parseInt(m[2], 10);
    if (isNaN(h) || isNaN(min) || h < 0 || h > 23 || min < 0 || min > 59) {
      return fallback;
    }
    return h * 60 + min;
  }

  /**
   * Globale variant van pickWaitTimeText — werkt ook buiten de chat-engine
   * (bv. om de banner-stat "Gem. antwoordtijd" te updaten). Neemt een config
   * met waitDayStart/End + waitDayText/NightText.
   */
  function pickWaitTimeTextFor(config) {
    var now = new Date();
    var nowMin = now.getHours() * 60 + now.getMinutes();
    var dayStart = parseHHMMGlobal(config.waitDayStart, 7 * 60);
    var dayEnd = parseHHMMGlobal(config.waitDayEnd, 23 * 60);
    var isDay;
    if (dayStart < dayEnd) {
      isDay = nowMin >= dayStart && nowMin < dayEnd;
    } else {
      isDay = nowMin >= dayStart || nowMin < dayEnd;
    }
    return isDay
      ? config.waitDayText || "12 min"
      : config.waitNightText || "30 min";
  }

  /**
   * Title-case voor namen: eerste letter van elk woord een hoofdletter, rest
   * lowercase. "BRAM" → "Bram", "max" → "Max", "jan-peter" → "Jan-Peter",
   * "lina van DIJK" → "Lina Van Dijk". Werkt op unicode (é, ï, etc.).
   * Wordt toegepast op pet-naam en eigenaars-voornaam — in admin-flow én
   * bij waarden uit LLM-extractie.
   */
  function titleCaseName(s) {
    if (!s) return "";
    var str = String(s).trim().toLowerCase();
    try {
      return str.replace(/(^|[\s\-'])(\p{L})/gu, function (_, sep, letter) {
        return sep + letter.toUpperCase();
      });
    } catch (e) {
      // Fallback voor browsers zonder \p{L} support (oude Safari/IE)
      return str.replace(/(^|[\s\-'])([a-zà-ÿ])/g, function (_, sep, letter) {
        return sep + letter.toUpperCase();
      });
    }
  }

  // ── NORMALIZERS (match azure-proxy/src/shared/schema.ts) ──────────────
  function normalizePhone(raw) {
    if (!raw) return "";
    return String(raw).replace(/[\s\-()]/g, "");
  }

  // Landenlijst voor de internationale telefoon-selector. NL eerst (default).
  // Vlag-emoji = regional-indicator-symbols (2 chars per vlag).
  var COUNTRIES = [
    { code: "NL", name: "Nederland", dial: "+31", flag: "🇳🇱" },
    { code: "BE", name: "België", dial: "+32", flag: "🇧🇪" },
    { code: "DE", name: "Duitsland", dial: "+49", flag: "🇩🇪" },
    { code: "FR", name: "Frankrijk", dial: "+33", flag: "🇫🇷" },
    { code: "GB", name: "Verenigd Koninkrijk", dial: "+44", flag: "🇬🇧" },
    { code: "LU", name: "Luxemburg", dial: "+352", flag: "🇱🇺" },
    { code: "ES", name: "Spanje", dial: "+34", flag: "🇪🇸" },
    { code: "IT", name: "Italië", dial: "+39", flag: "🇮🇹" },
    { code: "AT", name: "Oostenrijk", dial: "+43", flag: "🇦🇹" },
    { code: "CH", name: "Zwitserland", dial: "+41", flag: "🇨🇭" },
    { code: "PT", name: "Portugal", dial: "+351", flag: "🇵🇹" },
    { code: "PL", name: "Polen", dial: "+48", flag: "🇵🇱" },
    { code: "IE", name: "Ierland", dial: "+353", flag: "🇮🇪" },
    { code: "DK", name: "Denemarken", dial: "+45", flag: "🇩🇰" },
    { code: "SE", name: "Zweden", dial: "+46", flag: "🇸🇪" },
    { code: "NO", name: "Noorwegen", dial: "+47", flag: "🇳🇴" },
    { code: "FI", name: "Finland", dial: "+358", flag: "🇫🇮" },
    { code: "CZ", name: "Tsjechië", dial: "+420", flag: "🇨🇿" },
    { code: "GR", name: "Griekenland", dial: "+30", flag: "🇬🇷" },
    { code: "US", name: "Verenigde Staten", dial: "+1", flag: "🇺🇸" },
    { code: "CA", name: "Canada", dial: "+1", flag: "🇨🇦" },
    { code: "TR", name: "Turkije", dial: "+90", flag: "🇹🇷" },
    { code: "MA", name: "Marokko", dial: "+212", flag: "🇲🇦" },
    { code: "SR", name: "Suriname", dial: "+597", flag: "🇸🇷" },
  ];
  function findCountry(code) {
    for (var i = 0; i < COUNTRIES.length; i++) {
      if (COUNTRIES[i].code === code) return COUNTRIES[i];
    }
    return COUNTRIES[0];
  }
  function normalizeSpecies(raw) {
    var s = String(raw || "")
      .trim()
      .toLowerCase();
    if (s === "hond" || s === "kat" || s === "konijn") return s;
    return null; // 'Anders' wordt in de chat al onderschept
  }
  // Niet-ondersteunde diersoorten — Vetts kan alleen helpen met hond/kat/
  // konijn. Voorheen liep de chat door tot de "Wat voor dier"-vraag voordat
  // de user werd afgewezen, wat zonde was van LLM-tokens en de user-tijd
  // (V2-feedback Sander 2026-05-28). Deze regex matcht expliciete soort-
  // namen in de eerste vraag zodat we direct kunnen rejecten.
  // Bewust GEEN matches op "hond"/"kat"/"konijn" zelf — die zijn ondersteund.
  // Bewust GEEN matches op "dier"/"beestje"/"huisdier" — te algemeen.
  var UNSUPPORTED_SPECIES_RE = new RegExp(
    "\\b(?:" +
      [
        // Vogels
        "parkiet",
        "parkietje",
        "papegaai",
        "kanarie",
        "valkparkiet",
        "kaketoe",
        "ara",
        "lori",
        "loorie",
        "vink",
        "duif",
        "vogel",
        "vogeltje",
        // Reptielen
        "hagedis",
        "leguaan",
        "gekko",
        "bartagaam",
        "agame",
        "schildpad",
        "slang",
        "python",
        "boa",
        "kameleon",
        "reptiel",
        // Knaagdieren / kleine zoogdieren
        "rat",
        "ratje",
        "muis",
        "muisje",
        "hamster",
        "cavia",
        "gerbil",
        "chinchilla",
        "fret",
        "egel",
        // Vissen
        "vis",
        "visje",
        "goudvis",
        "koi",
        "guppy",
        "betta",
        // Vee / grote dieren
        "koe",
        "kalf",
        "stier",
        "paard",
        "pony",
        "ezel",
        "geit",
        "schaap",
        "lam",
        "varken",
        "biggetje",
        "kip",
        "kippetje",
        "haan",
        "kuiken",
        "eend",
        // Exotisch
        "spin",
        "tarantula",
        "schorpioen",
        "kikker",
        "salamander",
      ].join("|") +
      ")\\b",
    "i",
  );
  function detectUnsupportedSpecies(text) {
    if (!text) return null;
    var m = String(text).match(UNSUPPORTED_SPECIES_RE);
    return m ? m[0].toLowerCase() : null;
  }
  // Pet-leeftijd: client vraagt nu om een geheel aantal jaren (0..30). 0 betekent
  // "jonger dan 1 jaar" → server-zijde wordt dat een ApproximativeMonth-datum.
  // Legacy enum-labels (oude theme-cache) worden voor de zekerheid hier ook
  // nog gemapt naar een redelijk getal.
  var LEGACY_AGE_TO_YEARS = {
    "< 1 jaar": 0,
    "1–3 jaar": 2,
    "1-3 jaar": 2,
    "4–7 jaar": 5,
    "4-7 jaar": 5,
    "8–12 jaar": 10,
    "8-12 jaar": 10,
    "13+ jaar": 14,
    "Weet ik niet": 5,
  };
  function normalizeAgeYears(raw) {
    if (raw === null || raw === undefined || raw === "") return null;
    if (typeof raw === "number") {
      if (!isFinite(raw)) return null;
      return Math.max(0, Math.min(30, Math.floor(raw)));
    }
    var s = String(raw).trim();
    if (LEGACY_AGE_TO_YEARS[s] !== undefined) return LEGACY_AGE_TO_YEARS[s];
    var m = s.match(/^(\d{1,2})/);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    if (!isFinite(n)) return null;
    return Math.max(0, Math.min(30, n));
  }
  // Geslacht: chat slaat NL-label op (Reu/Teef/Kater/Poes/Mannetje/Vrouwtje).
  // Backend verwacht "Male" of "Female". Onbekende waardes → null (niet sturen).
  function normalizeSex(raw) {
    if (!raw) return null;
    var s = String(raw).trim().toLowerCase();
    if (
      s === "male" ||
      s === "reu" ||
      s === "kater" ||
      s === "mannetje" ||
      s === "m"
    ) {
      return "Male";
    }
    if (
      s === "female" ||
      s === "teef" ||
      s === "poes" ||
      s === "vrouwtje" ||
      s === "v" ||
      s === "f"
    ) {
      return "Female";
    }
    return null;
  }
  // Klachtduur uit follow-up-antwoord parsen → integer dagen.
  // De LLM-prompt forceert vaste options voor de "duration"-vraag:
  //   "Sinds vandaag" | "Gisteren" | "2 dagen" | "Langer dan 2 dagen"
  // Voor robuustheid (LLM kan afwijken, of user typt vrij) accepteren we ook
  // vrije vormen: "5 dagen", "een week", "2 maanden", etc.
  // Returnt null als we 't echt niet kunnen bepalen.
  function parseDaysFromAnswer(raw) {
    if (!raw) return null;
    var s = String(raw).trim().toLowerCase();
    if (!s) return null;
    // Vaste options uit de duration-LLM-prompt
    if (/^sinds vandaag$|^vandaag$/.test(s)) return 0;
    if (/^gisteren$/.test(s)) return 1;
    // "Langer dan X dagen/weken/maanden" → X + 1 (conservative)
    var langer = s.match(
      /langer dan\s+(\d{1,3})\s*(dag|dagen|week|weken|maand|maanden|jaar)/,
    );
    if (langer) {
      var n = parseInt(langer[1], 10);
      var unit = langer[2];
      var base = unitToDays(unit, n);
      return Math.min(36500, base + 1);
    }
    // "X dag(en)/week/weken/maand(en)/jaar" — pak eerste getal + eenheid
    var m = s.match(/(\d{1,3})\s*(dag|dagen|week|weken|maand|maanden|jaar)/);
    if (m) {
      return Math.min(36500, unitToDays(m[2], parseInt(m[1], 10)));
    }
    // Tekstuele varianten zonder cijfer
    if (/(?:een|1)\s*week/.test(s)) return 7;
    if (/(?:een|1)\s*maand/.test(s)) return 30;
    if (/(?:een|1)\s*jaar/.test(s)) return 365;
    if (/paar dagen/.test(s)) return 3;
    if (/aantal dagen/.test(s)) return 3;
    if (/paar weken/.test(s)) return 14;
    return null;
  }
  function unitToDays(unit, n) {
    if (!isFinite(n) || n < 0) return 0;
    if (unit === "dag" || unit === "dagen") return n;
    if (unit === "week" || unit === "weken") return n * 7;
    if (unit === "maand" || unit === "maanden") return n * 30;
    if (unit === "jaar") return n * 365;
    return n;
  }

  // ═══ ANALYZER ═════════════════════════════════════════════════════════
  var Analyzer = (function () {
    var SYMPTOMS = {
      huid: [
        "krabt",
        "krabben",
        "krab",
        "jeuk",
        "jeukt",
        "jeukend",
        "uitslag",
        "rode plekken",
        "kale plekken",
        "schilfers",
        "haaruitval",
        "bultjes",
        "wondjes",
        "hot spot",
        "likken aan",
        "likt",
        "likken",
        "likt aan",
        "likt veel",
        "bijt zichzelf",
        "bijt aan",
        "haarverlies",
        "kale plek",
        "rode plek",
        "schilfert",
        "vlekken",
        "roos",
        "korst",
        "korstjes",
      ],
      spijsvertering: [
        "braakt",
        "braken",
        "overgeven",
        "overgeeft",
        "kotst",
        "kotsen",
        "diarree",
        "dunne ontlasting",
        "bloed in ontlasting",
        "niet eten",
        "eet niet",
        "weinig eten",
        "veel eten",
        "gewichtsverlies",
        "opgeblazen buik",
        "winderig",
        "gras eten",
        "slijm",
        "misselijk",
        "buikpijn",
        "maagpijn",
        "vermagerd",
        "afgevallen",
      ],
      oren: [
        "schudt met hoofd",
        "hoofdschudden",
        "stinkt uit oor",
        "bruin in oor",
        "oorontsteking",
        "oormijt",
        "schudt zijn hoofd",
        "schudt haar hoofd",
        "hoofd schudden",
        "oor",
        "oren",
        "in zijn oor",
        "in haar oor",
      ],
      ogen: [
        "traant",
        "tranen",
        "rood oog",
        "dik oog",
        "troebel",
        "knijpt oog dicht",
        "uitpuilend",
        "oogontsteking",
        "pus uit oog",
        "dichtgekit",
        "tranend",
      ],
      beweging: [
        "mank",
        "mankt",
        "kreupel",
        "hinkt",
        "pijn",
        "stijf",
        "moeilijk lopen",
        "niet springen",
        "trillend",
        "beweegt minder",
        "poot optrekken",
        "zwelling",
        "loopt raar",
        "loopt mank",
        "trekt met poot",
        "strompelt",
        "niet lopen",
        "tilt poot op",
        "houdt poot omhoog",
        "belast niet",
      ],
      gedrag: [
        "angstig",
        "agressief",
        "onrustig",
        "verstopt zich",
        "huilt",
        "jankt",
        "slaapt veel",
        "sloom",
        "lusteloos",
        "trillen",
        "stress",
        "blaffen",
        "bijten",
        "niet luisteren",
        "bang",
        "piept",
        "piepen",
        "jankend",
        "onrustige",
        "hyperactief",
        "apathisch",
        "geen energie",
        "wil niet spelen",
      ],
      plassen: [
        "plast veel",
        "plast weinig",
        "bloed in urine",
        "onzindelijk",
        "druppelt",
        "plast in huis",
        "drinkt veel",
        "drinkt weinig",
        "veel plassen",
        "veel drinken",
        "kan niet plassen",
        "plas in huis",
      ],
      ademhaling: [
        "hoest",
        "hoesten",
        "niest",
        "niezen",
        "piepend",
        "hijgt",
        "ademnood",
        "rochelt",
        "snurkt",
        "benauwdheid",
        "benauwd",
        "piept bij ademhaling",
        "kucht",
        "kuchen",
      ],
      tanden: [
        "tandvlees",
        "stinkt uit bek",
        "kwijlt",
        "moeite met eten",
        "gebroken tand",
        "tandpijn",
        "kwijlen",
        "slechte adem",
      ],
      algemeen: [
        "koorts",
        "zwelling",
        "bult",
        "knobbel",
        "warmte",
        "gezwollen",
        "letsel",
        "wond",
        "snee",
        "beet",
        "parasieten",
        "vlooien",
        "teken",
        "wormen",
        "teek",
        "vlo",
        "opgezet",
        "verdikking",
      ],
    };
    var LOCATIONS = [
      "oor",
      "oren",
      "oog",
      "ogen",
      "poot",
      "poten",
      "been",
      "benen",
      "buik",
      "rug",
      "kop",
      "hoofd",
      "staart",
      "nek",
      "borst",
      "zij",
      "flank",
      "lies",
      "neus",
      "bek",
      "mond",
      "kaak",
      "tong",
      "nagel",
      "nagels",
      "teen",
      "tenen",
      "heup",
      "schouder",
      "knie",
      "elleboog",
      "keel",
      "huid",
      "vacht",
      "bil",
      "anus",
      "lip",
      "lippen",
    ];
    var LOCATION_PREFIXES = [
      "achter",
      "voor",
      "rechter",
      "linker",
      "onder",
      "boven",
    ];
    var DURATION_PATTERNS = [
      /sinds (gisteren|eergisteren|vanmorgen|vanochtend|vanavond|vannacht)/i,
      /(\d+)\s*(dag|dagen|week|weken|maand|maanden|uur|jaar)/i,
      /een paar dagen/i,
      /al een tijd/i,
      /al lang/i,
      /net begonnen/i,
      /vanochtend|vanmorgen|vanavond|vannacht|vandaag|gisteren/i,
      /vorige week|afgelopen week|deze week/i,
      /steeds erger|wordt erger|erger geworden/i,
      /begon|begonnen|gestart/i,
      /plotseling|ineens|opeens|zomaar/i,
    ];
    var SEVERITY_WORDS = [
      "veel",
      "heel",
      "erg",
      "erger",
      "ergste",
      "constant",
      "continue",
      "continu",
      "steeds",
      "heftig",
      "hevig",
      "vaak",
      "regelmatig",
      "dagelijks",
      "elke dag",
      "hele tijd",
      "niet meer",
      "kan niet",
      "wil niet",
      "weigert",
      "stopt niet",
      "bloed",
      "bloederig",
      "bloeden",
      "pus",
      "etter",
      "koorts",
      "uitgedroogd",
      "bewusteloos",
      "slap",
      "niet reageren",
      "flauwvallen",
      "stuipen",
      "heel erg",
      "verschrikkelijk",
      "flink",
      "behoorlijk",
    ];
    var CONTEXT_PATTERNS = [
      /na (het )?eten/i,
      /voor (het )?eten/i,
      /tijdens (het )?eten/i,
      /na\b.{0,20}(wandel|uitlat|renn|spel|zwem|train|loop|sprint)/i,
      /buiten|binnen|tuin|park|bos|strand/i,
      /ander(e)? (hond|kat|dier)/i,
      /gevochten/i,
      /vaccin|inenting|gevaccineerd|ontvvormd|ontworming/i,
      /medicijn|medicatie|antibiotica|pijnstiller/i,
      /voer|eten|brokken|natvoer|snack|traktatie|nieuw voer/i,
      /gecastreerd|gesteriliseerd|loops|zwanger|drachtig/i,
      /operatie|geopereerd/i,
      /vlo(oien)?|teek|teken|worm|wormen/i,
      /allergi/i,
      /verzekering/i,
      /puppy|kitten|jong|oud|senior/i,
    ];
    var SPOED_WORDS = [
      "spoed",
      "spoedgeval",
      "bloed",
      "bloeden",
      "bloedend",
      "bewusteloos",
      "ademnood",
      "vergiftigd",
      "gif",
      "rattengif",
      "chocolade gegeten",
      "aangereden",
      "stuipen",
      "epilepsie",
      "toeval",
      "flauwvallen",
      "gebroken",
      "open wond",
      "diepe wond",
      "shock",
      "verdronken",
      "opgezwollen",
      "anafylactisch",
      "baarmoederontsteking",
      "draait rondjes",
      "gaat dood",
      "doodgaan",
      "sterft",
      "overleden",
      "levenloos",
      "reageert niet",
      "slap",
      "geen hartslag",
      "kokhalzen zonder braken",
      "opgezette buik",
    ];
    var SPOED_PATTERNS = [
      /ademt?\s+(niet|nauwelijks|amper|heel\s+moeilijk)/i,
      /niet\s+(meer\s+)?(ademen|ademhalen|ademt)/i,
      /kan\s+(niet|geen)\s+(meer\s+)?(ademen|ademhalen|plassen|lopen|staan|bewegen)/i,
      /stopt?\s+(met\s+)?(ademen|ademhalen)/i,
      /gaat\s+(dood|eraan)/i,
      /valt?\s+(om|neer|flauw)/i,
      /reageert?\s+(niet|nergens)/i,
      /beweegt?\s+(niet|niet\s+meer)/i,
      /staat?\s+(niet|niet\s+meer)\s+(op|overeind)/i,
      /eet\s+(al|sinds)\s+\d+\s+dag(en)?\s+(niet|niks)/i,
      /al\s+\d+\s+dag(en)?\s+(niet\s+gegeten|niet\s+gedronken)/i,
      /heel\s+veel\s+bloed/i,
      /heeft?\s+(iets|gif|plastic|bot|speelgoed|sok)\s+(gegeten|ingeslikt|doorgeslikt)/i,
    ];

    function findSymptoms(t) {
      var l = t.toLowerCase(),
        f = [],
        c = new Set();
      for (var cat in SYMPTOMS) {
        var ws = SYMPTOMS[cat];
        for (var i = 0; i < ws.length; i++) {
          if (l.indexOf(ws[i]) !== -1) {
            f.push({ word: ws[i], category: cat });
            c.add(cat);
          }
        }
      }
      return { found: f, categories: Array.from(c) };
    }
    function findLocations(t) {
      var l = t.toLowerCase(),
        f = [];
      for (var i = 0; i < LOCATIONS.length; i++) {
        var loc = LOCATIONS[i];
        if (new RegExp("\\b" + loc + "\\b", "i").test(l)) {
          f.push(loc);
          continue;
        }
        for (var j = 0; j < LOCATION_PREFIXES.length; j++) {
          if (l.indexOf(LOCATION_PREFIXES[j] + loc) !== -1) {
            f.push(LOCATION_PREFIXES[j] + loc);
            break;
          }
        }
      }
      return f;
    }
    function findDuration(t) {
      return DURATION_PATTERNS.reduce(function (a, p) {
        var m = t.match(p);
        if (m) a.push(m[0]);
        return a;
      }, []);
    }
    function findSeverity(t) {
      var l = t.toLowerCase();
      return SEVERITY_WORDS.filter(function (w) {
        return l.indexOf(w) !== -1;
      });
    }
    function findContext(t) {
      return CONTEXT_PATTERNS.reduce(function (a, p) {
        var m = t.match(p);
        if (m) a.push(m[0]);
        return a;
      }, []);
    }
    function checkSpoed(t) {
      var l = t.toLowerCase();
      var f = SPOED_WORDS.filter(function (w) {
        return l.indexOf(w) !== -1;
      });
      for (var i = 0; i < SPOED_PATTERNS.length; i++) {
        var m = l.match(SPOED_PATTERNS[i]);
        if (m) f.push(m[0]);
      }
      return f;
    }
    function score(t) {
      var sy = findSymptoms(t),
        lo = findLocations(t),
        du = findDuration(t),
        se = findSeverity(t),
        co = findContext(t),
        sp = checkSpoed(t);
      var s = {
        symptom: Math.min(2, sy.found.length),
        location: Math.min(2, lo.length),
        duration: Math.min(2, du.length),
        severity: Math.min(2, se.length),
        context: Math.min(2, co.length),
      };
      var tot = s.symptom + s.location + s.duration + s.severity + s.context;
      return {
        scores: s,
        total: tot,
        max: 10,
        percentage: Math.round((tot / 10) * 100),
        details: {
          symptoms: sy,
          locations: lo,
          duration: du,
          severity: se,
          context: co,
          spoed: sp,
        },
        isComplete: tot >= 6,
        isPartial: tot >= 3 && tot < 6,
        isPoor: tot < 3,
        isSpoed: sp.length > 0,
      };
    }
    function getFollowUp(r, pet) {
      var m = [],
        s = r.scores,
        n = pet || "je huisdier";
      if (s.symptom === 0)
        m.push({
          priority: 1,
          question:
            "Kun je beschrijven wat je precies ziet bij " +
            n +
            "? Bijvoorbeeld: krabt, braakt, mank, niet eten, etc.",
        });
      if (s.duration === 0 && s.symptom > 0)
        m.push({
          priority: 2,
          question:
            "Hoe lang speelt dit al bij " +
            n +
            "? Sinds vandaag, gisteren, of langer?",
          options: [
            { label: "Sinds vandaag" },
            { label: "Gisteren" },
            { label: "2 dagen" },
            { label: "Langer dan 2 dagen" },
          ],
        });
      if (s.location === 0 && s.symptom > 0) {
        var c = r.details.symptoms.categories[0];
        if (
          ["spijsvertering", "gedrag", "plassen", "ademhaling"].indexOf(c) ===
          -1
        ) {
          m.push({
            priority: 3,
            question:
              "Waar op het lichaam zie je dit bij " +
              n +
              "? Bijvoorbeeld: oor, poot, buik, rug...",
          });
        }
      }
      if (s.severity === 0 && s.symptom > 0)
        m.push({
          priority: 4,
          question:
            "Hoe erg is het? Heeft " +
            n +
            " er een beetje last van, of juist veel?",
          options: [
            { label: "Een beetje" },
            { label: "Behoorlijk" },
            { label: "Heel erg" },
          ],
        });
      if (s.context === 0 && s.symptom > 0 && s.duration > 0)
        m.push({
          priority: 5,
          question:
            "Is er iets veranderd of gebeurd rond de tijd dat dit begon? Denk aan nieuw voer, een wandeling, contact met andere dieren, medicijnen...",
          options: [
            { label: "Nieuw voer" },
            { label: "Contact met ander dier" },
            { label: "Niks bijzonders" },
            { label: "Iets anders" },
          ],
        });
      m.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return m;
    }
    return { score: score, getFollowUp: getFollowUp };
  })();

  // ═══ CHAT ENGINE ══════════════════════════════════════════════════════
  function createChatEngine(root, config) {
    // Clone de template in de root. De template staat normaal in dezelfde section,
    // MAAR als de overlay/wrap naar <body> is geportaled (voor stacking-context
    // isolatie tegen WhatsApp/Download-app-widgets), is closest() null. Val dan
    // terug op een document-brede query.
    var section =
      root.closest("[data-vh-hero]") ||
      document.querySelector("[data-vh-hero]");
    var template = section
      ? section.querySelector("[data-chat-template]")
      : document.querySelector("[data-chat-template]");
    if (!template) {
      if (window.console)
        console.error(
          "[vetts-hero-chat] template ontbreekt — kan chat niet renderen.",
        );
      return {
        start: function () {
          return Promise.resolve();
        },
      };
    }
    root.innerHTML = "";
    root.appendChild(template.content.cloneNode(true));

    // ── GA4 tracking helpers ─────────────────────────────────────────────
    // `config.vetGA` wordt opgezet in bindSection (zelfde file). Hier maken
    // we een lokale wrapper + idempotent-guard zodat we events nooit per
    // ongeluk dubbel sturen (bv. mobile-engine re-init na minimize, of een
    // step die via meerdere paden afgerond kan worden — prefill-confirm vs
    // gewone invoer).
    var track = config.vetGA || function () {};
    var trackOnceState = {};
    function trackOnce(flagName, eventName, params) {
      if (trackOnceState[flagName]) return;
      trackOnceState[flagName] = true;
      track(eventName, params);
    }

    var msgsEl = root.querySelector(".vh-wmsgs");
    var optsEl = root.querySelector(".vh-wopts");
    var inpEl = root.querySelector(".vh-winp");
    var honeypotEl = root.querySelector("[data-honeypot]");
    var inpRow = root.querySelector(".vh-winp-row");
    // Twee progress-bars in de template: één binnen de avatars-card (classic
    // mode), één onder de messenger-header (messenger mode). We hebben een
    // proxy-object zodat alle bestaande `progBar.style.width = "X%"` calls
    // beide bars updaten zonder dat we ze allemaal hoeven aan te passen.
    var progBars = root.querySelectorAll(".vh-wprog-bar");
    var progBar = {
      style: new Proxy(
        {},
        {
          set: function (_t, prop, val) {
            progBars.forEach(function (el) {
              el.style[prop] = val;
            });
            return true;
          },
        },
      ),
    };
    var completeEl = root.querySelector(".vh-wcomplete");
    var errEl = root.querySelector(".vh-wsubmit-error");
    var errTextEl = root.querySelector("[data-submit-error-text]");
    var retryBtn = root.querySelector("[data-submit-retry]");
    var sndBtn = root.querySelector(".vh-wsnd");
    var attBtn = root.querySelector("[data-attach-btn]");
    var attFileEl = root.querySelector("[data-attach-file]");
    var headerEl = root.querySelector(".vh-wh");
    var waitTimeEl = root.querySelector("[data-wait-time]");
    var smsPhoneEl = root.querySelector("[data-sms-phone]");
    var emerEl = root.querySelector(".vh-wc-emer");
    // SMS-verificatie: notice onder de subtitel + extra stappenplan-stap.
    // Beide standaard verborgen; getoond wanneer de proxy verificationRequired
    // teruggeeft (zie showCompletion).
    var verifyNoticeEl = root.querySelector("[data-verify-notice]");
    var verifyStepEl = root.querySelector("[data-verify-step]");
    // Beschrijving van stap 1 ("Vraag doorgestuurd") — tekst wisselt bij
    // SMS-verificatie, want dan ligt de vraag nog NIET bij de dierenarts.
    var step1DescEl = root.querySelector("[data-step1-desc]");
    var cancelBtn = root.querySelector("[data-cancel-btn]");
    var cancelPane = root.querySelector("[data-cancel-pane]");
    var cancelDone = root.querySelector("[data-cancel-done]");
    var cancelBackBtn = root.querySelector("[data-cancel-back]");
    var cancelReasonBtns = root.querySelectorAll("[data-cancel-reason]");
    // Off-topic FAQ panel (toont 4 collapsibles + restart-knop).
    // Verschijnt wanneer LLM `isOffTopic: true` terugstuurt.
    var faqEl = root.querySelector("[data-faq-panel]");
    var faqRestartBtn = root.querySelector("[data-faq-restart]");

    var st = {};
    var phase = "intro";
    var clarifyCount = 0;
    var allQ = ""; // Letterlijke concat van alle user-input (niet verstuurd)
    var mainQuestion = ""; // De oorspronkelijke klacht zoals de gebruiker die typte → userQuestion
    var qaPairs = []; // Vervolgvragen met antwoord: [{ q, a, dimension }]
    var pendingFollowUp = null; // De vraag die de bot zojuist stelde (nog niet beantwoord)
    var pendingFollowUpDim = null; // Analyzer-dimensie van die vraag: symptom/duration/location/severity/context
    var attachments = []; // [{ name, dataUrl, size }] — bijgevoegde foto's (silent)
    var nonsenseAttempts = 0; // Aantal keer dat user gibberish heeft ingetypt (na 3 sluiten we de case)
    var clarifyAskCount = 0; // Aantal keer dat we om een concrete vraag vroegen (LLM needsClarification)

    // Analyzer priorities → dimensie-naam die vetComposedQuestion gebruikt voor templating
    var PRIORITY_TO_DIMENSION = {
      1: "symptom",
      2: "duration",
      3: "location",
      4: "severity",
      5: "context",
    };
    var adminStep = 0;
    var extraStep = 0; // Index in EXTRA_STEPS — extra medische vragen
    var askedDims = new Set();
    var lastAnalysis = null;
    var sessionId = uuidv4();
    var startedAt = new Date();
    var submitting = false;
    var lastError = null; // Laatste fout-response van de proxy (voor retry-logica)

    // ── V2 (LLM-modus) state ────────────────────────────────────────────
    // mode kan tijdens runtime van 'llm-v2' naar 'regex-v1' switchen als de
    // analyze-call faalt — silent fallback zodat de gebruiker er niks van merkt.
    var mode = config.mode || "regex-v1";
    var llmAnalyzed = false; // is /api/analyze al aangeroepen voor deze sessie?
    var llmExtracted = null; // ExtractedInfo van de LLM (na succes)
    var llmFollowUps = []; // Array van followUp-objects van de LLM
    var llmFollowUpIndex = 0; // Welke vraag we nu stellen
    var confirmStep = null; // Admin-step die we momenteel laten bevestigen
    var confirmLabel = null; // Voorgestelde waarde uit LLM-extractie

    // Vaste extra medische vragen die ALTIJD gesteld worden, ongeacht de
    // vervolgvragen die de LLM/regex-analyzer kiest. Volgorde:
    //   1. Andere klachten (Ja/Nee → open invulveld bij Ja)
    //   2. Medicatie (Ja/Nee → open invulveld bij Ja)
    // Worden tussen de symptoom-vragen en de admin-fase ingebed.
    var EXTRA_STEPS = [
      {
        key: "otherComplaints",
        question: "Zie je nog andere klachten bij je huisdier?",
        followUp: "Geef aan welke andere klachten je nog meer ziet:",
        placeholder: "Bijv. braken, sloom, koorts...",
        prog: 46,
      },
      {
        key: "medication",
        question: "Gebruikt je huisdier op dit moment medicatie?",
        followUp: "Welke medicatie gebruikt je huisdier?",
        placeholder: "Bijv. naam en dosering...",
        prog: 48,
      },
    ];

    var ADMIN_STEPS = [
      {
        key: "petType",
        ask: function () {
          return "Wat voor dier is het?";
        },
        type: "options",
        prog: 55,
        options: [
          { label: "Hond", icon: "🐶" },
          { label: "Kat", icon: "🐱" },
          { label: "Konijn", icon: "🐰" },
          { label: "Anders", icon: "🐾" },
        ],
      },
      {
        key: "petName",
        ask: function () {
          return (
            "Hoe heet je " + (st.petType || "huisdier").toLowerCase() + "?"
          );
        },
        type: "input",
        ph: "Naam...",
        prog: 65,
        validate: function (v) {
          var s = (v || "").trim().toLowerCase();
          if (s.length < 2) return false;
          // Voornaamwoorden zijn geen namen
          var pron = [
            "hij",
            "zij",
            "ze",
            "het",
            "ie",
            "die",
            "deze",
            "hem",
            "haar",
            "hen",
            "mijn",
            "jouw",
            "je",
            "jullie",
            "onze",
            "mij",
            "ik",
            "mn",
          ];
          if (pron.indexOf(s) !== -1) return false;
          return true;
        },
        err: "Vul de echte naam van je huisdier in.",
      },
      {
        key: "petBreed",
        ask: function () {
          // V2-feedback Sander: ras toevoegen, klinisch relevant voor de
          // dierenarts. 'Weet ik niet' als skip-optie zodat onbekende
          // ras-eigenaren niet vastlopen.
          var sp = (st.petType || "huisdier").toLowerCase();
          return "Wat is het ras van je " + sp + "?";
        },
        type: "input_with_skip",
        // Species-aware placeholder (V2-feedback Sander 2026-05-28). Voorheen
        // stond hier "Labrador, Mainecoon..." voor élk diersoort — verwarrend
        // omdat Maine Coon een kattenras is. Per species 2 voorbeeld-rassen.
        ph: function () {
          var sp = (st.petType || "").toLowerCase();
          if (sp === "hond") return "Bijv. Labrador, Teckel...";
          if (sp === "kat") return "Bijv. Maine Coon, Britse Korthaar...";
          if (sp === "konijn") return "Bijv. Hollander, Rex...";
          return "Bijv. ras (of typ 'weet ik niet')";
        },
        skipLabel: "Weet ik niet",
        prog: 68,
        validate: function (v) {
          // Vrije tekst — minimaal 2 chars zodat we typo's vangen, max 60
          // zodat we Mychon's veld niet overflowen.
          var s = (v || "").trim();
          return s.length >= 2 && s.length <= 60;
        },
        err: "Vul een geldig ras in, of klik 'Weet ik niet'.",
      },
      {
        key: "petSex",
        ask: function () {
          // Per Sander (V2 feedback 2026-05-26): universeel mannetje/vrouwtje
          // ipv species-specifieke termen (reu/teef/kater/poes). Houdt
          // copy consistent met de Vetts-app waar dezelfde formulering staat.
          var nm = st.petName || "je huisdier";
          return "Is " + nm + " een mannetje of een vrouwtje?";
        },
        type: "options",
        prog: 72,
        options: [
          {
            label: "Mannetje",
            // Mars-symbool als inline-SVG. Exact gecentreerd in 24×24-viewBox
            // (bbox 4–20 op beide assen → midden op 12,12). Vervangt Unicode ♂
            // dat op iOS scheef uitlijnde.
            iconSvg:
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10" cy="14" r="6"/><line x1="14.3" y1="9.7" x2="20" y2="4"/><polyline points="15,4 20,4 20,9"/></svg>',
          },
          {
            label: "Vrouwtje",
            // Venus-symbool als inline-SVG. Cirkel boven, kruis onder, bbox
            // 6–18 horizontaal en 2.5–21.5 verticaal → midden op 12,12.
            iconSvg:
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8.5" r="6"/><line x1="12" y1="14.5" x2="12" y2="21.5"/><line x1="8.5" y1="18" x2="15.5" y2="18"/></svg>',
          },
        ],
      },
      {
        key: "petNeutered",
        ask: function () {
          // Juiste term per geslacht: mannetje → gecastreerd, vrouwtje →
          // gesteriliseerd. Sex onbekend (LLM-skip mogelijk) → beide termen.
          // st.petSex bevat het NL-label ("Mannetje"/"Vrouwtje"); normalizeSex
          // mapt naar Male/Female.
          var nm = st.petName || "je huisdier";
          var sexC = normalizeSex(st.petSex);
          var term =
            sexC === "Male"
              ? "gecastreerd"
              : sexC === "Female"
                ? "gesteriliseerd"
                : "gecastreerd of gesteriliseerd";
          return "Is " + nm + " " + term + "?";
        },
        type: "options",
        prog: 74,
        // "Weet ik niet" voor adoptie-/asieldieren waar de eigenaar 't niet
        // zeker weet — voorkomt drop-off. Wordt niet meegestuurd (zie buildPayload).
        options: [{ label: "Ja" }, { label: "Nee" }, { label: "Weet ik niet" }],
      },
      {
        key: "petAge",
        ask: function () {
          return (
            "Hoe oud is " +
            (st.petName || "je huisdier") +
            "? Kies jaren of maanden. Weet je het niet precies? Geef dan een inschatting."
          );
        },
        // Eigen UI: getal-veld + Jaar/Maanden-switcher (showAgeUnit). Levert
        // st.petAge = "N jaar" of "N maanden"; buildPayload → ageValue + ageUnit
        // → backend ApproximativeYear/ApproximativeMonth.
        type: "age_unit",
        ph: "Bijv. 3",
        prog: 76,
      },
      {
        key: "ownerName",
        ask: function () {
          return (
            "En hoe heet jij, de huisdierouder van " +
            (st.petName || "je huisdier") +
            "?"
          );
        },
        type: "input",
        ph: "Je voornaam...",
        prog: 83,
        validate: function (v) {
          var s = (v || "").trim().toLowerCase();
          if (s.length < 2) return false;
          var pron = [
            "hij",
            "zij",
            "ze",
            "het",
            "ie",
            "die",
            "deze",
            "hem",
            "haar",
            "hen",
            "mijn",
            "jouw",
            "je",
            "jullie",
            "onze",
            "mij",
            "ik",
            "mn",
          ];
          if (pron.indexOf(s) !== -1) return false;
          return true;
        },
        err: "Vul je voornaam in.",
      },
      {
        key: "phone",
        ask: function () {
          return (
            "Oké " +
            st.ownerName +
            ", op welk nummer kan ik je een SMS sturen als de dierenarts antwoordt?"
          );
        },
        type: "phone_intl",
        ph: "612345678",
        prog: 93,
        // Validatie loopt via showPhoneIntl(): country.dial + lokaal-nummer wordt
        // gecombineerd tot E.164 (+...). Server-schema accepteert die format.
        err: "Vul een geldig telefoonnummer in.",
      },
    ];
    // E-mail wordt NIET meer in de chat gevraagd — die staat in de betaalkaart
    // (onder het totaal) en gaat via billing_details mee naar Stripe.

    function scroll() {
      // Smart-scroll: alleen automatisch naar bottom als user al onderaan
      // zat (binnen 120px). Heeft de user omhoog gescrolled om vorige
      // antwoorden te lezen, dan respecteren we die positie en yanken we
      // 'm NIET terug bij elke nieuwe bot-message. Per V2-feedback Sander
      // 2026-05-26 — voorheen lockte de chat aan bottom waardoor desktop-
      // users niet meer naar boven konden.
      var distanceFromBottom =
        msgsEl.scrollHeight - msgsEl.scrollTop - msgsEl.clientHeight;
      if (distanceFromBottom > 120) return;
      requestAnimationFrame(function () {
        msgsEl.scrollTop = msgsEl.scrollHeight;
      });
    }
    function autoGrow() {
      // Reset eerst zodat scrollHeight de échte content-hoogte is.
      inpEl.style.height = "auto";
      var sh = inpEl.scrollHeight;
      // Een LEGE textarea telt de placeholder niet mee in scrollHeight, waardoor
      // een placeholder die over 2 regels loopt wordt afgekapt. Meet dan de echte
      // placeholder-hoogte door 'm even als waarde te zetten (zet géén 'input'-
      // event af en is synchroon → geen zichtbare flikker).
      if (!inpEl.value && inpEl.placeholder) {
        inpEl.value = inpEl.placeholder;
        inpEl.style.height = "auto";
        sh = Math.max(sh, inpEl.scrollHeight);
        inpEl.value = "";
        inpEl.style.height = "auto";
      }
      var MAX = 110;
      if (sh > MAX) {
        // Lange content: cap op MAX en toon scrollbar zodat user kan scrollen.
        inpEl.style.height = MAX + "px";
        inpEl.style.overflowY = "auto";
      } else {
        // Past binnen max: laat textarea exact passen, geen scrollbar.
        inpEl.style.height = sh + "px";
        inpEl.style.overflowY = "hidden";
      }
      updateCharCounter();
    }
    // Char-counter: laat zien hoeveel chars de user heeft + waarschuwt
    // wanneer hij dichter bij de 2000-cap komt. Counter is hidden tot
    // 85% (1700 chars) zodat 't korte antwoorden niet visueel verstoort.
    // De textarea's eigen `maxlength="2000"` blokt het echt door-typen;
    // deze counter is alleen feedback zodat de user 't aan ziet komen.
    var CHAR_MAX = 2000;
    var CHAR_WARN_AT = 1700; // 85% — counter wordt zichtbaar vanaf hier
    var CHAR_DANGER_AT = 1900; // 95% — oranje
    function updateCharCounter() {
      var counter = root.querySelector("[data-char-count]");
      if (!counter) return;
      var len = (inpEl.value || "").length;
      if (len < CHAR_WARN_AT) {
        counter.classList.remove("visible", "warn", "max");
        counter.textContent = "";
        return;
      }
      counter.textContent = len + " / " + CHAR_MAX;
      counter.classList.add("visible");
      counter.classList.toggle("warn", len >= CHAR_DANGER_AT && len < CHAR_MAX);
      counter.classList.toggle("max", len >= CHAR_MAX);
    }
    function addBot(h) {
      rmTyping();
      var e = document.createElement("div");
      e.className = "vh-msg bot";
      e.textContent = h;
      msgsEl.appendChild(e);
      scroll();
      return e;
    }
    // System-bericht: bv. bevestiging dat een foto is bijgevoegd. Geen bot-
    // bubble (dat is voor inhoudelijke vragen), maar een centrale subtiele regel.
    function addSystemMessage(text) {
      var e = document.createElement("div");
      e.className = "vh-msg-sys";
      e.textContent = text;
      msgsEl.appendChild(e);
      scroll();
    }
    function addUser(t) {
      var e = document.createElement("div");
      e.className = "vh-msg user";
      e.textContent = t;
      msgsEl.appendChild(e);
      scroll();
      // Markeer dat de chat is begonnen — CSS verbergt dan de privacy-footer
      // (Versleuteld · Erkende NL-dierenartsen) want die hoort vooral bij de
      // initial trust-state, niet zodra het gesprek loopt.
      if (!root.classList.contains("vh-chatted")) {
        root.classList.add("vh-chatted");
      }
    }
    function showSpoedBanner() {
      rmTyping();
      var el = document.createElement("div");
      el.className = "vh-spoed-banner";
      // Title-rij: rode icon-tile + tekst naast elkaar (per V2-design Sander
      // 2026-05-26). De tile is een aparte span zodat we 'm los kunnen
      // stylen (rode achtergrond, wit driehoekje, vierkant + iets afgerond).
      var t = document.createElement("div");
      t.className = "vh-spoed-banner-title";
      var icon = document.createElement("span");
      icon.className = "vh-spoed-banner-icon";
      icon.setAttribute("aria-hidden", "true");
      icon.textContent = "⚠";
      var titleText = document.createElement("span");
      titleText.className = "vh-spoed-banner-title-text";
      titleText.textContent = "Mogelijk spoedgeval!";
      t.appendChild(icon);
      t.appendChild(titleText);
      // Body: twee aparte <p>-blokken zodat we de regelafstand tussen
      // paragrafen via CSS-margin gelijk kunnen trekken met de regelafstand
      // bínnen een paragraaf (was met dubbele <br> ongeveer 2× zo groot).
      // De expliciete <br> in zin 1 dwingt "mogelijk een spoedsituatie" naar
      // regel 2 — Sander's design-choice, niet auto-wrappen.
      var p = document.createElement("div");
      p.className = "vh-spoed-banner-text";
      p.innerHTML =
        '<p class="vh-spoed-banner-p">Op basis van je beschrijving lijkt dit<br>mogelijk een spoedsituatie.</p>' +
        '<p class="vh-spoed-banner-p">Neem bij twijfel <strong>direct contact</strong> op met de dichtstbijzijnde dierenkliniek of spoedpost.</p>';
      var disclaimer = document.createElement("div");
      disclaimer.className = "vh-spoed-banner-disclaimer";
      disclaimer.textContent =
        "*VETTS is bedoeld voor niet-spoedeisende vragen.";
      el.appendChild(t);
      el.appendChild(p);
      el.appendChild(disclaimer);
      msgsEl.appendChild(el);
      scroll();
    }
    function showTyping() {
      return new Promise(function (ok) {
        showTypingPersistent();
        setTimeout(
          function () {
            rmTyping();
            ok();
          },
          500 + Math.random() * 400,
        );
      });
    }
    /**
     * Toon typing-dots zonder auto-remove. Caller is verantwoordelijk voor
     * rmTyping() oproepen wanneer klaar (bv. zodra een lange LLM-call
     * teruggekomen is). Gebruikt voor LLM-analyze waar de wachttijd 2-4s is —
     * de standaard showTyping() zou de dots na ~900ms al weghalen waardoor de
     * gebruiker het idee krijgt dat er niks gebeurt.
     */
    function showTypingPersistent() {
      rmTyping();
      var e = document.createElement("div");
      e.className = "vh-typing";
      e.setAttribute("data-typ", "1");
      e.innerHTML = "<span></span><span></span><span></span>";
      msgsEl.appendChild(e);
      scroll();
    }
    function rmTyping() {
      root.querySelectorAll(".vh-typing[data-typ]").forEach(function (e) {
        e.remove();
      });
    }
    function showOpts(options) {
      inpRow.style.display = "none";
      optsEl.innerHTML = "";
      options.forEach(function (o) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "vh-wopt";
        if (o.icon || o.iconSvg) {
          var ic = document.createElement("span");
          ic.className = "vh-oi";
          if (o.iconSvg) {
            // Inline-SVG-variant (geslacht): pixel-identiek op iOS, geen
            // scheve Unicode-glyph-metrics. innerHTML is veilig — bron is
            // hardcoded hieronder, geen user-input.
            ic.classList.add("vh-oi-svg");
            ic.innerHTML = o.iconSvg;
          } else {
            ic.textContent = o.icon;
          }
          b.appendChild(ic);
        }
        var lbl = document.createTextNode(o.label || o);
        b.appendChild(lbl);
        b.onclick = function () {
          optsEl.classList.remove("active");
          handleOption(o.label || o.value || o);
        };
        optsEl.appendChild(b);
      });
      optsEl.classList.add("active");
    }
    function showInput(ph) {
      optsEl.classList.remove("active");
      inpRow.style.display = "flex";
      inpEl.placeholder = ph || "Typ hier...";
      inpEl.value = "";
      inpEl.style.height = "";
      // Groei meteen mee met de (evt. 2-regelige) placeholder — anders valt de
      // 2e regel weg tot de user begint te typen.
      autoGrow();
      setTimeout(function () {
        inpEl.focus();
      }, 80);
    }
    // Combinatie van input + één skip-chip. Gebruikt voor de ras-vraag
    // waar de user óf het ras intypt, óf 'Weet ik niet' aanklikt.
    // Anders dan showOpts/showInput hidet deze NIET de andere — beiden
    // blijven zichtbaar zodat de user kan kiezen.
    function showInputWithSkip(ph, skipLabel) {
      // Input zichtbaar
      inpRow.style.display = "flex";
      inpEl.placeholder = ph || "Typ hier...";
      inpEl.value = "";
      inpEl.style.height = "";
      // Groei meteen mee met de (evt. 2-regelige) placeholder.
      autoGrow();
      // Skip-chip (single option) zichtbaar
      optsEl.innerHTML = "";
      var b = document.createElement("button");
      b.type = "button";
      b.className = "vh-wopt vh-wopt-skip";
      b.textContent = skipLabel || "Weet ik niet";
      b.onclick = function () {
        optsEl.classList.remove("active");
        handleOption(skipLabel || "Weet ik niet");
      };
      optsEl.appendChild(b);
      optsEl.classList.add("active");
      setTimeout(function () {
        inpEl.focus();
      }, 80);
    }
    function hideAll() {
      inpRow.style.display = "none";
      optsEl.classList.remove("active");
      removePhoneIntl();
      removeAgeUnit();
    }

    // ── Telefoon-stap met internationale landcode-selector ─────────────
    // Plaatst een custom UI in de inputrij: [Vlag +Code ▾] [Phone input] [Send].
    // Klikt op de selector toont een dropdown met zoekveld. Default NL (+31).
    var selectedCountry = findCountry("NL");
    var phoneIntlEl = null;

    function removePhoneIntl() {
      if (phoneIntlEl && phoneIntlEl.parentNode) {
        phoneIntlEl.parentNode.removeChild(phoneIntlEl);
      }
      phoneIntlEl = null;
      // Consent-regel hoort bij de telnummer-stap; ruim 'm mee op zodat 'ie
      // niet blijft hangen of dubbel verschijnt bij een retry.
      var oldConsent = msgsEl.querySelector(".vh-consent-msg");
      if (oldConsent && oldConsent.parentNode) {
        oldConsent.parentNode.removeChild(oldConsent);
      }
    }

    function showPhoneIntl(placeholder) {
      // Verberg klassieke input + opts; render eigen blok bovenop input-rij.
      optsEl.classList.remove("active");
      inpRow.style.display = "none";
      removePhoneIntl();

      phoneIntlEl = document.createElement("div");
      phoneIntlEl.className = "vh-wphone";
      phoneIntlEl.innerHTML =
        '<div class="vh-wphone-row">' +
        '  <button type="button" class="vh-wphone-cc" aria-label="Selecteer landcode">' +
        '    <span class="vh-wphone-flag"></span>' +
        '    <span class="vh-wphone-dial"></span>' +
        '    <span class="vh-wphone-chev" aria-hidden="true">▾</span>' +
        "  </button>" +
        '  <input type="tel" class="vh-wphone-input" inputmode="numeric" autocomplete="tel" aria-label="Telefoonnummer">' +
        '  <button type="button" class="vh-wphone-send" aria-label="Verstuur">' +
        '    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '      <line x1="22" y1="2" x2="11" y2="13"/>' +
        '      <polygon points="22 2 15 22 11 13 2 9 22 2"/>' +
        "    </svg>" +
        "  </button>" +
        "</div>" +
        '<div class="vh-wphone-dd" hidden>' +
        '  <input type="text" class="vh-wphone-search" placeholder="Zoek land..." aria-label="Zoek land">' +
        '  <div class="vh-wphone-list" role="listbox"></div>' +
        "</div>";
      // Plaats vlak boven de bestaande input-rij zodat order in DOM logisch is.
      inpRow.parentNode.insertBefore(phoneIntlEl, inpRow);

      // Consent-disclaimer hoort IN het grijze chat-gebied (onder de telnummer-
      // vraag), niet in het witte invoer-blok. De harde <br> forceert exact
      // 2 regels ongeacht schermbreedte. removePhoneIntl ruimt 'm weer op.
      // Links openen in nieuw tabblad; rel="noopener noreferrer" voorkomt
      // window.opener-misbruik door de doelpagina + lekt geen referrer.
      var consentEl = document.createElement("div");
      consentEl.className = "vh-consent-msg";
      consentEl.innerHTML =
        "Met het versturen van je vraag ga je akkoord met<br>onze " +
        '<a href="https://vetts.app/policies/terms-of-service" target="_blank" rel="noopener noreferrer">Algemene Voorwaarden</a>' +
        " en " +
        '<a href="https://vetts.app/policies/privacy-policy" target="_blank" rel="noopener noreferrer">Privacyverklaring</a>.';
      msgsEl.appendChild(consentEl);
      scroll();

      var ccBtn = phoneIntlEl.querySelector(".vh-wphone-cc");
      var flagEl = phoneIntlEl.querySelector(".vh-wphone-flag");
      var dialEl = phoneIntlEl.querySelector(".vh-wphone-dial");
      var phInp = phoneIntlEl.querySelector(".vh-wphone-input");
      var sendBtn = phoneIntlEl.querySelector(".vh-wphone-send");
      var dd = phoneIntlEl.querySelector(".vh-wphone-dd");
      var search = phoneIntlEl.querySelector(".vh-wphone-search");
      var list = phoneIntlEl.querySelector(".vh-wphone-list");

      function renderSelected() {
        flagEl.textContent = selectedCountry.flag;
        dialEl.textContent = selectedCountry.dial;
        phInp.placeholder = placeholder || "612345678";
      }
      function renderList(q) {
        list.innerHTML = "";
        var query = (q || "").trim().toLowerCase();
        COUNTRIES.filter(function (c) {
          if (!query) return true;
          return (
            c.name.toLowerCase().indexOf(query) !== -1 ||
            c.dial.indexOf(query) !== -1 ||
            c.code.toLowerCase().indexOf(query) !== -1
          );
        }).forEach(function (c) {
          var item = document.createElement("button");
          item.type = "button";
          item.className = "vh-wphone-item";
          item.setAttribute("role", "option");
          item.innerHTML =
            '<span class="vh-wphone-flag">' +
            c.flag +
            "</span>" +
            '<span class="vh-wphone-name">' +
            c.name +
            "</span>" +
            '<span class="vh-wphone-dial">' +
            c.dial +
            "</span>";
          item.onclick = function () {
            selectedCountry = c;
            renderSelected();
            dd.hidden = true;
            phInp.focus();
          };
          list.appendChild(item);
        });
      }
      ccBtn.onclick = function () {
        dd.hidden = !dd.hidden;
        if (!dd.hidden) {
          search.value = "";
          renderList("");
          setTimeout(function () {
            search.focus();
          }, 30);
        }
      };
      search.addEventListener("input", function () {
        renderList(search.value);
      });
      sendBtn.onclick = submitPhone;
      phInp.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          submitPhone();
        }
      });

      function submitPhone() {
        if (submitting || phase === "submitting") return;
        var raw = (phInp.value || "").replace(/[\s\-()]/g, "");
        // De landcode staat al náást het veld (selectedCountry.dial). Sommige
        // gebruikers tikken 'm tóch mee in het nummer — als "+31…", "0031…" of
        // kaal "31…". Die strippen we, anders krijg je een dubbele landcode:
        // NL "31651672221" werd "+31" + "31651672221" = "+3131651672221", wat de
        // backend afwees met invalid_phone_number → 500 (Björn 2026-06-10).
        var dialDigits = selectedCountry.dial.replace(/\D/g, "");
        if (raw.charAt(0) === "+") {
          raw = raw.slice(1);
          if (dialDigits && raw.indexOf(dialDigits) === 0)
            raw = raw.slice(dialDigits.length);
        } else if (raw.slice(0, 2) === "00") {
          raw = raw.slice(2);
          if (dialDigits && raw.indexOf(dialDigits) === 0)
            raw = raw.slice(dialDigits.length);
        } else if (
          raw.charAt(0) !== "0" &&
          dialDigits &&
          raw.indexOf(dialDigits) === 0
        ) {
          // Kale landcode zonder + of 0. Alléén strippen als 't NIET met een
          // nationale 0 begint, zodat 0316-achtige nummers niet gemangeld worden.
          raw = raw.slice(dialDigits.length);
        }
        // Nationale leidende 0 — gebruikers tikken vaak "0612345678" bij NL.
        if (raw.charAt(0) === "0") raw = raw.slice(1);
        if (!/^[0-9]{6,14}$/.test(raw)) {
          showTyping().then(function () {
            addBot("Vul een geldig telefoonnummer in (alleen cijfers).");
          });
          return;
        }
        var full = selectedCountry.dial + raw;
        addUser(formatPhoneForDisplay(full));
        st.phone = full;
        removePhoneIntl();
        adminStep++;
        runAdmin();
      }

      renderSelected();
      setTimeout(function () {
        phInp.focus();
      }, 80);
    }

    // ── Leeftijd-stap met Jaar/Maanden-switcher ───────────────────────
    // Getal-veld + eenheid-dropdown + send-knop. Jaren → ApproximativeYear,
    // maanden → ApproximativeMonth (server-zijde). Lost het oude "0 jaar →
    // gegokte 6 maanden"-probleem op: bij < 1 jaar kies je Maanden + exacte
    // waarde. Inline-styled zodat enkel hero-chat.js geüpload hoeft te worden.
    var ageUnitEl = null;
    function removeAgeUnit() {
      if (ageUnitEl && ageUnitEl.parentNode) {
        ageUnitEl.parentNode.removeChild(ageUnitEl);
      }
      ageUnitEl = null;
    }
    function showAgeUnit(placeholder) {
      optsEl.classList.remove("active");
      inpRow.style.display = "none";
      removeAgeUnit();
      var FLD =
        "height:46px;border:1px solid #d8dce0;border-radius:12px;background:#fff;font-size:16px;outline:none;-webkit-appearance:none;appearance:none;";
      ageUnitEl = document.createElement("div");
      ageUnitEl.className = "vh-wage";
      ageUnitEl.style.cssText =
        "display:flex;align-items:center;gap:8px;padding:8px 10px;";
      ageUnitEl.innerHTML =
        '<input type="number" class="vh-wage-num" inputmode="numeric" min="1" max="30" ' +
        'placeholder="' +
        (placeholder || "Bijv. 3") +
        '" aria-label="Leeftijd" style="' +
        FLD +
        'flex:1;min-width:0;padding:0 14px;">' +
        '<select class="vh-wage-unit" aria-label="Eenheid" style="' +
        FLD +
        'padding:0 12px;cursor:pointer;color:#1a1a1a;">' +
        '<option value="year">Jaar</option>' +
        '<option value="month">Maanden</option>' +
        "</select>" +
        '<button type="button" class="vh-wage-send" aria-label="Verstuur" ' +
        'style="flex:none;width:46px;height:46px;border:none;border-radius:50%;background:#00bf63;color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>' +
        "</button>";
      inpRow.parentNode.insertBefore(ageUnitEl, inpRow);

      var numEl = ageUnitEl.querySelector(".vh-wage-num");
      var unitEl = ageUnitEl.querySelector(".vh-wage-unit");
      var sendEl = ageUnitEl.querySelector(".vh-wage-send");

      // Max meebewegen met de eenheid: jaren 1–30, maanden 1–11 (≥12 mnd = Jaar).
      function syncMax() {
        numEl.max = unitEl.value === "month" ? "11" : "30";
      }
      unitEl.addEventListener("change", syncMax);
      syncMax();

      function submitAge() {
        if (submitting || phase === "submitting") return;
        var unit = unitEl.value === "month" ? "month" : "year";
        var n = parseInt(String(numEl.value || "").trim(), 10);
        var max = unit === "month" ? 11 : 30;
        if (!(n >= 1 && n <= max)) {
          showTyping().then(function () {
            addBot(
              unit === "month"
                ? "Vul een aantal maanden in (1 t/m 11). Is " +
                    (st.petName || "je huisdier") +
                    " een jaar of ouder? Kies dan Jaar."
                : "Vul de leeftijd in jaren in (1 t/m 30). Jonger dan 1 jaar? Kies dan Maanden.",
            );
          });
          return;
        }
        var label =
          unit === "month"
            ? n + (n === 1 ? " maand" : " maanden")
            : n + " jaar";
        addUser(label);
        st.petAge = label;
        removeAgeUnit();
        adminStep++;
        runAdmin();
      }
      sendEl.onclick = submitAge;
      numEl.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          submitAge();
        }
      });
      setTimeout(function () {
        numEl.focus();
      }, 80);
    }

    // ── Foto-bijlage (silent attachments) ─────────────────────────────
    // Foto's reizen STIL mee met de uiteindelijke submission. Ze verschijnen
    // NIET als chat-bubbles en zijn GEEN antwoord op vervolgvragen. De user
    // ziet ze in een thumbnail-strip boven de input-rij. Elke keer dat hij op
    // de paperclip klikt kan hij MEER foto's toevoegen (multi-select én
    // herhaaldelijk picken — geen replace).
    var MAX_ATTACH = 4;
    var MAX_ATTACH_BYTES = 4 * 1024 * 1024;

    // Verkort lange bestandsnamen ("Screenshot 2026-05-10 at 23.25.34.png" →
    // "Screenshot ...23.25.34.png").
    function prettyFileName(name) {
      var n = String(name || "Foto");
      if (n.length <= 22) return n;
      var dot = n.lastIndexOf(".");
      var ext = dot > 0 ? n.slice(dot) : "";
      var base = dot > 0 ? n.slice(0, dot) : n;
      if (base.length <= 16) return n;
      return base.slice(0, 10) + "…" + base.slice(-6) + ext;
    }

    // Plaatst een chat-bericht voor een bijgevoegde foto. Het bericht heeft
    // een × om de foto te verwijderen — geen aparte strip onder de chat meer.
    // De `att`-referentie wordt in de closure bewaard zodat we 'm bij click
    // exact kunnen identificeren ook als de array-volgorde verandert.
    function addAttachmentMessage(att) {
      var e = document.createElement("div");
      e.className = "vh-msg-sys vh-msg-sys-att";
      e.innerHTML =
        '<span class="vh-msg-sys-att-text"></span>' +
        '<button type="button" class="vh-msg-sys-att-rm" aria-label="Verwijderen">' +
        '  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '    <line x1="18" y1="6" x2="6" y2="18"/>' +
        '    <line x1="6" y1="6" x2="18" y2="18"/>' +
        "  </svg>" +
        "</button>";
      e.querySelector(".vh-msg-sys-att-text").textContent =
        "📎 Foto bijgevoegd: " + prettyFileName(att.name);
      e.querySelector(".vh-msg-sys-att-rm").onclick = function () {
        var idx = attachments.indexOf(att);
        if (idx >= 0) attachments.splice(idx, 1);
        e.remove();
        updateAttachBadge();
      };
      msgsEl.appendChild(e);
      scroll();
    }

    // Aantal-bijlagen-badge op de paperclip-knop ("📎 (2)") zodat de user
    // ook zonder strip-zicht weet hoeveel foto's hij heeft geselecteerd.
    function updateAttachBadge() {
      if (!attBtn) return;
      var badge = attBtn.querySelector(".vh-watt-badge");
      if (attachments.length === 0) {
        if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
        return;
      }
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "vh-watt-badge";
        attBtn.appendChild(badge);
      }
      badge.textContent = String(attachments.length);
    }

    function handleAttachPick(e) {
      var files =
        e.target && e.target.files
          ? Array.prototype.slice.call(e.target.files)
          : [];
      // Reset value zodat opnieuw dezelfde foto kiezen ook 'change' triggert.
      e.target.value = "";
      if (files.length === 0) return;

      var slotsLeft = MAX_ATTACH - attachments.length;
      if (slotsLeft <= 0) {
        showTyping().then(function () {
          addBot("Je kunt maximaal " + MAX_ATTACH + " foto's meesturen.");
        });
        return;
      }
      if (files.length > slotsLeft) {
        showTyping().then(function () {
          addBot(
            "Maximaal " +
              MAX_ATTACH +
              " foto's. De eerste " +
              slotsLeft +
              " worden toegevoegd, de rest sla ik over.",
          );
        });
        files = files.slice(0, slotsLeft);
      }

      // Verwerk elk bestand sequentieel via FileReader.
      files.forEach(function (file) {
        if (!file) return;
        if (file.size > MAX_ATTACH_BYTES) {
          showTyping().then(function () {
            addBot("Een foto was te groot (max 4 MB) en is overgeslagen.");
          });
          return;
        }
        var reader = new FileReader();
        reader.onload = function () {
          var att = {
            name: file.name || "foto.jpg",
            dataUrl: String(reader.result || ""),
            size: file.size,
          };
          attachments.push(att);
          addAttachmentMessage(att);
          updateAttachBadge();
        };
        reader.readAsDataURL(file);
      });
    }

    if (attBtn && attFileEl) {
      attBtn.addEventListener("click", function () {
        // Foto-knop is altijd actief — foto's reizen silent mee met de
        // uiteindelijke submission. Geen aparte fase-check meer nodig.
        if (attachments.length >= MAX_ATTACH) {
          showTyping().then(function () {
            addBot(
              "Je kunt maximaal " +
                MAX_ATTACH +
                " foto's meesturen. Verwijder er eerst eentje.",
            );
          });
          return;
        }
        attFileEl.click();
      });
      attFileEl.addEventListener("change", handleAttachPick);
    }

    function recordUserInput(text) {
      if (!text) return;
      allQ += (allQ ? " " : "") + text;
      if (pendingFollowUp) {
        // Antwoord op de zojuist gestelde vervolgvraag
        qaPairs.push({
          q: pendingFollowUp,
          a: text,
          dimension: pendingFollowUpDim || "other",
        });
        pendingFollowUp = null;
        pendingFollowUpDim = null;
      } else if (!mainQuestion) {
        // Eerste user-input = hoofdvraag
        mainQuestion = text;
      } else if (qaPairs.length > 0) {
        // Extra tekst na een beantwoorde vraag → plak aan laatste antwoord
        qaPairs[qaPairs.length - 1].a += " " + text;
      } else {
        // Extra tekst zonder pending follow-up → breid hoofdvraag uit
        mainQuestion += " " + text;
      }
    }

    /**
     * Filtert + normaliseert de LLM-follow-ups voordat we ze tonen:
     *  1. Skip vragen over "andere klachten/symptomen/veranderingen/medicatie"
     *     — die stelt EXTRA_STEPS al verplicht met Ja/Nee + open invulveld.
     *     Als de LLM 't toch genereert dubbelt het met onze fixed step.
     *  2. Title-case de pet-naam IN de vraagtekst, zelfs als de LLM 'm
     *     lowercase liet staan ("Hoe lang eet jan al..." → "...eet Jan al...").
     */
    // Herkent of de gebruiker de DUUR al noemde ("sinds gisteren", "al 3 dagen",
    // "vandaag", ...). Gebruikt als deterministisch vangnet zodat we nooit alsnog
    // een duur-vraag stellen, ook niet als de LLM-regel een keer slipt.
    function mentionsDuration(text) {
      var s = String(text || "").toLowerCase();
      return (
        /\bsinds\b/.test(s) ||
        /\b(gisteren|eergisteren|vandaag|vanochtend|vanmorgen|vanmiddag|vannacht)\b/.test(
          s,
        ) ||
        // Bare getal alleen als dagen/uren — "8 weken/maanden" is meestal een
        // LEEFTIJD, geen duur; die vangen we hieronder alleen mét "al/sinds".
        /\d+\s*(uur|uren|dag|dagen)\b/.test(s) ||
        /\b(al|sinds|vanaf)\s+(een|'?n|\d+|paar)\b/.test(s) ||
        /\bpaar\s+(dag|dagen|week|weken)\b/.test(s)
      );
    }

    function sanitizeLlmFollowUps(list, extracted) {
      var BANNED_IDS = [
        "other-symptoms",
        "other_symptoms",
        "medication",
        "medicatie",
      ];
      // Match Nederlandse formuleringen die om "andere klachten/symptomen/
      // veranderingen" vragen, óók als de LLM een vrijere id gaf.
      var BANNED_RE = /(andere|nog)\s+(klacht|symptom|verander)/i;
      var MED_RE = /medicat|medicij|medicament/i;
      var petName =
        extracted && extracted.petName ? titleCaseName(extracted.petName) : "";
      // Duur al in de hoofdvraag genoemd? Dan filteren we een duur-vervolgvraag weg.
      var durationAlreadyGiven = mentionsDuration(mainQuestion);

      var out = [];
      for (var i = 0; i < list.length; i++) {
        var fu = list[i];
        if (!fu || typeof fu.question !== "string") continue;
        var idLower = String(fu.id || "").toLowerCase();
        if (BANNED_IDS.indexOf(idLower) !== -1) continue;
        if (BANNED_RE.test(fu.question)) continue;
        if (MED_RE.test(fu.question)) continue;
        // Deterministisch vangnet: duur staat al in de vraag → nooit alsnog een
        // duur-vraag stellen (ook als de LLM-regel een keer slipt).
        if (
          durationAlreadyGiven &&
          (idLower === "duration" ||
            idLower === "duur" ||
            /hoe ?lang|hoelang|sinds wanneer/i.test(fu.question))
        )
          continue;
        // Title-case pet-naam in de question + placeholder (case-insensitive)
        if (petName) {
          var nameRe = new RegExp("\\b" + escapeRegExp(petName) + "\\b", "gi");
          fu.question = fu.question.replace(nameRe, petName);
          if (typeof fu.placeholder === "string") {
            fu.placeholder = fu.placeholder.replace(nameRe, petName);
          }
        }
        out.push(fu);
      }
      return out;
    }

    function escapeRegExp(s) {
      return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function handleQuestion(text) {
      // Onzin-detectie: alleen op de EERSTE user-input (hoofdvraag). Vervolg-
      // antwoorden mogen kort zijn ("Ja", "Nee", "Matig") en moeten niet als
      // gibberish gemarkeerd worden. We tellen het aantal afwijzingen om na 3
      // pogingen de case af te sluiten ipv de user oneindig te frustreren.
      var isFirstInput = !mainQuestion;
      if (isFirstInput && isGibberish(text)) {
        nonsenseAttempts++;
        if (nonsenseAttempts >= 3) {
          return showTyping().then(function () {
            addBot(
              "We konden geen duidelijke vraag herkennen. Sluit de chat en probeer het later opnieuw met een korte omschrijving van de klacht (bijv. 'Mijn hond krabt al 3 dagen').",
            );
            hideAll();
            progBar.style.width = "100%";
            phase = "rejected";
          });
        }
        return showTyping().then(function () {
          addBot(
            nonsenseAttempts === 1
              ? "Kun je je vraag iets duidelijker omschrijven? Bijvoorbeeld 'Mijn kat eet al 2 dagen niet meer' of 'Mijn hond heeft jeuk'."
              : "Ik kan er nog niks van maken — probeer een korte zin met de klacht en het dier (bv. 'Mijn konijn ademt zwaar').",
          );
          // Reset state alsof de user nog niks gevraagd had
          mainQuestion = "";
          allQ = "";
          showInput("Beschrijf hier je vraag...");
          phase = "question";
        });
      }
      // Vroeg-detectie niet-ondersteunde diersoort (Sander V2 2026-05-28).
      // Voorheen liep de chat door tot de "Wat voor dier"-vraag voordat de
      // user werd afgewezen — zonde van LLM-tokens en user-tijd. Match op
      // expliciete soort-namen ('parkiet', 'hagedis', 'koe', ...) en weiger
      // meteen. NB: alleen op de eerste vraag — bij follow-up-antwoorden
      // mag de user gewoon andere woorden gebruiken.
      if (isFirstInput) {
        var unsupportedTerm = detectUnsupportedSpecies(text);
        if (unsupportedTerm) {
          // We RECORDEN de input niet zodat de chat 'm niet als
          // mainQuestion bewaart — anders zou een latere fallback alsnog
          // submit'en met deze input. We tonen wel de user-bubble (addUser
          // werd al door send() gedaan) en daarna meteen de rejection.
          return rejectUnsupportedSpecies();
        }
      }
      recordUserInput(text);
      // GA4: eerste user-input = funnel-start (chat_started).
      // Desktop en mobile delen hierdoor één meetpunt, los van wanneer
      // de overlay geopend werd. Per Sander's definitieve lijst is
      // chat_started het ENIGE first-message event (geen duplicaten).
      if (isFirstInput) {
        trackOnce("chat_started", "chat_started", {
          mode: mode,
          message_length: (text || "").length,
        });
      }
      // V2: bij de eerste user-input naar /api/analyze; bij fallback of error
      // schakel automatisch naar V1.
      if (mode === "llm-v2" && !llmAnalyzed) {
        return doLlmAnalyzeAndStartFollowUps();
      }
      // V1 (regex) flow
      return handleQuestionRegex();
    }

    /**
     * Vertel de user dat we hun diersoort niet ondersteunen. Zelfde tekst
     * en visuele staat als wanneer ze in de "Wat voor dier"-stap "Anders"
     * kiezen — consistente UX, één rejection-pad.
     */
    function rejectUnsupportedSpecies() {
      phase = "rejected";
      return showTyping().then(function () {
        addBot(
          "Sorry, op dit moment kunnen we je helaas niet helpen met diersoorten anders dan honden, katten en konijnen. We werken eraan om in de toekomst meer diersoorten te ondersteunen!",
        );
        hideAll();
        progBar.style.width = "100%";
      });
    }

    /**
     * Reject voor inappropriate / spam / harm-intent content. LLM detecteert
     * dit via het isInappropriate-veld. Toont een vriendelijke verwijzing
     * naar de Vetts-app zodat de user weet dat we niet hard NEE zeggen
     * tegen áll z'n vragen — alleen deze specifieke kan hier niet
     * (V2 Sander 2026-05-28).
     */
    function rejectInappropriate() {
      phase = "rejected";
      return showTyping().then(function () {
        addBot(
          "Sorry, daar kan ik je op dit moment niet mee helpen. Gebruik de Vetts-app om je vraag direct aan een dierenarts te stellen.",
        );
        hideAll();
        progBar.style.width = "100%";
      });
    }

    /**
     * Off-topic detectie: user stelde een legitieme maar niet-dierenarts
     * vraag ("is dit AI?", "wat kost het?", "hallo"). Tonen we het FAQ-
     * paneel met 4 collapsibles + "Stel een vraag" knop die de chat
     * volledig reset zodat de user opnieuw kan beginnen (V2 Sander 2026-05).
     */
    function rejectOffTopic() {
      phase = "rejected";
      progBar.style.width = "100%";
      rmTyping();
      hideAll();
      // Verberg chat-content (messages), toon FAQ-paneel in z'n plaats.
      msgsEl.style.display = "none";
      // Maak de dierenartsen-card compact (zelfde state als showCompletion),
      // zodat het FAQ-paneel de focus krijgt en de pagina niet onnodig
      // lang oogt.
      if (headerEl) headerEl.classList.add("compact");
      if (faqEl) {
        faqEl.hidden = false;
        faqEl.classList.add("active");
      }
    }

    /**
     * "Stel een vraag" knop in het FAQ-paneel: reset ALLES en herstart
     * de chat alsof de user net binnen is. Idempotent — kan vaker
     * geklikt worden zonder problemen.
     */
    function restartFromFaq() {
      // Verberg FAQ paneel
      if (faqEl) {
        faqEl.classList.remove("active");
        faqEl.hidden = true;
      }
      // Toon messages-area weer
      msgsEl.style.display = "";
      // Wis alle chat-bubbles
      msgsEl.innerHTML = "";
      // Reset alle state-variabelen die de flow drijven
      st = {};
      phase = "intro";
      clarifyCount = 0;
      allQ = "";
      mainQuestion = "";
      qaPairs = [];
      pendingFollowUp = null;
      pendingFollowUpDim = null;
      llmAnalyzed = false;
      llmExtracted = null;
      llmFollowUps = [];
      llmFollowUpIndex = 0;
      extraStep = 0;
      adminStep = 0;
      submitting = false;
      nonsenseAttempts = 0;
      clarifyAskCount = 0;
      lastError = null;
      lastAnalysis = null;
      attachments = [];
      // Reset header-states (compact + chat-started flags) zodat de
      // intro-animaties weer kunnen draaien.
      if (headerEl) headerEl.classList.remove("compact");
      var chatWrap = root.closest(".vh-chat-wrap");
      if (chatWrap) chatWrap.classList.remove("vh-chatted");
      // Reset progress + GA4 once-flags (zodat we niet onterecht denken
      // dat chat_started al verstuurd is in deze nieuwe sessie).
      trackOnceState = {};
      progBar.style.width = "5%";
      // Start van voren af aan.
      start("");
    }

    /**
     * Heuristische detectie van onzin-input (toetsenbord-gestamp,
     * willekeurige tekens) op de eerste vraag. Een ECHTE klacht-omschrijving
     * heeft bijna altijd:
     *  - tenminste 8 zichtbare characters
     *  - tenminste 1 spatie (= meerdere woorden)
     *  - klinkers in de woorden (a/e/i/o/u/y) → "qwertyz" heeft er geen
     *  - geen woord langer dan 18 karakters zonder klinker (typische mash)
     */
    function isGibberish(raw) {
      var s = String(raw || "")
        .trim()
        .toLowerCase();
      if (s.length < 8) return true;
      // Geen enkele klinker → vrijwel zeker gibberish (NL/EN zinnen hebben
      // 30-40% klinkers).
      var vowels = (s.match(/[aeiouy]/g) || []).length;
      var letters = (s.match(/[a-zà-ÿ]/g) || []).length;
      if (letters > 0 && vowels / letters < 0.2) return true;
      // Lange tokens zonder klinker zijn toetsenbord-stamp (bv. "asgwgjueeyu"
      // is ok qua klinkers maar "qwrtypsdfgh" niet).
      var tokens = s.split(/\s+/);
      for (var i = 0; i < tokens.length; i++) {
        var t = tokens[i];
        if (t.length >= 6 && !/[aeiouy]/.test(t)) return true;
        // Tegelijk 4+ identieke karakters op rij ("aaaaaaaa", "zzzzz") = nonsense
        if (/(.)\1{4,}/.test(t)) return true;
      }
      // Geen enkele spatie + > 20 chars → vrijwel zeker mash (echte zinnen
      // hebben woorden).
      if (s.length > 20 && tokens.length < 2) return true;
      return false;
    }

    /**
     * V2-flow: roep analyze-endpoint aan, gebruik returned followUps + extracted.
     * Bij elke fout (config, timeout, rate-limit, schema-fail) val terug op V1.
     *
     * Typing-animatie blijft de hele LLM-call door zichtbaar (showTypingPersistent)
     * zodat de gebruiker niet 2-4s naar een leeg scherm staart.
     */
    function doLlmAnalyzeAndStartFollowUps() {
      st.question = allQ;
      progBar.style.width = "20%";
      showTypingPersistent();
      return submitToAnalyze(mainQuestion || allQ).then(function (res) {
        // BELANGRIJK: GEEN rmTyping hier. De persistent dots blijven staan.
        // addBot() of showSpoedBanner() verwijdert ze straks zelf wanneer ze
        // het eerste bericht renderen. Dat voorkomt de flikker tussen
        // "dots verdwijnen" → "leeg scherm 50ms" → "nieuwe dots".
        if (res && res.ok === true) {
          llmAnalyzed = true;
          llmExtracted = res.extracted || null;
          // Volgorde van rejection-checks (zelfde prioriteit als de LLM-
          // prompt voorschrijft): zwaarste rejection eerst.
          // 1. Inappropriate (seksueel/gewelddadig/spam) → terse rejection
          if (llmExtracted && llmExtracted.isInappropriate) {
            rmTyping();
            return rejectInappropriate();
          }
          // 2. Niet-ondersteunde diersoort → species-specifieke rejection
          //    (vangt wat de client-side regex miste).
          if (llmExtracted && llmExtracted.unsupportedSpecies) {
            rmTyping();
            return rejectUnsupportedSpecies();
          }
          // 3. Off-topic (legitieme maar niet-dierenarts vraag, bv. "is
          //    dit AI?", "wat kost het?") → FAQ-paneel + restart-knop.
          if (llmExtracted && llmExtracted.isOffTopic) {
            return rejectOffTopic();
          }
          // Geen herkenbare klacht/vraag (bv. "2 konijntjes geslacht onbekend"):
          // vraag de gebruiker z'n vraag concreet te formuleren en analyseer
          // opnieuw. Zelfde patroon als de gibberish-heropvraag (reset → nieuwe
          // input = eerste vraag). Max 1× zodat niemand in een lus blijft hangen;
          // daarna gaan we gewoon door met de vervolgvragen.
          if (llmExtracted && llmExtracted.needsClarification) {
            if (clarifyAskCount < 1) {
              // 1e keer: vraag de gebruiker de vraag concreet te formuleren en
              // analyseer opnieuw (reset → nieuwe input = eerste vraag).
              clarifyAskCount++;
              llmAnalyzed = false;
              mainQuestion = "";
              allQ = "";
              rmTyping();
              addBot("Wat is je vraag voor de dierenarts precies?");
              showInput("Beschrijf je vraag voor de dierenarts...");
              phase = "question";
              return;
            }
            // Nog steeds geen duidelijke vraag ná de heropvraag → GEEN generieke/
            // redundante vervolgvragen forceren (leeftijd/soort/andere klachten
            // vragen we straks toch). Sla de vervolgvragen over en ga door.
            llmFollowUps = [];
            llmFollowUpIndex = 0;
            progBar.style.width = "30%";
            return new Promise(function (resolve) {
              setTimeout(
                function () {
                  addBot(
                    "Dank je. Ik stel je nog een paar korte vragen om de dierenarts goed te informeren.",
                  );
                  resolve(askNextLlmFollowUp());
                },
                500 + Math.random() * 200,
              );
            });
          }
          // Pet-naam title-casen — LLM levert soms "jan" terwijl user "jan"
          // typte; downstream questions zien er dan netter uit.
          if (llmExtracted && llmExtracted.petName) {
            llmExtracted.petName = titleCaseName(llmExtracted.petName);
          }
          if (llmExtracted && llmExtracted.ownerFirstName) {
            llmExtracted.ownerFirstName = titleCaseName(
              llmExtracted.ownerFirstName,
            );
          }
          llmFollowUps = sanitizeLlmFollowUps(
            Array.isArray(res.followUps) ? res.followUps : [],
            llmExtracted,
          );
          llmFollowUpIndex = 0;
          progBar.style.width = "30%";

          // Korte pauze (500-700ms) terwijl typing-dots blijven, dan in één
          // tick: spoed-banner (indien nodig) + intro-bericht. Daarna direct
          // door naar de eerste vervolgvraag.
          return new Promise(function (resolve) {
            setTimeout(
              function () {
                if (
                  llmExtracted &&
                  llmExtracted.isPotentialEmergency &&
                  !st.spoed
                ) {
                  st.spoed = true;
                  showSpoedBanner(); // verwijdert intern rmTyping
                }
                addBot(
                  "Dank je. Ik stel je nog drie korte vragen om de dierenarts goed te informeren.",
                ); // verwijdert intern rmTyping
                resolve(askNextLlmFollowUp());
              },
              500 + Math.random() * 200,
            );
          });
        }
        // Fallback regex-v1 — silent voor de gebruiker
        rmTyping();
        if (window.console)
          console.warn(
            "[vetts-chat] analyze fallback:",
            (res && res.reason) || "unknown",
          );
        mode = "regex-v1";
        llmAnalyzed = true;
        return handleQuestionRegex();
      });
    }

    function askNextLlmFollowUp() {
      if (llmFollowUpIndex >= llmFollowUps.length) {
        // Alle 3 vragen beantwoord → extra-fase in (vóór admin)
        // GA4: dit is het moment waarop de symptomen-uitvraag (LLM
        // follow-ups) is afgerond. Sander's funnel.
        trackOnce("question_symptoms_answered", "question_symptoms_answered", {
          follow_ups_count: llmFollowUps.length,
        });
        extraStep = 0;
        return runExtra();
      }
      var fu = llmFollowUps[llmFollowUpIndex];
      pendingFollowUp = fu.question;
      pendingFollowUpDim = fu.id || "other";
      var prog = 30 + (llmFollowUpIndex + 1) * 5;
      progBar.style.width = prog + "%";
      return showTyping().then(function () {
        addBot(fu.question);
        if (fu.type === "options" && Array.isArray(fu.options)) {
          showOpts(
            fu.options.map(function (o) {
              return { label: o };
            }),
          );
          phase = "llm_fu_options";
        } else {
          showInput(fu.placeholder || "Typ hier...");
          phase = "llm_fu_text";
        }
      });
    }

    /**
     * V1 / fallback: regex-analyzer beslist of meer vervolgvragen of admin-fase.
     */
    function handleQuestionRegex() {
      var result = Analyzer.score(allQ);
      lastAnalysis = result;
      if (result.isSpoed && !st.spoed) {
        st.spoed = true;
        showSpoedBanner();
      }
      if (result.isComplete || clarifyCount >= 2) {
        st.question = allQ;
        progBar.style.width = "45%";
        extraStep = 0;
        return runExtra();
      }
      var fus = Analyzer.getFollowUp(result).filter(function (f) {
        return !askedDims.has(f.priority);
      });
      if (fus.length > 0) {
        clarifyCount++;
        var fu = fus[0];
        askedDims.add(fu.priority);
        pendingFollowUp = fu.question;
        pendingFollowUpDim = PRIORITY_TO_DIMENSION[fu.priority] || "other";
        return showTyping().then(function () {
          addBot(fu.question);
          if (fu.options) {
            showOpts(fu.options);
            phase = "clarify_option";
          } else {
            showInput("Typ hier...");
            phase = "clarify";
          }
        });
      }
      st.question = allQ;
      progBar.style.width = "45%";
      extraStep = 0;
      return runExtra();
    }

    /**
     * Extra medische vragen die ALTIJD gesteld worden tussen de symptoom-
     * vervolgvragen en de admin-fase. Per stap:
     *   1. Ja/Nee-knoppen → bij "Ja" een open invulveld, bij "Nee" door naar volgende.
     * Antwoorden worden als qaPair opgeslagen (q = vraag, a = antwoord)
     * zodat ze in vetComposedQuestion en followUps meegaan naar de dierenarts.
     */
    function runExtra() {
      // GA4: per-step events vuren wanneer we KLAAR zijn met een EXTRA_STEP
      // (dus extraStep wijst nu naar de VOLGENDE; de voorgaande was net
      // beantwoord). EXTRA_STEPS[1] = medication-step.
      if (extraStep === 2) {
        // medication-step (index 1) is zojuist beantwoord
        trackOnce(
          "question_medication_answered",
          "question_medication_answered",
        );
      }
      if (extraStep >= EXTRA_STEPS.length) {
        // Alle extra-vragen klaar → admin-fase in
        // GA4: medische klacht-uitvraag is volledig afgerond (LLM-followups
        // + andere-klachten + medicatie). Vanaf hier vragen we PII (pet/owner).
        trackOnce("question_problem_finished", "question_problem_finished");
        progBar.style.width = "50%";
        return showTyping().then(function () {
          addBot(
            "Helder. Nog een paar gegevens om je vraag bij de juiste dierenarts te krijgen.",
          );
          phase = "admin";
          adminStep = 0;
          runAdmin();
        });
      }
      var step = EXTRA_STEPS[extraStep];
      progBar.style.width = step.prog + "%";
      pendingFollowUp = step.question;
      pendingFollowUpDim = step.key;
      return showTyping().then(function () {
        addBot(step.question);
        showOpts([{ label: "Ja" }, { label: "Nee" }]);
        phase = "extra_options";
      });
    }

    function runAdmin() {
      // GA4: vuur event voor de zojuist-afgeronde admin-step.
      // adminStep wijst nu naar de VOLGENDE; ADMIN_STEPS[adminStep-1] is wat
      // er net is afgemaakt. STRICT alleen Sander's lijst:
      //   petName → petAge → ownerName → phone
      // Per opdrachtgever-feedback wordt nu de VOLLEDIGE admin-uitvraag getrackt
      // (incl. diersoort, ras, geslacht en gecastreerd/gesteriliseerd).
      if (adminStep > 0) {
        var prevKey =
          ADMIN_STEPS[adminStep - 1] && ADMIN_STEPS[adminStep - 1].key;
        var stepEventMap = {
          petType: "question_pet_species_answered",
          petName: "question_pet_name_answered",
          petBreed: "question_pet_breed_answered",
          petSex: "question_pet_sex_answered",
          petNeutered: "question_pet_neutered_answered",
          petAge: "question_pet_age_answered",
          ownerName: "question_owner_name_answered",
          phone: "question_phone_number_answered",
        };
        var evName = stepEventMap[prevKey];
        if (evName) trackOnce(evName, evName);
      }
      if (adminStep >= ADMIN_STEPS.length) {
        // v2_payment: na de laatste stap eerst betalen (als payment aanstaat).
        // De intake gaat pas door ná een geslaagde, server-geverifieerde betaling.
        if (
          config.paymentEnabled &&
          config.createPaymentUrl &&
          config.submitPaidUrl
        ) {
          startPayment();
        } else {
          finish();
        }
        return;
      }
      var step = ADMIN_STEPS[adminStep];

      // V2: confirmation-step als de LLM al een waarde heeft geëxtraheerd voor deze step
      var preLabel = getPrefilledLabelForStep(step.key);
      if (
        preLabel &&
        !st["__confirmed:" + step.key] &&
        !st["__rejected:" + step.key]
      ) {
        progBar.style.width = step.prog + "%";
        phase = "admin_confirm";
        confirmStep = step;
        confirmLabel = preLabel;
        showTyping().then(function () {
          addBot(buildConfirmQuestion(step.key, preLabel));
          showOpts([{ label: "Ja, klopt" }, { label: "Nee, anders" }]);
        });
        return;
      }

      // Normale step (V1, of V2 zonder/geweigerde prefill)
      progBar.style.width = step.prog + "%";
      showTyping().then(function () {
        var msg = typeof step.ask === "function" ? step.ask() : step.ask;
        addBot(msg);
        if (step.type === "options") {
          // Steps mogen óf een statische `options`-array hebben, óf een
          // `optionsBuilder`-functie die ze runtime opbouwt op basis van
          // eerdere antwoorden (bijv. species-afhankelijke geslacht-labels).
          var opts = step.options;
          if (!opts && typeof step.optionsBuilder === "function") {
            opts = step.optionsBuilder();
          }
          showOpts(opts || []);
        } else if (step.type === "input_with_skip") {
          // Input + skip-chip naast elkaar. Gebruiker mag typen óf op
          // de skip-knop klikken (bv. 'Weet ik niet' bij de ras-vraag).
          // step.ph mag een string OF een function zijn — als function
          // wordt 'ie hier uitgevoerd zodat de placeholder species-aware
          // kan zijn (Sander V2 2026-05-28: bv. petBreed verschillende
          // suggesties per dier).
          var phSkip = typeof step.ph === "function" ? step.ph() : step.ph;
          showInputWithSkip(phSkip, step.skipLabel || "Weet ik niet");
        } else if (step.type === "phone_intl") {
          var phPhone = typeof step.ph === "function" ? step.ph() : step.ph;
          showPhoneIntl(phPhone);
        } else if (step.type === "age_unit") {
          var phAge = typeof step.ph === "function" ? step.ph() : step.ph;
          showAgeUnit(phAge);
        } else {
          var phInput = typeof step.ph === "function" ? step.ph() : step.ph;
          showInput(phInput);
        }
      });
    }

    /**
     * Mapt een admin-step.key op de bijbehorende waarde uit llmExtracted.
     * Returnt null als er niks is om te bevestigen.
     */
    function getPrefilledLabelForStep(stepKey) {
      if (!llmExtracted) return null;
      switch (stepKey) {
        case "petType":
          if (!llmExtracted.petSpecies) return null;
          return (
            llmExtracted.petSpecies.charAt(0).toUpperCase() +
            llmExtracted.petSpecies.slice(1)
          );
        case "petName":
          // Veiligheidscheck: weiger pronoun-achtige extraction (mocht LLM
          // toch een keer falen). Anders title-case de naam.
          return safeName(llmExtracted.petName);
        case "petSex":
          // LLM mag "Male"/"Female" extracten uit "mijn teefje" / "haar
          // kater" etc. We tonen universele NL-labels (Mannetje/Vrouwtje)
          // — consistent met de app, per V2-feedback Sander 2026-05-26.
          if (!llmExtracted.petSex) return null;
          if (llmExtracted.petSex === "Male") return "Mannetje";
          if (llmExtracted.petSex === "Female") return "Vrouwtje";
          return null;
        case "petAge":
          // LLM extraheert een petAgeRange-enum. Jaar-ranges → "N jaar" (de user
          // kan 't bevestigen). lt1y → GEEN prefill: dan vraagt de switcher de
          // exacte maanden (we weten de maand anders niet → giswerk vermijden).
          var ageYearsMap = {
            "1-3y": 2,
            "4-7y": 5,
            "8-12y": 10,
            "13plus": 14,
          };
          if (!llmExtracted.petAgeRange) return null;
          if (llmExtracted.petAgeRange === "lt1y") return null;
          var y = ageYearsMap[llmExtracted.petAgeRange];
          return y === undefined ? null : y + " jaar";
        case "ownerName":
          return safeName(llmExtracted.ownerFirstName);
        default:
          return null;
      }
    }

    /**
     * Extra defensieve laag: als de LLM tóch ondanks de prompt een
     * pronoun/algemeen woord teruggeeft, weigeren we 'm hier en doen we
     * alsof niks geëxtraheerd is. Anders returnen we de title-cased versie.
     */
    function safeName(raw) {
      if (!raw) return null;
      var s = String(raw).trim();
      if (s.length < 2) return null;
      var pron = [
        "hij",
        "zij",
        "ze",
        "het",
        "ie",
        "die",
        "deze",
        "hem",
        "haar",
        "hen",
        "mijn",
        "jouw",
        "je",
        "jullie",
        "onze",
        "mij",
        "ik",
        "mn",
        "dier",
        "beestje",
        "huisdier",
        "maatje",
      ];
      if (pron.indexOf(s.toLowerCase()) !== -1) return null;
      return titleCaseName(s);
    }

    function buildConfirmQuestion(stepKey, label) {
      switch (stepKey) {
        case "petType":
          return (
            "Klopt het dat je vraag om je " + label.toLowerCase() + " gaat?"
          );
        case "petName": {
          var sp = (st.petType || "huisdier").toLowerCase();
          return "Heet je " + sp + ' "' + label + '"?';
        }
        case "petAge": {
          var nm = st.petName || "je huisdier";
          var yrs = parseInt(label, 10);
          if (yrs === 0) return "Is " + nm + " jonger dan 1 jaar?";
          return "Is " + nm + " ongeveer " + yrs + " jaar oud?";
        }
        case "petSex": {
          var nm2 = st.petName || "je huisdier";
          return "Is " + nm2 + " een " + label.toLowerCase() + "?";
        }
        case "ownerName":
          return 'Mag ik je "' + label + '" noemen?';
        default:
          return "Klopt: " + label + "?";
      }
    }

    function handleOption(value) {
      addUser(value);

      // V2 follow-up beantwoord via knop
      if (phase === "llm_fu_options") {
        recordUserInput(value); // pendingFollowUp staat al, qaPair wordt opgeslagen
        llmFollowUpIndex++;
        askNextLlmFollowUp();
        return;
      }

      // Extra-fase: gebruiker beantwoordt Ja/Nee op vaste medische vraag
      if (phase === "extra_options") {
        var stepEx = EXTRA_STEPS[extraStep];
        recordUserInput(value); // sla Ja/Nee op als qaPair
        if (value === "Ja") {
          // Open invulveld voor toelichting; bij submit van de tekst gaat
          // recordUserInput de tekst aan het laatste qaPair plakken.
          pendingFollowUp = stepEx.followUp;
          pendingFollowUpDim = stepEx.key + "Detail";
          showTyping().then(function () {
            addBot(stepEx.followUp);
            showInput(stepEx.placeholder || "Typ hier...");
            phase = "extra_text";
          });
          return;
        }
        // "Nee" → direct door naar volgende extra-stap
        extraStep++;
        runExtra();
        return;
      }

      // V2 confirmation: gebruiker zegt Ja of Nee op een prefilled-step
      if (phase === "admin_confirm" && confirmStep) {
        if (value === "Ja, klopt") {
          // PetType moet "Anders" niet zijn (het LLM extraheert alleen hond/kat/konijn)
          // dus we gaan veilig door
          if (confirmStep.key === "petType") {
            // We slaan label op (Hond/Kat/Konijn) zodat normalizeSpecies het herkent
            st[confirmStep.key] = confirmLabel;
          } else {
            st[confirmStep.key] = confirmLabel;
          }
          st["__confirmed:" + confirmStep.key] = true;
          var doneStep = confirmStep;
          confirmStep = null;
          confirmLabel = null;
          phase = "admin";
          adminStep++;
          runAdmin();
          return;
        }
        // "Nee, anders" → markeer als rejected en herloop deze step zonder prefill
        st["__rejected:" + confirmStep.key] = true;
        confirmStep = null;
        confirmLabel = null;
        phase = "admin";
        runAdmin();
        return;
      }

      if (phase === "clarify_option") {
        if (value === "Iets anders") {
          showInput("Vertel...");
          phase = "clarify";
          return;
        }
        phase = "question";
        handleQuestion(value); // recordUserInput binnenin verwerkt pendingFollowUp
        return;
      }
      var step = ADMIN_STEPS[adminStep];
      if (step.key === "petType" && value === "Anders") {
        rejectUnsupportedSpecies();
        return;
      }
      st[step.key] = value;
      adminStep++;
      runAdmin();
    }

    // Natuurlijke zinnen per dimensie. Missende dimensies worden simpelweg weggelaten.
    // Elk template geeft een zin terug zonder eindpunt (wordt door join geplakt).
    var VET_COMPOSE_TEMPLATES = {
      duration: function (a) {
        return "Dit houdt al aan voor " + a.toLowerCase();
      },
      location: function (a) {
        return "het speelt zich af ter hoogte van " + a.toLowerCase();
      },
      severity: function (a) {
        return "de ernst wordt ingeschat als " + a.toLowerCase();
      },
      symptom: function (a) {
        return "specifiek te zien: " + a.toLowerCase();
      },
      context: function (a) {
        return "context/aanleiding: " + a.toLowerCase();
      },
    };

    function buildVetComposedQuestion() {
      var main = (mainQuestion || "").trim();
      if (qaPairs.length === 0) return main;

      // Vaste volgorde zodat de alinea natuurlijk loopt ongeacht de volgorde
      // waarin de chat-assistent de vragen stelde.
      var order = ["duration", "location", "severity", "symptom", "context"];
      var clauses = [];
      order.forEach(function (dim) {
        var pair = qaPairs.find(function (p) {
          return p.dimension === dim;
        });
        if (pair && VET_COMPOSE_TEMPLATES[dim]) {
          clauses.push(VET_COMPOSE_TEMPLATES[dim](pair.a));
        }
      });
      // Dimensies zonder template (bv. 'other') → toch meenemen als Q&A
      qaPairs.forEach(function (p) {
        if (!VET_COMPOSE_TEMPLATES[p.dimension]) {
          clauses.push(p.q + " " + p.a.toLowerCase());
        }
      });

      if (clauses.length === 0) return main;

      // "Clause1, clause2 en clause3." — Nederlands joining-ritueel
      var joined;
      if (clauses.length === 1) {
        joined = clauses[0];
      } else {
        joined =
          clauses.slice(0, -1).join(", ") +
          " en " +
          clauses[clauses.length - 1];
      }
      // Eerste letter hoofdletter
      joined = joined.charAt(0).toUpperCase() + joined.slice(1) + ".";
      return main + "\n\n" + joined;
    }

    function buildFollowUps() {
      // Dimension is alleen client-side metadata voor buildVetComposed — niet meesturen.
      // Cap 2000 chars per veld (gelijk aan userQuestion-limit). Voorheen was
      // dit 500, waardoor lange follow-up-antwoorden stil werden afgekapt —
      // zie Sander's bug 2026-05-28. Symmetrisch met de hoofdvraag is
      // intuïtiever en geeft de user ruimte om uit te wijden.
      return qaPairs.map(function (p) {
        var q = (p.q || "").toString().slice(0, 2000);
        var a = (p.a || "").toString().slice(0, 2000);
        return { question: q, answer: a };
      });
    }

    function buildAnalysis() {
      // Vrije metadata-bag. Nu: client-regex-analyzer output. Later: Claude output.
      // Backend behandelt de inhoud als opaak.
      var a = lastAnalysis || Analyzer.score(st.question || "");
      return {
        source: "client-regex-v1",
        score: a.total,
        scoreBreakdown: {
          symptom: a.scores.symptom,
          location: a.scores.location,
          duration: a.scores.duration,
          severity: a.scores.severity,
          context: a.scores.context,
        },
        categories: a.details.symptoms.categories,
        locations: a.details.locations,
        durationMatches: a.details.duration,
        severityMatches: a.details.severity,
        contextMatches: a.details.context,
        isPotentialEmergency: a.isSpoed,
        emergencyTriggers: a.details.spoed,
      };
    }

    // Leeftijd-antwoord (st.petAge) → backend-velden. Nieuw: "N maanden"/"N jaar"
    // → { ageValue, ageUnit }. Legacy (kaal getal / oude range via stash/resume)
    // → jaren; 0 = <1 jr → 6 maanden-benadering (oude gedrag). Het object wordt
    // in `pet` gemerged.
    function ageFieldsFor(raw) {
      var s = String(raw || "")
        .trim()
        .toLowerCase();
      var mm = s.match(/(\d{1,2})\s*maand/);
      if (mm) return { ageValue: parseInt(mm[1], 10), ageUnit: "month" };
      var yy = s.match(/(\d{1,2})\s*jaar/);
      if (yy) return { ageValue: parseInt(yy[1], 10), ageUnit: "year" };
      var ny = normalizeAgeYears(raw);
      if (ny === 0) return { ageValue: 6, ageUnit: "month" };
      if (typeof ny === "number" && !isNaN(ny)) {
        return { ageValue: ny, ageUnit: "year" };
      }
      return { ageYears: 5 }; // ultieme fallback (refine vereist een leeftijd)
    }

    function buildPayload() {
      var submittedAt = new Date();
      var durationSec = Math.max(
        0,
        Math.round((submittedAt.getTime() - startedAt.getTime()) / 1000),
      );
      // Question-payload bouwen: attachments alleen toevoegen als er ECHT
      // foto's bij zitten. De gedeployde proxy is strict over unknown keys, dus
      // een leeg attachments-array op een oude server-schema = VALIDATION_FAILED.
      var questionPayload = {
        userQuestion: (mainQuestion || "").trim(),
        vetComposedQuestion: buildVetComposedQuestion(),
        followUps: buildFollowUps(),
        analysis: buildAnalysis(),
      };
      if (attachments.length > 0) {
        questionPayload.attachments = attachments.map(function (a) {
          return { name: a.name, dataUrl: a.dataUrl, size: a.size };
        });
      }
      // Sterilisatie/castratie: meesturen als extra vraag voor de dierenarts
      // via het follow-up-kanaal (conversation.followupQuestions) — het
      // bevestigde, gegarandeerd-zichtbare kanaal. De backend heeft (nog) geen
      // bevestigd structured veld hiervoor; zodra Mychon dat aanlevert kunnen
      // we 't óók als pet.<veld> sturen. "Weet ik niet" laten we weg. Guard op
      // <10 omdat de proxy max 10 follow-ups accepteert (anders VALIDATION_FAILED).
      var neuterAnswer = (st.petNeutered || "").trim();
      if (
        neuterAnswer &&
        neuterAnswer.toLowerCase() !== "weet ik niet" &&
        questionPayload.followUps.length < 10
      ) {
        var neuterSex = normalizeSex(st.petSex);
        var neuterTerm =
          neuterSex === "Male"
            ? "gecastreerd"
            : neuterSex === "Female"
              ? "gesteriliseerd"
              : "gecastreerd/gesteriliseerd";
        questionPayload.followUps.push({
          question:
            "Is " + (st.petName || "het huisdier") + " " + neuterTerm + "?",
          answer: neuterAnswer,
        });
      }
      // daysProblemActive: pak antwoord op de duration-follow-up (LLM-prompt
      // forceert vaste options "Sinds vandaag/Gisteren/2 dagen/Langer dan 2
      // dagen"). Fallback: scan ANY qaPair waarvan de q-tekst klinkt als duur.
      // We sturen alleen mee als parseDays een geldige int oplevert — anders
      // niets sturen i.p.v. een gegokte 0.
      var durationPair = qaPairs.find(function (p) {
        return p.dimension === "duration";
      });
      if (!durationPair) {
        durationPair = qaPairs.find(function (p) {
          var q = (p.q || "").toLowerCase();
          return /hoe ?lang|sinds wanneer|sinds hoe lang|al hoe lang/.test(q);
        });
      }
      if (durationPair) {
        var days = parseDaysFromAnswer(durationPair.a);
        if (days !== null && days !== undefined) {
          questionPayload.daysProblemActive = Math.max(
            0,
            Math.min(36500, days),
          );
        }
      }
      var sexCanonical = normalizeSex(st.petSex);
      // petBreed: 'Weet ik niet' = skip-knop → niet sturen. Vrije tekst
      // → trim + cap. Lege of skip-waardes laten we eruit zodat Mychon
      // 't als 'onbekend' behandelt (veld is optional in zijn spec).
      var breedRaw = (st.petBreed || "").trim();
      var breedCanonical =
        breedRaw &&
        breedRaw.toLowerCase() !== "weet ik niet" &&
        breedRaw.toLowerCase() !== "onbekend"
          ? breedRaw.slice(0, 60)
          : null;
      return {
        owner: Object.assign(
          {
            firstName: (st.ownerName || "").trim(),
            phone: normalizePhone(st.phone),
          },
          // E-mail meesturen als verzameld (verplicht in de betaalflow). Leeg →
          // weglaten zodat de optionele server-validatie ook de non-payment-
          // /api/chat-fallback accepteert.
          (st.email || "").trim()
            ? { email: (st.email || "").trim().slice(0, 120) }
            : {},
        ),
        pet: Object.assign(
          {
            species: normalizeSpecies(st.petType),
            name: (st.petName || "").trim(),
          },
          // Leeftijd: nieuwe switcher → { ageValue, ageUnit }, met legacy-fallback.
          ageFieldsFor(st.petAge),
          // sex alleen toevoegen als we 'm valide hebben — anders weet de
          // proxy dat we 't niet weten en stuurt 't ook niet door naar Mychon.
          sexCanonical ? { sex: sexCanonical } : {},
          breedCanonical ? { breed: breedCanonical } : {},
        ),
        question: questionPayload,
        session: {
          id: sessionId,
          startedAt: startedAt.toISOString(),
          submittedAt: submittedAt.toISOString(),
          durationSeconds: durationSec,
          source: config.source || "vetts.app",
          referrer: (document.referrer || "").slice(0, 500),
          userAgent: (navigator.userAgent || "").slice(0, 500),
          locale: (navigator.language || "").slice(0, 10),
        },
        // Appec/Mychon-omgeving: het schuifje (Dev/Prod) bepaalt of de proxy de
        // intake naar dev- of prod-Mychon doorzet. Reist mee met de intake zodat
        // de webhook (ná betaling) die keuze óók kent.
        target: config.env === "prod" ? "prod" : "dev",
        antiAbuse: { honeypot: honeypotEl ? honeypotEl.value : "" },
      };
    }

    /**
     * V2: roep /api/analyze aan om uit de eerste vraag info te extraheren +
     * 3 vervolgvragen op te halen. Returnt altijd een object met `ok` boolean
     * en óf {extracted, followUps} óf {fallback: 'regex-v1', reason}.
     * Bij netwerk-fail of timeout: fallback regex-v1.
     */
    function submitToAnalyze(userQuestion) {
      if (!config.analyzeUrl) {
        return Promise.resolve({
          ok: false,
          fallback: "regex-v1",
          reason: "config_missing",
        });
      }
      var controller =
        typeof AbortController !== "undefined" ? new AbortController() : null;
      // 15s timeout — analyze + LLM call kan tot ~10s duren bij cold start
      var timer = controller
        ? setTimeout(function () {
            controller.abort();
          }, 15000)
        : null;

      return fetch(config.analyzeUrl, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        cache: "no-store",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          userQuestion: userQuestion,
          source: config.source || "vetts.app",
          antiAbuse: { honeypot: honeypotEl ? honeypotEl.value : "" },
        }),
        signal: controller ? controller.signal : undefined,
      })
        .then(function (res) {
          if (timer) clearTimeout(timer);
          return res
            .json()
            .catch(function () {
              return null;
            })
            .then(function (json) {
              if (json && typeof json.ok === "boolean") return json;
              return {
                ok: false,
                fallback: "regex-v1",
                reason: "llm_invalid_response",
              };
            });
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          return { ok: false, fallback: "regex-v1", reason: "llm_unavailable" };
        });
    }

    function submitToProxy(payload) {
      if (!config.proxyUrl) {
        return Promise.resolve({
          ok: false,
          error: {
            code: "INTERNAL_ERROR",
            message: "Chat is nog niet geconfigureerd (geen proxy-URL).",
          },
        });
      }
      var controller =
        typeof AbortController !== "undefined" ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () {
            controller.abort();
          }, 15000)
        : null;

      return fetch(config.proxyUrl, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        cache: "no-store",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined,
      })
        .then(function (res) {
          if (timer) clearTimeout(timer);
          return res
            .json()
            .catch(function () {
              return null;
            })
            .then(function (json) {
              if (json && typeof json.ok === "boolean") return json;
              // Onbekend response-formaat → wrap als unavailable
              return {
                ok: false,
                error: {
                  code: "BACKEND_UNAVAILABLE",
                  message:
                    "Onze systemen gaven een onverwacht antwoord. Probeer het zo opnieuw.",
                },
              };
            });
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          return {
            ok: false,
            error: {
              code: "BACKEND_UNAVAILABLE",
              message:
                "Geen verbinding. Controleer je internet en probeer het opnieuw.",
            },
          };
        });
    }

    function showCompletion(result) {
      rmTyping();
      hideAll();
      msgsEl.style.display = "none";
      errEl.classList.remove("active");
      headerEl.classList.add("compact");
      if (smsPhoneEl) smsPhoneEl.textContent = formatPhoneForDisplay(st.phone);
      // Wachttijd-tekst: kies dag- of nacht-versie obv huidige tijd. De ranges
      // en de teksten komen uit de Shopify theme-editor (data-wait-* attrs).
      if (waitTimeEl) {
        waitTimeEl.textContent = pickWaitTimeText();
      }
      if (st.spoed && emerEl) emerEl.classList.add("active");
      // SMS-verificatie: backend zet result.verificationRequired=true wanneer de
      // gebruiker DIRECT een verificatie-SMS heeft ontvangen en z'n nummer moet
      // bevestigen. Toon dan de notice onder de subtitel + de extra "Verificatie
      // via SMS"-stap. Bij false/afwezig blijven beide verborgen. Expliciet
      // add/remove (geen toggle-met-force, i.v.m. oudere browsers); de remove-tak
      // voorkomt stale 'active' als showCompletion ooit opnieuw draait.
      var needsVerify = !!(result && result.verificationRequired);
      if (needsVerify) {
        if (verifyNoticeEl) verifyNoticeEl.classList.add("active");
        if (verifyStepEl) verifyStepEl.classList.add("active");
        // Stap 1 mag niet claimen dat de vraag al bij de dierenarts ligt —
        // die gaat pas door ná geslaagde verificatie. Neutrale tekst.
        if (step1DescEl)
          step1DescEl.textContent = "We hebben je vraag goed ontvangen.";
      } else {
        if (verifyNoticeEl) verifyNoticeEl.classList.remove("active");
        if (verifyStepEl) verifyStepEl.classList.remove("active");
        // Reset naar de standaardtekst (bv. na een retry op hetzelfde scherm).
        if (step1DescEl)
          step1DescEl.textContent = "Je vraag ligt nu bij de dierenarts.";
      }
      completeEl.classList.add("active");
    }

    /**
     * Kiest de juiste wachttijd-tekst op basis van huidige browser-tijd. Tijd-
     * ranges worden in HH:MM uit config gehaald. Werkt ook over middernacht
     * (bv. day-start "07:00", day-end "23:00" → 's nachts tussen 23-7 uur
     * verschijnt nacht-tekst).
     */
    function pickWaitTimeText() {
      return pickWaitTimeTextFor(config);
    }

    function parseHHMM(s, fallback) {
      if (typeof s !== "string") return fallback;
      var m = s.match(/^(\d{1,2}):(\d{2})$/);
      if (!m) return fallback;
      var h = parseInt(m[1], 10);
      var min = parseInt(m[2], 10);
      if (isNaN(h) || isNaN(min) || h < 0 || h > 23 || min < 0 || min > 59) {
        return fallback;
      }
      return h * 60 + min;
    }

    function showSubmitError(err) {
      lastError = err || null;
      rmTyping();
      hideAll();
      msgsEl.style.display = "none";
      completeEl.classList.remove("active");
      if (errTextEl)
        errTextEl.textContent = (err && err.message) || "Probeer het nog eens.";
      errEl.classList.add("active");
    }

    function findAdminStepIndex(key) {
      for (var i = 0; i < ADMIN_STEPS.length; i++) {
        if (ADMIN_STEPS[i].key === key) return i;
      }
      return -1;
    }

    function isPhoneValidationError(err) {
      if (!err) return false;
      if (err.code !== "VALIDATION_FAILED") return false;
      // Match op verschillende signalen:
      //   1. NL message bevat "telefoon"/"nummer" (proxy-Zod-message)
      //   2. errorKey bevat "phone" (Mychon's raw key, bv.
      //      'phone_number_invalid')
      //   3. Heuristisch: VALIDATION_FAILED zonder errorKey ZIJN op onze
      //      flow vrijwel altijd het telefoonnummer (laatste veld; alle
      //      andere worden client-side gevalideerd vóór ze hier komen).
      // Liever te ruim matchen dan een dead-end error-scherm tonen waar
      // de user geen actie meer kan ondernemen.
      if (/telefoon|nummer|NL-nummer|\bphone\b/i.test(err.message || ""))
        return true;
      if (/phone|telefoon/i.test(err.errorKey || "")) return true;
      // Onbekende validation-error na de submit: route ook naar de phone-
      // step zodat de user 't kan corrigeren.
      return true;
    }
    // Telefoon-gerelateerde fouten waarbij het zinloos is de SAME payload
    // opnieuw te POST'en: validatiefout op het nummer, OF Mychon's DUPLICATE
    // (telefoonnummer al gebruikt). Allebei vragen om een ander nummer.
    // Per V2-feedback Sander 2026-05-26 — voorheen liep de DUPLICATE-fout in
    // een retry-loop omdat we domweg dezelfde payload opnieuw stuurden.
    function isPhoneRelatedError(err) {
      if (!err) return false;
      if (err.code === "DUPLICATE") return true;
      return isPhoneValidationError(err);
    }

    function resetToPhoneStep(err) {
      var phoneIdx = findAdminStepIndex("phone");
      if (phoneIdx < 0) return false;
      errEl.classList.remove("active");
      msgsEl.style.display = "";
      completeEl.classList.remove("active");
      submitting = false;
      sndBtn.classList.remove("submitting");
      sndBtn.disabled = false;
      adminStep = phoneIdx;
      st.phone = "";
      phase = "admin";
      // Bot-message hangt af van het type fout: validatie vs duplicate
      // hebben verschillende oorzaken en de tone-of-voice moet daarbij
      // passen (geen "probeer opnieuw" als 't probleem is dat 't nummer
      // al bekend is).
      showTyping().then(function () {
        var msg;
        if (err && err.code === "DUPLICATE") {
          msg =
            "Dit nummer staat al bij ons in het systeem. Wacht op het " +
            "antwoord van de dierenarts, of vul een ander telefoonnummer in.";
        } else {
          msg =
            "Sorry, dat nummer kon ik niet verwerken. Probeer het nog eens.";
        }
        addBot(msg);
        runAdmin();
      });
      return true;
    }

    function finish() {
      if (submitting) return;
      submitting = true;
      phase = "submitting";
      hideAll(); // voorkom Enter-spam tijdens submit
      progBar.style.width = "100%";
      showTyping().then(function () {
        // De-dupe "Ik verstuur..."-bericht. Als de user via een eerdere
        // retry al een dergelijk bericht heeft gezien, voegen we 'm NIET
        // nog een keer toe — voorheen kon de chat de regel 4-5× stapelen
        // bij meerdere mislukte submits (V2-feedback Sander 2026-05-26).
        var sendingMsg = "Ik verstuur je vraag naar de dierenarts...";
        var lastBot = msgsEl.lastElementChild;
        var alreadyShown =
          lastBot &&
          lastBot.classList &&
          lastBot.classList.contains("bot") &&
          lastBot.textContent === sendingMsg;
        if (!alreadyShown) addBot(sendingMsg);
        sndBtn.classList.add("submitting");
        sndBtn.disabled = true;
        var payload = buildPayload();
        submitToProxy(payload).then(function (res) {
          submitting = false;
          sndBtn.classList.remove("submitting");
          sndBtn.disabled = false;
          if (res.ok) {
            // GA4: succesvol verstuurd. Conversie-event in Sander's funnel.
            trackOnce("chat_finished_sent", "chat_finished_sent");
            showCompletion(res);
            return;
          }
          // Telefoon-gerelateerde fouten (DUPLICATE, validatie op nummer):
          // sla het generic error-scherm over en stuur de user DIRECT terug
          // naar de telefoon-stap. Voorheen kreeg hij "Er ging iets mis" +
          // moest hij Opnieuw proberen klikken om alsnog naar de stap te
          // gaan; dat was twee onnodige clicks (V2-feedback Sander 2026-05-26).
          if (isPhoneRelatedError(res.error) && resetToPhoneStep(res.error)) {
            return;
          }
          // Alle overige fouten (RATE_LIMITED, BACKEND_UNAVAILABLE, etc.):
          // generic "Er ging iets mis"-scherm met Opnieuw-proberen knop.
          showSubmitError(res.error);
        });
      });
    }

    // ═══════════════════════════════════════════════════════════════════
    //  v2_payment — Stripe embedded betaling
    //  Flow: na de telefoon-stap → create-payment-intent (bedrag server-side
    //  uit Stripe Price) → embedded Payment Element in een chat-bubbel →
    //  betalen → /api/submit-paid-intake (verifieert betaling server-side) →
    //  bestaand completion-scherm. De intake gaat dus PAS na betaling door.
    // ═══════════════════════════════════════════════════════════════════
    var paymentStripe = null;
    var paymentElements = null;
    // Huidige Payment Element — bewaard zodat we 'm bij een NIEUWE betaalpoging
    // kunnen opruimen (destroy) i.p.v. Stripe-iframes te laten opstapelen.
    var paymentElement = null;
    // ÉÉN Stripe-instantie voor de hele pagina-levensduur. Elke window.Stripe(...)
    // maakt een eigen achtergrond-iframe; bij meerdere betaalpogingen (de chat een
    // paar keer opnieuw doorlopen) stapelden die zich op en liep Safari (ITP /
    // iframe-limiet) na een paar keer vast in de skeleton-laadstaat. Firefox/Chrome
    // zijn toleranter — vandaar dat het daar niet opviel. Hergebruik lost dit op.
    function vhStripeOnce(pubKey) {
      if (!window.Stripe) return null;
      if (!window.__vhStripeInstance) {
        window.__vhStripeInstance = window.Stripe(pubKey);
      }
      return window.__vhStripeInstance;
    }
    // Het bericht NET vóór de betaalkaart ("De laatste stap:..."). Hierop ankert
    // de betaalkaart-scroll zodat dat bericht net bovenaan het venster komt.
    var payAnchorEl = null;
    // Naam uit de chat — geven we mee aan Stripe zodat we 't naam-veld kunnen
    // verbergen (de gebruiker hoeft 'm niet nog eens in te tikken).
    var payBillingName = "";

    function formatAmount(cents, currency) {
      var v = (Number(cents) / 100).toFixed(2).replace(".", ",");
      var cur = (currency || "eur").toLowerCase();
      return (cur === "eur" ? "€ " : (currency || "").toUpperCase() + " ") + v;
    }

    // De intake staat na create-payment-intent server-side (Blob, op PI-id). In
    // de stash bewaren we alleen wat we ná een iDEAL-redirect nodig hebben: PI-id
    // (doorzet triggeren) en telefoon (op het completion-scherm tonen).
    // Snapshot van het chat-gesprek (zonder betaal-bubbel + zware foto-dataURLs)
    // zodat we 't na een MISLUKTE iDEAL-betaling visueel kunnen herstellen.
    function snapshotConversation() {
      try {
        var clone = msgsEl.cloneNode(true);
        var pays = clone.querySelectorAll(".vh-pay");
        for (var i = 0; i < pays.length; i++) pays[i].remove();
        var imgs = clone.querySelectorAll("img[src^='data:']");
        for (var j = 0; j < imgs.length; j++) imgs[j].removeAttribute("src");
        var html = clone.innerHTML;
        return html.length > 200000 ? "" : html;
      } catch (e) {
        return "";
      }
    }
    // Stash voor de iDEAL-redirect: PI-id (doorzet/verificatie) + telefoon
    // (completion-scherm), én — voor het geval de betaling FAALT — de intake en
    // het gesprek, zodat we de sessie kunnen hervatten (chat herstellen + nieuw
    // betaalvenster). Bij een geslaagde betaling gebruiken we intake/convo niet.
    function stashPay(pubKey, piId, intake, convo, clientSecret) {
      try {
        var payload = {
          pubKey: pubKey || "",
          piId: piId || "",
          // clientSecret bewaren we zodat we na een afgebroken betaling de ECHTE
          // PI-status bij Stripe kunnen opvragen (retrievePaymentIntent) i.p.v. te
          // gokken. Hij is sowieso al client-side (mount de Payment Element).
          cs: clientSecret || "",
          phone: st.phone || "",
          // E-mail uit de betaalkaart bewaren (overleeft een iDEAL-redirect/
          // mislukte betaling) zodat we 'm kunnen prefillen i.p.v. opnieuw vragen.
          // stashPay draait bij mount (vóór invullen), dus behoud een eerder
          // gezette e-mail; patchStashEmail + de input-listener houden 'm actueel.
          email: (readStash() || {}).email || "",
          // Tijdstempel: alleen een RECENTE stash hervatten we bij een verse boot
          // (afgebroken betaling). Voorkomt dat een uren-oude stash later in
          // dezelfde tab alsnog onverwacht de betaalkaart terugtovert.
          ts: Date.now(),
        };
        if (intake) payload.intake = intake;
        if (convo && convo.length <= 200000) payload.convo = convo;
        sessionStorage.setItem(PAY_STASH_KEY, JSON.stringify(payload));
      } catch (e) {
        /* sessionStorage vol/uit — niet fataal voor de kaart-flow */
      }
    }
    function readStash() {
      try {
        return JSON.parse(sessionStorage.getItem(PAY_STASH_KEY) || "null");
      } catch (e) {
        return null;
      }
    }
    // Patch enkel de e-mail in een bestaande stash. De e-mail wordt pas ná het
    // mounten van de kaart ingevuld (stashPay draaide toen al), dus we updaten 'm
    // los zodra de klant typt — zo overleeft 'ie een redirect/mislukte betaling.
    function patchStashEmail(email) {
      try {
        var s = readStash();
        if (!s) return;
        s.email = (email || "").trim();
        sessionStorage.setItem(PAY_STASH_KEY, JSON.stringify(s));
      } catch (e) {
        /* niet fataal */
      }
    }
    function clearStash() {
      try {
        sessionStorage.removeItem(PAY_STASH_KEY);
      } catch (e) {}
      // Bij een afgeronde/opgeruimde betaling vervalt ook de redirect-vlag.
      clearRedirectMark();
    }
    // Markeer dat er NU een redirect-betaling (bv. iDEAL) gestart is. Alleen als
    // deze vlag staat hervatten we na een verse boot een afgebroken betaling — zo
    // resumen we NIET als de klant de kaart enkel zag maar nooit op betalen klikte.
    // Wordt gewist zodra een verse kaart mount of de betaling inline afrondt.
    function markRedirect() {
      try {
        sessionStorage.setItem(PAY_REDIRECT_KEY, "1");
      } catch (e) {}
    }
    function clearRedirectMark() {
      try {
        sessionStorage.removeItem(PAY_REDIRECT_KEY);
      } catch (e) {}
    }

    function startPayment() {
      if (phase === "payment" || phase === "submitting") return;
      phase = "payment";
      hideAll();
      progBar.style.width = "100%";
      trackOnce("chat_payment_started", "chat_payment_started");
      // Volledige intake naar create-payment-intent (server slaat 'm op onder de
      // PI). Bijlagen strippen we eruit — die gaan toch niet naar Mychon en
      // zouden de body onnodig groot maken.
      var intake = JSON.parse(JSON.stringify(buildPayload()));
      if (intake.question) delete intake.question.attachments;
      payBillingName = (intake.owner && intake.owner.firstName) || "";
      // Snapshot nu (vóór de betaal-UI) voor herstel na een mislukte iDEAL-betaling.
      var convoSnapshot = snapshotConversation();
      showTyping().then(function () {
        payAnchorEl = addBot(
          "De laatste stap: Na je betaling, wordt je vraag direct doorgestuurd naar een ervaren dierenarts.",
        );
        createPaymentIntentReq(intake).then(function (res) {
          if (
            !res ||
            res.ok !== true ||
            !res.clientSecret ||
            !res.publishableKey
          ) {
            phase = "admin";
            showSubmitError({
              message:
                (res && res.error && res.error.message) ||
                "De betaling kon niet gestart worden. Probeer het opnieuw.",
            });
            return;
          }
          stashPay(
            res.publishableKey,
            (res.clientSecret || "").split("_secret_")[0],
            intake,
            convoSnapshot,
            res.clientSecret,
          );
          mountPaymentElement(res);
        });
      });
    }

    function createPaymentIntentReq(intake) {
      var controller =
        typeof AbortController !== "undefined" ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () {
            controller.abort();
          }, 15000)
        : null;
      return fetch(config.createPaymentUrl, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        cache: "no-store",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(intake),
        signal: controller ? controller.signal : undefined,
      })
        .then(function (r) {
          if (timer) clearTimeout(timer);
          return r.json().catch(function () {
            return null;
          });
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          return null;
        });
    }

    function mountPaymentElement(piRes) {
      // Verse kaart = nog geen redirect gestart. Wis de redirect-vlag zodat een
      // hervatte/nieuw getoonde kaart niet bij de volgende boot opnieuw als
      // "afgebroken redirect" telt (anders bleef de kaart zich herhalen).
      clearRedirectMark();
      if (!window.Stripe) {
        phase = "admin";
        showSubmitError({
          message:
            "De betaalmodule kon niet laden. Herlaad de pagina en probeer het opnieuw.",
        });
        return;
      }
      // Vorige Payment Element (van een eerdere poging) opruimen vóór we een
      // nieuwe mounten — anders blijft z'n iframe hangen en stapelt het op.
      if (paymentElement) {
        try {
          paymentElement.destroy();
        } catch (e) {}
        paymentElement = null;
      }
      paymentStripe = vhStripeOnce(piRes.publishableKey);
      // Markeer dat er een Stripe Payment Element gemount is. De bfcache-guard
      // (init-blok onder config.paymentEnabled) herlaadt hierop bij terugkeer.
      window.__vhPaymentMounted = true;
      paymentElements = paymentStripe.elements({
        clientSecret: piRes.clientSecret,
        // Forceer Nederlands voor ALLE Stripe-teksten (de "extra stap"-notice
        // bij Apple Pay/iDEAL, foutmeldingen, veldlabels). Zonder dit pakt
        // Stripe de browsertaal — vandaar het Engels.
        locale: "nl",
        appearance: {
          theme: "stripe",
          variables: {
            colorPrimary: "#00bf63",
            fontFamily: "Poppins, -apple-system, sans-serif",
            borderRadius: "12px",
          },
        },
      });
      var amountTxt = formatAmount(piRes.amount, piRes.currency);

      // ── Pet-naam voor de kaarttitel. Primair uit state; valt bij een
      // mislukte-betaling-retry-ná-reload (state leeg) terug op de stash-intake.
      var pcPetName = (st && st.petName && String(st.petName).trim()) || "";
      if (!pcPetName) {
        try {
          var _stash = readStash();
          if (_stash && _stash.intake && _stash.intake.pet) {
            pcPetName = (_stash.intake.pet.name || "").trim();
          }
        } catch (e) {}
      }
      if (!pcPetName) pcPetName = "je huisdier";

      // ── Bannerbeelden (theme-assets via de liquid). Zijn ze gezet, dan tonen
      // we het kant-en-klare beeld; anders/bij laadfout vallen we terug op de
      // CSS-recreatie van het blok hieronder.
      var PC_PROMO_IMG = (config.promoImg || "").trim();
      var PC_REVIEW_IMG = (config.reviewImg || "").trim();
      // Fallback-beelden voor de CSS-recreatie (placeholder-hond + avatars).
      var PC_FALLBACK_DOG =
        "https://images.unsplash.com/photo-1633722715463-d30f4f325e24?auto=format&fit=facearea&facepad=2&w=240&h=180&q=80";
      var PC_FALLBACK_AVATARS = [
        "https://vetts.app/cdn/shop/files/DIERENARTSEN_VETTS_19.png?v=1750847799",
        "https://vetts.app/cdn/shop/files/DIERENARTSEN_VETTS_16.png?v=1750847562",
        "https://vetts.app/cdn/shop/files/DIERENARTSEN_VETTS_17.png?v=1750847681",
      ];

      // De doorgestreepte "was"-prijzen + besparings-% zijn marketing-ankers: de
      // REGULIERE waardes liggen vast, maar de besparing rekenen we t.o.v. het LIVE
      // betaalbedrag (piRes.amount) zodat de percentages automatisch kloppen zodra je
      // de Stripe-prijs wijzigt. Pas alléén deze twee ankers aan als de normale
      // waarde verandert:
      var PC_CONSULT_REGULAR = 1499; // normale consult-prijs in centen (€ 14,99)
      var PC_TRACTIVE_VALUE = 6900; // Tractive-waarde in centen (€ 69,00, gratis)
      var pcTotalRegular = PC_CONSULT_REGULAR + PC_TRACTIVE_VALUE; // € 83,99
      function pcSavePct(regularCents) {
        if (!regularCents || piRes.amount >= regularCents) return 0;
        return Math.round((1 - piRes.amount / regularCents) * 100);
      }
      function pcSaveTxt(regularCents) {
        var p = pcSavePct(regularCents);
        return p > 0 ? "BESPAAR " + p + "%" : "";
      }
      var pcConsultWasTxt = formatAmount(PC_CONSULT_REGULAR, piRes.currency);
      var pcTotalWasTxt = formatAmount(pcTotalRegular, piRes.currency);
      var pcConsultSaveTxt = pcSaveTxt(PC_CONSULT_REGULAR);

      // CSS-fallback voor de Tractive-promo (als er geen bannerbeeld is/laadt).
      var promoFallbackHtml =
        '<div class="vh-pc-promo">' +
        '<div class="vh-pc-promo-body">' +
        '<span class="vh-pc-promo-tag">Tijdelijke aanbieding</span>' +
        '<div class="vh-pc-promo-title">Gratis Slimme<br>Health Tracker</div>' +
        '<div class="vh-pc-promo-price"><span class="vh-pc-promo-now">€ 0,00</span><span class="vh-pc-promo-was">€ 69,00</span></div>' +
        "</div>" +
        '<div class="vh-pc-promo-side">' +
        '<span class="vh-pc-promo-brand"><svg viewBox="0 0 24 24" width="13" height="13" fill="#1f6fe5" aria-hidden="true"><path d="M12 2C8.1 2 5 5.1 5 9c0 5 7 13 7 13s7-8 7-13c0-3.9-3.1-7-7-7z"></path><circle cx="12" cy="9" r="2.4" fill="#fff"></circle></svg> Tractive</span>' +
        '<img class="vh-pc-promo-img" alt="" referrerpolicy="no-referrer" crossorigin="anonymous" data-pc-fallback-dog>' +
        "</div>" +
        "</div>";

      // CSS-fallback voor het beoordelingsblok.
      var reviewFallbackHtml =
        '<div class="vh-pc-trust">' +
        '<div class="vh-pc-tcard">' +
        '<span class="vh-pc-tlabel">Gemiddelde beoordeling</span>' +
        '<div class="vh-pc-trow"><span class="vh-pc-tnum">4.9</span><span class="vh-pc-stars">' +
        '<span class="vh-pc-star">★</span><span class="vh-pc-star">★</span><span class="vh-pc-star">★</span><span class="vh-pc-star">★</span><span class="vh-pc-star">★</span>' +
        "</span></div>" +
        '<span class="vh-pc-tsub">Zeer tevreden</span>' +
        "</div>" +
        '<div class="vh-pc-tcard">' +
        '<div class="vh-pc-avatars" data-pc-avatars></div>' +
        '<span class="vh-pc-tnum vh-pc-tnum-lg">12.348</span>' +
        '<span class="vh-pc-tsub">Huisdierouders</span>' +
        "</div>" +
        "</div>";

      // Bij een banner-URL: het beeld + een verborgen fallback (die bij een
      // laadfout zichtbaar wordt). Geen URL: meteen de CSS-fallback.
      function pcBlock(url, alt, kind, fallbackHtml) {
        if (url) {
          return (
            '<img class="vh-pc-banner" alt="' +
            alt +
            '" referrerpolicy="no-referrer" data-pc-banner="' +
            kind +
            '">' +
            '<div data-pc-fb="' +
            kind +
            '" hidden>' +
            fallbackHtml +
            "</div>"
          );
        }
        return fallbackHtml;
      }

      var bubble = document.createElement("div");
      bubble.className = "vh-msg bot vh-pay";
      bubble.innerHTML =
        '<div class="vh-pc-title">Vraag voor <span data-pc-pet></span></div>' +
        '<div class="vh-pc-price">' +
        '<span class="vh-pc-now" data-pc-now></span>' +
        '<span class="vh-pc-was" data-pc-was></span>' +
        "</div>" +
        '<span class="vh-pc-save" data-pc-save></span>' +
        pcBlock(
          PC_PROMO_IMG,
          "Gratis Tractive Health Tracker (t.w.v. € 69,00)",
          "promo",
          promoFallbackHtml,
        ) +
        pcBlock(
          PC_REVIEW_IMG,
          "Beoordeling 4,9 van 5 — 12.348 huisdierouders",
          "review",
          reviewFallbackHtml,
        ) +
        '<div class="vh-pc-summary">' +
        '<div class="vh-pc-line"><span>VETTS Chat • Dierenarts</span><span data-pc-line></span></div>' +
        '<div class="vh-pc-line"><span>Tractive Health Tracker</span><span>€ 0,00</span></div>' +
        '<div class="vh-pc-total"><span class="vh-pc-total-l">Totaal</span>' +
        '<span class="vh-pc-total-r"><span class="vh-pc-total-now" data-pc-total></span>' +
        '<span class="vh-pc-total-sub"><span class="vh-pc-total-was" data-pc-total-was></span></span>' +
        "</span></div>" +
        "</div>" +
        // E-mailadres in de kaart, ónder het totaal (verplicht). Het adres gaat bij
        // 'Chat versturen' mee naar Stripe via billing_details; de webhook leest 't
        // daar (charge.billing_details.email) en stuurt de factuur + Tractive-code.
        // We verzamelen 't dus NIET in de chat.
        '<div class="vh-pc-email">' +
        '<label class="vh-pc-email-label" for="vh-pc-email-input">E-mailadres</label>' +
        '<input type="email" id="vh-pc-email-input" class="vh-pc-email-input" inputmode="email" autocomplete="email" placeholder="Voorbeeld@gmail.com" data-pc-email aria-label="E-mailadres" maxlength="120">' +
        '<div class="vh-pc-email-err" data-pc-email-err role="alert" hidden></div>' +
        "</div>" +
        '<div class="vh-pay-element"></div>' +
        '<div class="vh-pay-error" data-pay-error hidden></div>' +
        '<button type="button" class="vh-pay-btn" data-pay-btn></button>' +
        '<div class="vh-pay-secure">🔒 Beveiligd via Stripe</div>';

      // textContent (geen innerHTML) voor naam + bedragen — voorkomt injectie.
      bubble.querySelector("[data-pc-pet]").textContent = pcPetName;
      bubble.querySelector("[data-pc-now]").textContent = amountTxt;
      bubble.querySelector("[data-pc-line]").textContent = amountTxt;
      bubble.querySelector("[data-pc-total]").textContent = amountTxt;
      bubble.querySelector("[data-pay-btn]").textContent =
        "Chat versturen • " + amountTxt;
      // Dynamische marketing-ankers: besparing t.o.v. het live betaalbedrag.
      bubble.querySelector("[data-pc-was]").textContent = pcConsultWasTxt;
      bubble.querySelector("[data-pc-save]").textContent = pcConsultSaveTxt;
      bubble.querySelector("[data-pc-total-was]").textContent = pcTotalWasTxt;

      // CSS-fallback-beelden vullen (alleen wanneer dat blok zichtbaar is).
      function showPromoFallback() {
        var fb = bubble.querySelector('[data-pc-fb="promo"]');
        if (fb) fb.hidden = false;
        var dog = bubble.querySelector("[data-pc-fallback-dog]");
        if (dog && !dog.getAttribute("src")) dog.src = PC_FALLBACK_DOG;
      }
      function showReviewFallback() {
        var fb = bubble.querySelector('[data-pc-fb="review"]');
        if (fb) fb.hidden = false;
        var box = bubble.querySelector("[data-pc-avatars]");
        if (box && !box.childNodes.length) {
          for (var i = 0; i < PC_FALLBACK_AVATARS.length; i++) {
            var im = document.createElement("img");
            im.src = PC_FALLBACK_AVATARS[i];
            im.alt = "";
            im.setAttribute("referrerpolicy", "no-referrer");
            im.setAttribute("crossorigin", "anonymous");
            box.appendChild(im);
          }
        }
      }
      function wirePcBanner(kind, url, showFallback) {
        var img = bubble.querySelector('[data-pc-banner="' + kind + '"]');
        if (!img) return;
        img.onerror = function () {
          img.style.display = "none";
          showFallback();
        };
        img.src = url;
      }
      if (PC_PROMO_IMG) wirePcBanner("promo", PC_PROMO_IMG, showPromoFallback);
      else showPromoFallback();
      if (PC_REVIEW_IMG)
        wirePcBanner("review", PC_REVIEW_IMG, showReviewFallback);
      else showReviewFallback();

      msgsEl.appendChild(bubble);

      // Klap de dierenartsen-header alvast in (compact) zodra de betaalkaart
      // verschijnt — exact dezelfde "uitzoom" als op het completion-scherm
      // (showCompletion) — zodat de hele, lange betaalkaart in beeld past.
      if (headerEl) headerEl.classList.add("compact");

      // Positioneer de kaart zó dat het bericht NET VÓÓR de kaart ("De laatste
      // stap:...") nog net bovenaan het chatvenster staat (met een kleine marge).
      // Zo ziet de klant meteen het complete overzicht i.p.v. dat 'ie naar de
      // betaalknop onderaan wordt geduwd; daarna scrollt 'ie zelf naar beneden om
      // te betalen. Viewport-onafhankelijk — we ankeren op de bubbel, niet op een
      // vaste pixel-positie.
      // Positioneer de kaart zó dat de "De laatste stap"-bubbel (payAnchorEl) net
      // bovenaan het chatvenster komt — de klant ziet meteen het overzicht i.p.v.
      // de betaalknop onderaan. Belangrijk: we scrollen hier NOOIT naar de bodem
      // (geen else-fallback). Is er geen anker, dan laten we de scroll met rust.
      function payScrollOverview() {
        requestAnimationFrame(function () {
          var anchor = payAnchorEl;
          if (!anchor || !anchor.getBoundingClientRect) return;
          var delta =
            anchor.getBoundingClientRect().top -
            msgsEl.getBoundingClientRect().top -
            // 16px = de header-overlap (zie .vh-wmsgs margin-top in de CSS) +
            // ~4px lucht, zodat "De laatste stap" nét onder de header uitkomt.
            20;
          msgsEl.scrollTop = Math.max(0, msgsEl.scrollTop + delta);
        });
      }
      payScrollOverview();

      // KRITISCH voor Stripe: het Payment Element rendert NIET binnen een
      // voorouder met een CSS transform/filter/perspective — dat breekt z'n
      // iframe-positionering en het blijft eeuwig in de skeleton-laadstaat. De
      // hero-entree-animatie (vh-fade-up) laat zo'n transform achter op
      // .vh-right. We neutraliseren transform/filter/perspective op alle
      // voorouders van het mount-punt vóór we mounten. De entree-animatie is op
      // dit punt al gespeeld, dus dit heeft geen zichtbaar effect.
      // Als functie (i.p.v. eenmalige IIFE) zodat het vangnet hieronder 'm kan
      // herhalen als het Element toch in skeleton blijft hangen.
      function neutralizeAncestorTransforms() {
        var node = msgsEl;
        while (node && node.nodeType === 1 && node !== document.body) {
          var cs = window.getComputedStyle(node);
          if (
            (cs.transform && cs.transform !== "none") ||
            (cs.filter && cs.filter !== "none") ||
            (cs.perspective && cs.perspective !== "none")
          ) {
            node.style.transform = "none";
            node.style.filter = "none";
            node.style.perspective = "none";
            node.style.willChange = "auto";
          }
          node = node.parentNode;
        }
      }
      neutralizeAncestorTransforms();

      // Accordion + ingeklapt: de betaalmethodes staan als lijst; de kaart-
      // velden verschijnen pas wanneer de gebruiker 'Kaart' kiest (idem iDEAL).
      var pe = paymentElements.create("payment", {
        layout: {
          type: "accordion",
          defaultCollapsed: true,
          radios: true,
          spacedAccordionItems: true,
        },
        // Geen naam/contact-velden vragen — die hebben we al uit de chat. We
        // geven de naam mee bij confirmPayment (payment_method_data).
        fields: { billingDetails: { name: "never" } },
      });
      // Bewaar de huidige Payment Element zodat een volgende poging 'm opruimt.
      paymentElement = pe;
      var payMountEl = bubble.querySelector(".vh-pay-element");
      pe.mount(payMountEl);

      // Het Element rendert async (iframe) en de accordion klapt pas open bij
      // methode-keuze → de hoogte verandert. Scroll mee op 'ready' en bij een
      // methode-wijziging (niet bij elke toetsaanslag). De timeouts vangen de
      // async iframe-render af.
      // GEEN reactie op Stripe's 'change'-event: dat vuurt óók automatisch zodra
      // het Element klaar is met laden (~1-2s) en zou de kaart dan alsnog naar de
      // bodem duwen. De klant scrolt zelf naar de betaalknop (op mobiel brengt de
      // browser het kaartveld vanzelf in beeld zodra je erin tikt).
      var payReadyFired = false;
      pe.on("ready", function () {
        payReadyFired = true;
      });
      setTimeout(payScrollOverview, 250);
      setTimeout(payScrollOverview, 700);

      // VANGNET: vuurt 'ready' na ~5s nog niet (de betaalopties hangen in
      // skeleton), dan is meestal een laat toegepaste transform op een voorouder
      // de boosdoener. Neutraliseer opnieuw en mount het Element één keer
      // opnieuw — zonder de chat of de ingevoerde gegevens te verliezen.
      setTimeout(function () {
        if (payReadyFired) return;
        neutralizeAncestorTransforms();
        try {
          pe.unmount();
          pe.mount(payMountEl);
        } catch (e) {}
      }, 5000);

      var payBtn = bubble.querySelector("[data-pay-btn]");
      var payErr = bubble.querySelector("[data-pay-error]");
      var emailInput = bubble.querySelector("[data-pc-email]");
      var emailErr = bubble.querySelector("[data-pc-email-err]");
      // Prefill na een afgebroken/mislukte betaling: bewaarde e-mail terugzetten
      // zodat de klant 'm niet opnieuw hoeft te typen.
      if (emailInput) {
        var _stashedEmail = (readStash() || {}).email || "";
        if (_stashedEmail) emailInput.value = _stashedEmail;
      }
      // Foutmelding wissen zodra de klant typt.
      if (emailInput) {
        emailInput.addEventListener("input", function () {
          clearEmailError(emailInput, emailErr);
          // Actueel houden in de stash → prefill na een mislukte/afgebroken betaling.
          patchStashEmail(emailInput.value);
          // GA4: klant heeft een geldig e-mailadres ingevuld (funnel-stap).
          var _v = (emailInput.value || "").trim();
          if (_v.length <= 120 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(_v)) {
            trackOnce("payment_email_entered", "payment_email_entered");
          }
        });
      }
      payBtn.addEventListener("click", function () {
        confirmPay(payBtn, payErr, emailInput, emailErr);
      });
    }

    function showEmailError(input, errEl, msg) {
      if (input) input.classList.add("vh-pc-email-invalid");
      if (errEl) {
        errEl.textContent = msg;
        errEl.hidden = false;
      }
    }
    function clearEmailError(input, errEl) {
      if (input) input.classList.remove("vh-pc-email-invalid");
      if (errEl) {
        errEl.hidden = true;
        errEl.textContent = "";
      }
    }

    function confirmPay(payBtn, payErr, emailInput, emailErr) {
      if (!paymentStripe || !paymentElements) return;
      // E-mail VERPLICHT + valideren vóór we de knop blokkeren of Stripe aanroepen.
      var email = ((emailInput && emailInput.value) || "").trim();
      if (!email) {
        showEmailError(emailInput, emailErr, "Dit veld is verplicht");
        if (emailInput) emailInput.focus();
        return;
      }
      if (email.length > 120 || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        showEmailError(emailInput, emailErr, "Vul een geldig e-mailadres in");
        if (emailInput) emailInput.focus();
        return;
      }
      clearEmailError(emailInput, emailErr);
      // GA4: e-mail geldig (vangnet, o.a. bij prefill) + betaling gestart. Dit is
      // het punt waarop de klant op "Chat versturen" klikt en Stripe wordt
      // aangeroepen (e-mail is dan gevalideerd).
      trackOnce("payment_email_entered", "payment_email_entered");
      trackOnce("payment_started", "payment_started");
      payBtn.disabled = true;
      payBtn.classList.add("loading");
      if (payErr) {
        payErr.hidden = true;
        payErr.textContent = "";
      }
      // Vlag NU: er gaat mogelijk een redirect (iDEAL) gebeuren. Komt de promise
      // hieronder tóch terug (kaart, geen redirect), dan wissen we 'm meteen weer.
      // Blijft de vlag staan (pagina is weg naar de bank), dan weten we bij een
      // browser-terug dat dit een afgebroken redirect-betaling was.
      markRedirect();
      paymentStripe
        .confirmPayment({
          elements: paymentElements,
          // return_url is nodig voor redirect-methodes (iDEAL). Bij kaart komt
          // 'redirect: if_required' niet aan een redirect toe en lossen we 't
          // hier inline op.
          confirmParams: {
            return_url: window.location.href,
            // GEEN receipt_email: dan stuurt Stripe z'n eigen ontvangstbewijs
            // náást onze Brevo-factuur (en de account-instelling daarvoor is
            // globaal, dus dat kan niet per transactie uit). Het adres geven we
            // mee via billing_details; de webhook leest 't daar
            // (charge.billing_details.email).
            // Naam meegeven (veld is verborgen) — Stripe eist 'm anders bij
            // billingDetails.name = 'never'.
            payment_method_data: {
              billing_details: {
                name: payBillingName || "Klant",
                email: email,
              },
            },
          },
          redirect: "if_required",
        })
        .then(function (result) {
          // We zijn hier → er is GEEN redirect gebeurd (kaart of inline fout).
          clearRedirectMark();
          if (result.error) {
            payBtn.disabled = false;
            payBtn.classList.remove("loading");
            if (payErr) {
              payErr.textContent =
                result.error.message ||
                "Betaling mislukt. Probeer het opnieuw.";
              payErr.hidden = false;
            }
            return;
          }
          var pi = result.paymentIntent;
          // succeeded (kaart) of processing/requires_action (async, bv. iDEAL):
          // de server verifieert de definitieve status bij submit-paid-intake.
          if (
            pi &&
            (pi.status === "succeeded" ||
              pi.status === "processing" ||
              pi.status === "requires_action")
          ) {
            // Stripe heeft de betaling bevestigd. Een eventuele (zeldzame) fout in
            // de afronding hieronder mag NIET in de .catch als "Betaling mislukt"
            // belanden (het geld is al binnen) → hier opvangen. De stripe-webhook
            // zet de intake server-side sowieso door.
            try {
              finishPaid(pi.id);
            } catch (e) {}
          } else {
            payBtn.disabled = false;
            payBtn.classList.remove("loading");
            if (payErr) {
              payErr.textContent =
                "Betaling niet voltooid. Probeer het opnieuw.";
              payErr.hidden = false;
            }
          }
        })
        .catch(function () {
          // confirmPayment hoort te resolven met {error}; mocht de promise tóch
          // rejecten, herstel dan de knop + wis de redirect-vlag (anders blijft de
          // knop hangen en denkt een latere boot dat er een redirect liep).
          clearRedirectMark();
          payBtn.disabled = false;
          payBtn.classList.remove("loading");
          if (payErr) {
            payErr.textContent = "Betaling mislukt. Probeer het opnieuw.";
            payErr.hidden = false;
          }
        });
    }

    function finishPaid(paymentIntentId) {
      phase = "submitting";
      hideAll();
      msgsEl.style.display = "";
      completeEl.classList.remove("active");
      errEl.classList.remove("active");
      trackOnce("chat_payment_complete", "chat_payment_complete");
      showTyping().then(function () {
        addBot("We ronden je betaling af...");
        // Forceer naar onder: bij een iDEAL-terugkeer is het gesprek hersteld
        // (innerHTML → scrollpositie reset), dus de smart-guard van addBot scrollt
        // niet vanzelf naar het nieuwe bericht.
        requestAnimationFrame(function () {
          msgsEl.scrollTop = msgsEl.scrollHeight;
        });
        var shownAt = Date.now();
        submitPaidIntakeReq(paymentIntentId).then(function (res) {
          // Minimaal ~2s op "We ronden je betaling af..." blijven, zodat de
          // gebruiker z'n herstelde gesprek rustig ziet vóór het completion-
          // scherm (anders springt 't bij een snelle response meteen door).
          var wait = Math.max(0, 2000 - (Date.now() - shownAt));
          setTimeout(function () {
            // Async betaling (iDEAL) nog in verwerking → de webhook zet de intake
            // door zodra 't settelt. Toon een geruststellend wacht-scherm.
            if (res && res.pending) {
              clearStash();
              showPaymentPending();
              return;
            }
            if (res && res.ok) {
              clearStash();
              trackOnce("chat_finished_sent", "chat_finished_sent");
              showCompletion(res);
              return;
            }
            // Fout ná een geslaagde betaling. We routen NIET naar de telefoon-
            // stap (die heuristiek is voor /api/chat-validatie; hier is het een
            // betaal/backend-kwestie, en na een iDEAL-reload is de chat-state weg).
            var err = (res && res.error) || {
              message: "Er ging iets mis bij het versturen van je vraag.",
            };
            showSubmitError({
              message:
                (err.message || "Er ging iets mis.") +
                " Je betaling is gelukt — neem contact met ons op als je vraag niet doorkomt.",
            });
          }, wait);
        });
      });
    }

    // Async betaling (iDEAL) nog niet definitief; de webhook zet de intake door
    // zodra 't settelt. Geruststellend eind-scherm.
    function showPaymentPending() {
      phase = "done";
      rmTyping();
      addBot(
        "Je betaling wordt verwerkt. Zodra deze rond is, gaat je vraag automatisch naar de dierenarts en krijg je een SMS. Je hoeft niets meer te doen.",
      );
    }

    // Na terugkeer van een iDEAL-redirect. Bij SUCCES: herstel het telefoonnummer
    // en draai dezelfde afronding als de kaart-flow (finishPaid → completion-
    // scherm). Bij FAALT (redirect_status=failed): hervat de sessie — herstel het
    // gesprek en toon opnieuw een betaalvenster.
    function resumePaidReturn(paymentIntentId, redirectStatus) {
      if (!paymentIntentId) return;
      // Claim de gedeelde resume-vlag zodat een TWEEDE engine (embed: desktop +
      // mobile booten beide) niet óók de afgebroken-resume draait en een tweede
      // PI maakt/doorzet. Marker weg: deze terugkeer is afgehandeld.
      window.__vhPayResumeHandled = true;
      clearRedirectMark();
      var s = readStash() || {};
      if (s.phone) st.phone = s.phone;
      msgsEl.style.display = "";
      completeEl.classList.remove("active");
      errEl.classList.remove("active");
      if (redirectStatus === "failed") {
        // 'mislukt' uit de URL is niet gezaghebbend (en te vervalsen). Verifieer
        // de ECHTE PI-status vóór we eventueel een nieuwe PI maken — net als de
        // onbekend-status- en afgebroken-paden. Zo nooit een tweede PI terwijl de
        // oude nog kan settelen. (Bij een echte iDEAL-fail staat de PI op
        // requires_payment_method → verifyAndRoute hergebruikt diezelfde PI.)
        if (s.cs && s.pubKey && window.Stripe) {
          if (s.convo) msgsEl.innerHTML = s.convo;
          verifyAndRoute(s, PAY_FAILED_INTRO);
        } else {
          retryPaymentAfterFailure(s);
        }
        return;
      }
      // Herstel eerst het hele gesprek (zodat de gebruiker z'n chat ziet en niet
      // denkt dat alles weg is).
      if (s.convo) msgsEl.innerHTML = s.convo;
      if (redirectStatus === "succeeded") {
        // Stripe bevestigt succes → afronden richting completion-scherm.
        finishPaid(paymentIntentId);
        return;
      }
      // Leeg/onbekend redirect_status → NIET blind "gelukt" aannemen. Vraag de
      // echte status op en route veilig (net als de afgebroken-resume).
      if (s.cs && s.pubKey && window.Stripe) {
        verifyAndRoute(s, PAY_ABANDON_INTRO);
      } else {
        finishPaid(paymentIntentId);
      }
    }

    // Hervat na een MISLUKTE iDEAL-betaling: herstel het gesprek visueel en toon
    // opnieuw het betaalvenster (nieuwe PaymentIntent met dezelfde, opgeslagen
    // intake). De chat-state is na de reload weg, maar de intake staat in de stash.
    function retryPaymentAfterFailure(s, introMessage) {
      phase = "payment";
      hideAll();
      // Geforceerde scroll naar onder (negeert de smart-guard). Het herstellen
      // van het gesprek via innerHTML zet de scrollpositie op 0, dus we moeten
      // expliciet naar onderen zodat de gebruiker het nieuwe bericht + het
      // betaalvenster ziet (i.p.v. bovenaan het herstelde gesprek).
      function forceScroll() {
        requestAnimationFrame(function () {
          msgsEl.scrollTop = msgsEl.scrollHeight;
        });
      }
      if (s.convo) msgsEl.innerHTML = s.convo;
      if (!s.intake) {
        showTyping().then(function () {
          addBot(
            "De betaling is helaas niet gelukt en we konden je gegevens niet herstellen. Begin je vraag opnieuw.",
          );
          phase = "done";
          forceScroll();
        });
        return;
      }
      payBillingName = (s.intake.owner && s.intake.owner.firstName) || "";
      showTyping().then(function () {
        payAnchorEl = addBot(
          introMessage ||
            "De betaling is niet gelukt — geen zorgen, je gegevens staan nog. Je kunt het hieronder opnieuw proberen.",
        );
        forceScroll();
        createPaymentIntentReq(s.intake).then(function (res) {
          if (
            !res ||
            res.ok !== true ||
            !res.clientSecret ||
            !res.publishableKey
          ) {
            showSubmitError({
              message:
                (res && res.error && res.error.message) ||
                "De betaling kon niet opnieuw gestart worden. Probeer het later opnieuw.",
            });
            return;
          }
          stashPay(
            res.publishableKey,
            (res.clientSecret || "").split("_secret_")[0],
            s.intake,
            s.convo || snapshotConversation(),
            res.clientSecret,
          );
          // mountPaymentElement positioneert zelf (payScrollOverview): de
          // "betaling niet gelukt"-bubbel komt net bovenaan het venster, de
          // nieuwe kaart eronder — consistent met de normale betaalflow. Geen
          // eigen forceScroll meer (dat duwde naar de knop onderaan + botste
          // met de overview-positionering).
          mountPaymentElement(res);
        });
      });
    }

    // Intro-tekst bij het opnieuw tonen van de kaart na een afgebroken betaling
    // (de klant heeft niet "gefaald", alleen niet afgerond).
    var PAY_ABANDON_INTRO =
      "Je betaling is nog niet afgerond — geen zorgen, je gegevens staan nog. Kies hieronder je betaalmethode om het af te ronden.";
    // Intro bij een door Stripe bevestigde MISLUKKING (redirect_status=failed).
    var PAY_FAILED_INTRO =
      "De betaling is niet gelukt. Je vraag staat nog steeds klaar. Kies je betaalmethode om het opnieuw te proberen.";

    // Toon de betaalkaart opnieuw op DEZELFDE PaymentIntent (clientSecret uit de
    // stash). Cruciaal: één PaymentIntent kan nooit dubbel belasten — dus dit kan,
    // anders dan een NIEUWE PI maken, nooit tot een dubbele afschrijving leiden.
    // Bedrag/valuta komen uit de opgehaalde PI.
    function remountSamePayment(s, pi, introMessage) {
      phase = "payment";
      hideAll();
      if (s.convo) msgsEl.innerHTML = s.convo;
      payBillingName =
        (s.intake && s.intake.owner && s.intake.owner.firstName) || "";
      showTyping().then(function () {
        payAnchorEl = addBot(introMessage);
        requestAnimationFrame(function () {
          msgsEl.scrollTop = msgsEl.scrollHeight;
        });
        mountPaymentElement({
          publishableKey: s.pubKey,
          clientSecret: s.cs,
          amount: pi.amount,
          currency: pi.currency,
        });
      });
    }

    // Vraag de ECHTE PI-status bij Stripe op (Stripe.js retrievePaymentIntent) en
    // route veilig. Gedeeld door de afgebroken-resume én de legitieme terugkeer met
    // onbekende redirect_status. NOOIT een tweede PI voor een PI die nog kan
    // settelen → geen dubbele charge.
    //   - succeeded / processing                        → afronden (idempotente forward).
    //   - requires_payment_method/_confirmation/_action → DEZELFDE PI hergebruiken
    //                                                      (kaart opnieuw; nooit dubbel).
    //   - canceled                                      → PI is dood → veilig nieuwe PI.
    //   - onbekend / Stripe onbereikbaar                → kort retryen, dan een veilig
    //                                                      niet-ladend bericht; geen PI.
    function verifyAndRoute(s, introMessage) {
      function scrollDown() {
        requestAnimationFrame(function () {
          msgsEl.scrollTop = msgsEl.scrollHeight;
        });
      }
      function uncertainTerminal() {
        rmTyping();
        phase = "done";
        addBot(
          "We konden je betaling nog niet bevestigen. Heb je al betaald? Dan komt je vraag automatisch bij de dierenarts zodra de betaling rond is — je hoeft niets te doen. Lukt het niet? Herlaad de pagina om het opnieuw te proberen.",
        );
        scrollDown();
      }
      var vStripe;
      try {
        vStripe = vhStripeOnce(s.pubKey);
      } catch (e) {
        vStripe = null;
      }
      if (!vStripe || !s.cs) {
        uncertainTerminal();
        return;
      }
      // Direct een indicator zodat de check niet als een "bevroren" gesprek oogt.
      showTyping().then(function () {
        addBot("Even je betaling controleren...");
        scrollDown();
        verify(1);
      });
      function verify(attempt) {
        vStripe
          .retrievePaymentIntent(s.cs)
          .then(function (result) {
            var pi = result && result.paymentIntent;
            var status = pi && pi.status;
            if (status === "succeeded" || status === "processing") {
              // Echt betaald / aan het settelen → afronden (idempotente forward).
              rmTyping();
              finishPaid(s.piId);
              return;
            }
            if (
              status === "requires_payment_method" ||
              status === "requires_confirmation" ||
              status === "requires_action"
            ) {
              // PI leeft nog (niet voltooid, maar ook niet dood) → DEZELFDE PI
              // hergebruiken. requires_action kan een net-geautoriseerde iDEAL zijn
              // die zo settelt; een nieuwe PI zou die dubbel belasten — hergebruik
              // niet (één PI = max. één charge).
              rmTyping();
              remountSamePayment(s, pi, introMessage);
              return;
            }
            if (status === "canceled") {
              // PI definitief dood (nooit belast) → veilig een nieuwe PI maken.
              rmTyping();
              retryPaymentAfterFailure(s, introMessage);
              return;
            }
            // Onbekende/lege status (bv. requires_capture) → onzeker.
            uncertain(attempt);
          })
          .catch(function () {
            // Stripe onbereikbaar → onzeker.
            uncertain(attempt);
          });
      }
      function uncertain(attempt) {
        if (attempt < 3) {
          // Korte auto-retry; netwerk hapert vaak net na een bank-redirect.
          setTimeout(function () {
            verify(attempt + 1);
          }, 1500 * attempt);
          return;
        }
        // Status blijft onzeker → NOOIT een nieuwe PI maken (dubbele-charge-risico).
        // De stash blijft staan zodat de webhook de intake alsnog doorzet als de
        // betaling toch settelt.
        uncertainTerminal();
      }
    }

    // Hervat een AFGEBROKEN redirect-betaling: er staat een stash, de redirect-vlag
    // stond (er is dus écht een iDEAL-redirect gestart), maar de klant kwam NIET via
    // de normale Stripe-terugweg terug (bv. browser-terug vanaf de bank). We checken
    // de echte status (verifyAndRoute) en maken nooit zomaar een tweede PI.
    function resumeAbandonedPayment(s) {
      // Zonder pubKey+clientSecret (of zonder Stripe.js) kunnen we de status niet
      // veilig checken — dan NIET hervatten; val terug op de normale intro. Geldt
      // alleen voor oude stashes; deze build schrijft cs altijd mee.
      if (!s || !s.piId || !s.cs || !s.pubKey || !window.Stripe) {
        clearStash();
        return false;
      }
      // Eén pad per page-life mag een betaling hervatten (embed-modus kan desktop-
      // én mobile-engine tegelijk booten; gedeeld met resumePaidReturn). Zonder dit
      // zouden twee engines elk een PI kunnen maken/doorzetten.
      if (window.__vhPayResumeHandled) return false;
      window.__vhPayResumeHandled = true;

      startedAt = new Date();
      phase = "submitting";
      hideAll();
      msgsEl.style.display = "";
      completeEl.classList.remove("active");
      errEl.classList.remove("active");
      // Gesprek alvast terug zodat de klant z'n chat ziet tijdens de status-check.
      if (s.convo) msgsEl.innerHTML = s.convo;
      verifyAndRoute(s, PAY_ABANDON_INTRO);
      return true;
    }

    function submitPaidIntakeReq(paymentIntentId) {
      var controller =
        typeof AbortController !== "undefined" ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () {
            controller.abort();
          }, 15000)
        : null;
      return fetch(config.submitPaidUrl, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        cache: "no-store",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ paymentIntentId: paymentIntentId }),
        signal: controller ? controller.signal : undefined,
      })
        .then(function (r) {
          if (timer) clearTimeout(timer);
          return r.json().catch(function () {
            return null;
          });
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          return {
            ok: false,
            error: {
              code: "BACKEND_UNAVAILABLE",
              message: "Geen verbinding na betaling.",
            },
          };
        });
    }

    function formatPhoneForDisplay(p) {
      var n = normalizePhone(p);
      if (!n) return "06 ...";
      // NL-nummers tonen we in vertrouwde 06-vorm met spaties.
      if (n.startsWith("+31")) {
        var nl = "0" + n.slice(3);
        return nl.length === 10
          ? nl.slice(0, 2) + " " + nl.slice(2, 6) + " " + nl.slice(6)
          : nl;
      }
      // Andere landen: hou + en split na de eerste 3 cijfers van nationale deel
      // voor leesbaarheid. Geen gok over country-specifieke groepering.
      var m = n.match(/^(\+\d{1,3})(\d+)$/);
      if (m) {
        var rest = m[2];
        if (rest.length > 3) {
          rest = rest.slice(0, 3) + " " + rest.slice(3);
        }
        return m[1] + " " + rest;
      }
      return n;
    }

    function send() {
      if (submitting || phase === "submitting") return;
      var val = inpEl.value.trim();
      if (!val) return; // foto's reizen silent mee — pure send vereist tekst
      addUser(val);
      inpEl.value = "";
      // Reset hoogte zodat na verzenden de balk weer 1-regel hoog is
      inpEl.style.height = "";
      // Char-counter reset (programmatic value-reset triggert geen input-
      // event, dus updateCharCounter wordt niet auto-aangeroepen).
      updateCharCounter();
      if (phase === "llm_fu_text") {
        // V2 follow-up tekst-antwoord
        recordUserInput(val); // pendingFollowUp set, opslaan als qaPair
        llmFollowUpIndex++;
        askNextLlmFollowUp();
        return;
      }
      if (phase === "extra_text") {
        // Open invulveld na "Ja" op een extra-vraag
        recordUserInput(val); // pendingFollowUp staat → qaPair update
        extraStep++;
        runExtra();
        return;
      }
      if (
        phase === "question" ||
        phase === "clarify" ||
        phase === "clarify_option"
      ) {
        handleQuestion(val);
      } else if (phase === "admin") {
        var step = ADMIN_STEPS[adminStep];
        if (step.validate && !step.validate(val)) {
          showTyping().then(function () {
            addBot(step.err);
          });
          return;
        }
        // Namen altijd in title-case opslaan: "max" → "Max", "JAN" → "Jan"
        if (step.key === "petName" || step.key === "ownerName") {
          val = titleCaseName(val);
        }
        st[step.key] = val;
        adminStep++;
        runAdmin();
      }
    }

    // Gebruik mousedown/touchstart i.p.v. click voor de send-knop op mobile:
    // op iOS Safari fires de click ná blur, waardoor het toetsenbord een
    // moment dichtklapt. preventDefault op mousedown houdt de focus in de
    // textarea → toetsenbord blijft staan tussen messages door → veel smoothere
    // ervaring. We laten ook een click-handler staan voor toegankelijkheid.
    function handleSendPress(e) {
      e.preventDefault(); // voorkom focus-shift naar de button
      send();
    }
    sndBtn.addEventListener("mousedown", handleSendPress);
    sndBtn.addEventListener("touchstart", handleSendPress, { passive: false });
    sndBtn.addEventListener("click", function (e) {
      e.preventDefault();
    });
    inpEl.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        send();
      }
    });
    inpEl.addEventListener("input", autoGrow);
    if (retryBtn) {
      retryBtn.addEventListener("click", function () {
        // Als de fout aan het telefoonnummer lag (validatie OF duplicate),
        // stuur de user terug naar die stap in plaats van blind dezelfde
        // payload opnieuw te POST'en. Dezelfde payload geeft dezelfde fout
        // → eindeloze loop (V2-feedback Sander 2026-05-26).
        if (isPhoneRelatedError(lastError) && resetToPhoneStep(lastError))
          return;

        // Alle andere fouten (BACKEND_UNAVAILABLE, RATE_LIMITED, generic VALIDATION_FAILED):
        // retry de submit met dezelfde payload. Bij rate-limit krijg je dezelfde fout terug.
        errEl.classList.remove("active");
        msgsEl.style.display = "";
        finish();
      });
    }
    // FAQ "Stel een vraag"-knop: reset chat-state en herstart de flow.
    if (faqRestartBtn) {
      faqRestartBtn.addEventListener("click", restartFromFaq);
    }

    // ── Annuleer mijn vraag ────────────────────────────────────────────
    // FEATURE STATUS (v1, 2026-05): elementen worden NIET gerendered tenzij
    // de theme-setting `enable_cancel_button` aan staat (Shopify-liquid), of
    // de cancel-template handmatig in de DOM is gezet (embed widget). De
    // handlers hieronder zijn defensief — `if (cancelBtn)` zorgt dat alles
    // stil overslaat als de knop ontbreekt. Niets uit deze code is dood:
    // backend-endpoint /api/cancel staat live, CSS in hero-chat.css staat
    // gereed, alle JS hier werkt zodra de elementen aanwezig zijn.
    //
    // Vanuit het completion-scherm: 1) klik op "Annuleer mijn vraag",
    // 2) kies reden (Tijdsgebrek / Verkeerde vraag / Niet meer relevant) of ga terug.
    // De reden wordt naar de proxy gestuurd via /api/cancel (best-effort, faalt
    // stil als endpoint nog niet bestaat) en de UI toont een bevestigings-state.
    if (cancelBtn) {
      cancelBtn.addEventListener("click", function () {
        if (cancelPane) cancelPane.classList.add("active");
        if (cancelBtn) cancelBtn.style.display = "none";
      });
    }
    if (cancelBackBtn) {
      cancelBackBtn.addEventListener("click", function () {
        if (cancelPane) cancelPane.classList.remove("active");
        if (cancelBtn) cancelBtn.style.display = "";
      });
    }
    Array.prototype.forEach.call(cancelReasonBtns || [], function (btn) {
      btn.addEventListener("click", function () {
        var reason = btn.getAttribute("data-cancel-reason") || "";
        submitCancel(reason);
      });
    });

    function submitCancel(reason) {
      // GA4: cancel-event. Reden wordt meegestuurd zodat we per reason
      // kunnen segmenteren in GA4. trackOnce zodat dubbel-tappen van een
      // cancel-knop niet 2x als cancellation telt.
      trackOnce("chat_cancelled", "chat_cancelled", {
        cancel_reason: String(reason || "").slice(0, 60),
      });
      // Probeer een cancel-signaal te POSTen naar dezelfde origin als de proxy.
      // Het endpoint is /api/cancel, parallel aan /api/chat. Als 't (nog) niet
      // bestaat (404/CORS), gaan we toch door met de UI-confirmatie zodat de
      // gebruiker het gevoel heeft dat zijn annulering verwerkt is.
      var cancelUrl = "";
      if (config.proxyUrl) {
        try {
          cancelUrl = config.proxyUrl.replace(/\/api\/chat$/, "/api/cancel");
        } catch (_) {
          cancelUrl = "";
        }
      }
      if (cancelUrl && typeof fetch === "function") {
        try {
          fetch(cancelUrl, {
            method: "POST",
            mode: "cors",
            credentials: "omit",
            cache: "no-store",
            keepalive: true,
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
              sessionId: sessionId,
              reason: String(reason || "").slice(0, 60),
              source: config.source || "vetts.app",
              cancelledAt: new Date().toISOString(),
              target: config.env === "prod" ? "prod" : "dev",
            }),
          }).catch(function () {
            /* stil falen */
          });
        } catch (_) {
          /* stil falen */
        }
      }
      if (cancelPane) cancelPane.classList.remove("active");
      if (cancelDone) cancelDone.classList.add("active");
      // Verberg overbodige info zodat alleen de bevestiging zichtbaar is.
      var hideEls = root.querySelectorAll(
        ".vh-wc-top, .vh-wc-card, .vh-wc-steps, .vh-wc-sms, .vh-wc-emer",
      );
      Array.prototype.forEach.call(hideEls, function (el) {
        el.style.display = "none";
      });
    }

    function start(initialQ) {
      // v2_payment: terugkeer van een iDEAL-redirect → sla de normale intro over
      // en hervat direct de betaal-doorzet (vlag gezet door bindSection).
      try {
        if (window.__vhPayReturnPiId) {
          var _pid = window.__vhPayReturnPiId;
          var _pstatus = window.__vhPayReturnStatus || "";
          window.__vhPayReturnPiId = "";
          window.__vhPayReturnStatus = "";
          startedAt = new Date();
          resumePaidReturn(_pid, _pstatus);
          return Promise.resolve();
        }
      } catch (e) {}
      // v2_payment: GEEN Stripe-terugkeer, maar wél een nog-niet-afgeronde
      // betaling in de stash (browser-terug vanaf iDEAL of een reload midden in
      // de betaling) → herstel het gesprek en toon opnieuw de betaalkaart i.p.v.
      // de normale intro, zodat de klant z'n gegevens terugziet en (een andere)
      // betaalmethode kan kiezen.
      try {
        if (config.paymentEnabled) {
          var _redirected = false;
          try {
            _redirected = sessionStorage.getItem(PAY_REDIRECT_KEY) === "1";
          } catch (e) {}
          var _resumeStash = readStash();
          // Alleen hervatten als er ECHT een redirect-betaling liep (vlag), de
          // stash compleet is (piId + intake + clientSecret) én recent genoeg.
          if (
            _redirected &&
            _resumeStash &&
            _resumeStash.piId &&
            _resumeStash.intake &&
            _resumeStash.cs
          ) {
            // Ontbrekende ts = oude/onbekende stash → behandel als te oud.
            var _stashAge = _resumeStash.ts
              ? Date.now() - _resumeStash.ts
              : Infinity;
            if (_stashAge >= 0 && _stashAge < PAY_RESUME_MAX_AGE_MS) {
              if (resumeAbandonedPayment(_resumeStash))
                return Promise.resolve();
            } else {
              clearStash(); // te oud → gewoon de normale intro
            }
          }
        }
      } catch (e) {}
      startedAt = new Date();
      progBar.style.width = "5%";
      return showTyping()
        .then(function () {
          addBot("Welkom! Waar kunnen we jou en je huisdier mee helpen?");
          return showTyping();
        })
        .then(function () {
          addBot(
            "We stellen daarna een paar aanvullende vragen en sturen alles direct door naar een ervaren dierenarts.",
          );
          phase = "question";
          showInput("Beschrijf hier je vraag...");
          progBar.style.width = "10%";
          if (initialQ && initialQ.trim()) {
            setTimeout(function () {
              addUser(initialQ.trim());
              handleQuestion(initialQ.trim());
            }, 300);
          }
        });
    }

    return { start: start, resumePaidReturn: resumePaidReturn };
  }

  // ═══ PAGE INIT ════════════════════════════════════════════════════════
  function init() {
    var sections = document.querySelectorAll("[data-vh-hero]");
    if (!sections.length) return;
    sections.forEach(function (section) {
      bindSection(section);
    });
  }

  // Selectors voor third-party sticky-button widgets die we permanent willen
  // verbergen op pagina's met de hero-chat. Vetts wil dat hun eigen chat de
  // primaire CTA is — een WhatsApp-button of Download-app-button daarnaast
  // splitst aandacht. Werkt aanvullend op de :has()-CSS-regels.
  var STICKY_BUTTON_SELECTORS = [
    '[class*="dondy" i]',
    '[id*="dondy" i]',
    '[data-app="dondy"]',
    '[class*="whatsapp-button" i]',
    '[class*="wa-button" i]',
    '[class*="download-app" i]',
    '[class*="app-download" i]',
    'iframe[src*="dondy"]',
    'iframe[src*="whatsapp"]',
  ];

  function hideStickyMatches() {
    STICKY_BUTTON_SELECTORS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          // Behoud onze eigen FAB en chat-elementen
          if (el.closest && el.closest("[data-vh-hero]")) return;
          if (el.getAttribute("data-vh-hidden") === "1") return;
          el.setAttribute("data-vh-hidden", "1");
          el.style.setProperty("display", "none", "important");
        });
      } catch (_) {
        /* selector-fail op oude browsers, negeer */
      }
    });
  }

  var stickyHiderInstalled = false;
  function installStickyButtonHider() {
    if (stickyHiderInstalled) return;
    stickyHiderInstalled = true;
    hideStickyMatches();
    // Sommige widgets (Dondy, Shopify-app FABs) injecten zichzelf laat of
    // re-appenden zich bij route-changes. Een MutationObserver pakt die later
    // ingevoegde nodes op.
    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function (mutations) {
        var needRecheck = false;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            needRecheck = true;
            break;
          }
        }
        if (needRecheck) hideStickyMatches();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function bindSection(section) {
    var config = {
      proxyUrl: section.getAttribute("data-proxy-url") || "",
      analyzeUrl: section.getAttribute("data-analyze-url") || "",
      source: section.getAttribute("data-source") || "vetts.app",
      mode: section.getAttribute("data-chat-mode") || "llm-v2",
      env: section.getAttribute("data-env") || "",
      // GA4 alleen versturen als de liquid 'true' meegeeft (= prod + toggle aan).
      // Dev geeft hier altijd 'false' → harde garantie: geen events in dev.
      ga4Send: section.getAttribute("data-ga4-send") === "true",
      waitDayStart: section.getAttribute("data-wait-day-start") || "07:00",
      waitDayEnd: section.getAttribute("data-wait-day-end") || "23:00",
      waitDayText: section.getAttribute("data-wait-day-text") || "12 min",
      waitNightText: section.getAttribute("data-wait-night-text") || "30 min",
      ga4MeasurementId: section.getAttribute("data-ga4-measurement-id") || "",
      ga4DefaultSource:
        section.getAttribute("data-ga4-default-source") || "direct",
      ga4Version: section.getAttribute("data-ga4-version") || "v2",
      // v2_payment: Stripe embedded betaling.
      paymentEnabled: section.getAttribute("data-payment-enabled") === "true",
      createPaymentUrl: section.getAttribute("data-create-payment-url") || "",
      submitPaidUrl: section.getAttribute("data-submit-paid-url") || "",
      // Bannerbeelden voor de betaalkaart (theme-assets via asset_url). Leeg
      // = val terug op de CSS-recreatie van het blok.
      promoImg: section.getAttribute("data-pc-promo-img") || "",
      reviewImg: section.getAttribute("data-pc-review-img") || "",
    };

    // DEV-omgeving: markeer <html> zodat de CSS een oranje randje om de
    // chat-card zet (duidelijk visueel onderscheid dev vs prod).
    if (config.env === "dev") {
      document.documentElement.classList.add("vh-env-dev");
    }

    // v2_payment: detecteer een terugkeer van een iDEAL-redirect (vóór de chat
    // boot). Stripe hangt ?payment_intent & ?payment_intent_client_secret &
    // ?redirect_status aan de return_url. We zetten een vlag die start() oppakt
    // om de normale intro over te slaan en de betaling te hervatten.
    var _payReturnMobileOpen = false;
    if (config.paymentEnabled) {
      // Safari's back-forward-cache (bfcache) herstelt de pagina UIT GEHEUGEN
      // zonder de scripts opnieuw te draaien. Een eerder gemount Stripe Payment
      // Element is na zo'n restore KAPOT → de betaalopties blijven eeuwig in
      // skeleton hangen. Dit is precies de bug: "na betalen + terugkeren/refresh
      // in Safari laden de opties niet meer; een dag later (nieuwe sessie) wel".
      // Stripe's advies: herlaad de pagina bij een bfcache-restore. We doen dat
      // alleen als er in dit page-leven al een betaalvenster getoond is (anders
      // is er niks kapot om te herstellen).
      if (!window.__vhBfcacheBound) {
        window.__vhBfcacheBound = true;
        window.addEventListener("pageshow", function (e) {
          if (e.persisted && window.__vhPaymentMounted) {
            window.location.reload();
          }
        });
      }
      var _pp = null;
      try {
        _pp = new URLSearchParams(window.location.search);
      } catch (e) {}
      if (_pp && _pp.get("payment_intent_client_secret")) {
        var _stash = null;
        try {
          _stash = JSON.parse(sessionStorage.getItem(PAY_STASH_KEY) || "null");
        } catch (e) {}
        var _piId = _pp.get("payment_intent") || (_stash && _stash.piId) || "";
        var _pstatus = _pp.get("redirect_status") || "";
        // Stripe-params uit de URL halen zodat een refresh niet opnieuw triggert.
        try {
          var _u = new URL(window.location.href);
          [
            "payment_intent",
            "payment_intent_client_secret",
            "redirect_status",
            "source_type",
          ].forEach(function (k) {
            _u.searchParams.delete(k);
          });
          window.history.replaceState(
            {},
            document.title,
            _u.pathname + _u.search + _u.hash,
          );
        } catch (e) {}
        if (_piId) {
          window.__vhPayReturnPiId = _piId;
          window.__vhPayReturnStatus = _pstatus;
          _payReturnMobileOpen = true;
        }
      } else {
        // GEEN Stripe-terugkeer, maar mogelijk een AFGEBROKEN redirect-betaling
        // in de stash (bv. browser-terug vanaf de iDEAL-pagina). Op mobiel is er
        // geen auto-boot → open de chat zelf zodat start() de kaart herstelt.
        // Zelfde voorwaarden als de start()-guard: redirect-vlag + complete +
        // recente stash (anders geen onverwachte auto-open).
        try {
          var _redirected = sessionStorage.getItem(PAY_REDIRECT_KEY) === "1";
          var _abStash = JSON.parse(
            sessionStorage.getItem(PAY_STASH_KEY) || "null",
          );
          if (
            _redirected &&
            _abStash &&
            _abStash.piId &&
            _abStash.intake &&
            _abStash.cs
          ) {
            var _abAge = _abStash.ts ? Date.now() - _abStash.ts : Infinity;
            if (_abAge >= 0 && _abAge < PAY_RESUME_MAX_AGE_MS) {
              _payReturnMobileOpen = true;
            }
          }
        } catch (e) {}
      }
    }

    // ── GA4 setup ────────────────────────────────────────────────────────
    // Bepaal de user-source eenmalig bij init zodat alle events 'm meekrijgen.
    // URL-param ?source=X wint (handig voor partner-attributie: Univé/OHRA
    // hebben elk hun eigen landing-URL). Anders fallback op section-setting.
    var ga4Source = (function () {
      try {
        var p = new URLSearchParams(window.location.search);
        var s = p.get("source");
        if (s) return s.slice(0, 60); // Cap voor GA4 (custom dim max 100 chars)
      } catch (_) {
        /* IE / extreme oude browser: window.URLSearchParams ontbreekt */
      }
      return config.ga4DefaultSource || "direct";
    })();

    // Als de section een measurementId heeft EN gtag nog niet geladen is,
    // laden we 'm zelf. Zonder measurementId vertrouwen we op een al-aanwezige
    // gtag op de pagina (komt 95% van de tijd via Shopify's Google channel).
    if (
      config.ga4Send &&
      config.ga4MeasurementId &&
      typeof window.gtag !== "function"
    ) {
      var s = document.createElement("script");
      s.async = true;
      s.src =
        "https://www.googletagmanager.com/gtag/js?id=" +
        encodeURIComponent(config.ga4MeasurementId);
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", config.ga4MeasurementId, {
        // Stuur GEEN page_view automatisch — die meet Shopify al via z'n eigen
        // GA-integratie. Wij voegen alleen funnel-events toe.
        send_page_view: false,
      });
    }

    // Centraal event-helper: één codepad voor alle event-fires. Voegt altijd
    // de source toe. Zwijgt veilig als gtag ontbreekt (bv. adblock) — dan
    // pushen we naar dataLayer zodat een GTM/SST-setup 'm later alsnog kan
    // doorgeven.
    function vetGA(eventName, params) {
      if (!eventName) return;
      // DEV (of GA4-toggle uit): NOOIT events versturen — niet via gtag én niet
      // via de dataLayer. Harde garantie dat er geen testverkeer in GA4 komt.
      if (!config.ga4Send) return;
      // vetts_source = herkomst/partner (ff_website, ff_unive, ...).
      // vetts_version = welke Fast-Funnel-versie ('v2' = deze betaalflow), zodat
      // je V1 en V2 in GA4 los kunt vergelijken zonder de source te vervuilen.
      var enriched = Object.assign(
        { vetts_source: ga4Source, vetts_version: config.ga4Version || "v2" },
        params || {},
      );
      try {
        if (typeof window.gtag === "function") {
          window.gtag("event", eventName, enriched);
          return;
        }
        // Fallback: GTM dataLayer-style push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, enriched));
      } catch (_) {
        /* analytics-failures mogen NOOIT user-flow breken */
      }
    }
    // Expose op config zodat createChatEngine 'm kan oproepen.
    config.vetGA = vetGA;
    config.ga4Source = ga4Source;

    // (Stat 3 is sinds 2026-05 een statische "365 / Dagen per jaar" en bindt
    // niet meer aan de dynamische wait-time. De wait-time logica leeft alleen
    // nog in het completion-scherm via pickWaitTimeText.)

    // Verberg third-party sticky buttons (Dondy WhatsApp, Shopify download-app)
    // permanent op pagina's met de hero-chat. CSS doet dit ook via :has(), maar
    // deze JS-versie werkt ook op browsers zonder :has()-support en pakt nieuw
    // ingevoegde widgets op (DOM-mutaties).
    if (section.classList.contains("hide-sticky-button")) {
      installStickyButtonHider();
    }

    if (!config.proxyUrl && window.console) {
      console.warn(
        "[vetts-hero-chat] Geen proxy-URL ingesteld in de theme-editor. Submissions zullen falen.",
      );
    }
    if (config.mode === "llm-v2" && !config.analyzeUrl && window.console) {
      console.warn(
        "[vetts-hero-chat] V2 mode actief maar geen analyze-URL — val automatisch terug op V1 bij eerste vraag.",
      );
    }

    // Desktop: auto-start wanneer in beeld (alleen bij grote viewport)
    var desktopWrap = section.querySelector('[data-chat-wrap="desktop"]');
    var desktopEngine = null;
    // EMBED-mode (data-embed="1" op section): hero-chat draait in een iframe
    // op een 3rd-party site. We willen dan de chat ALTIJD direct booten,
    // ongeacht viewport-grootte (iframe is mobile-sized maar moet starten).
    var isEmbed = section.getAttribute("data-embed") === "1";

    function bootDesktop() {
      if (desktopEngine || !desktopWrap) return;
      if (!isEmbed && isMobile()) return;
      // Een betaling-resume claimt deze page-life al (bv. mobiel hervat → draai
      // naar desktop, of embed dual-boot) → geen tweede engine met een verse chat
      // naast de lopende betaling.
      if (window.__vhPayResumeHandled) return;
      desktopEngine = createChatEngine(desktopWrap, config);
      desktopEngine.start("");
      // GA4: op desktop is de chat direct zichtbaar (geen klik-trigger).
      // Sander's funnel start op desktop dus pas bij chat_started (eerste
      // user-message). We fire'n hier GEEN event meer.
    }
    bootDesktop();

    // ── Beschikbare hoogte berekenen ───────────────────────────────────
    // Hero zit ONDER de Shopify-site-header (VETTS-logo, nav, etc.). Pure
    // CSS `max-height: 100vh` houdt geen rekening met die header, waardoor
    // op kleinere laptop-schermen de chat-bottom (input-rij) onder de fold
    // valt. We meten daarom de werkelijke afstand tussen viewport-top en
    // hero-top, en gebruiken het verschil als de echt-beschikbare hoogte.
    // Update bij resize zodat browser-window-resize en mobile-rotatie ook
    // correct meeschalen.
    function syncAvailableHeight() {
      // Op mobile geldt de constraint niet (geen 100vh-max op de hero) —
      // CSS-rule zit alleen achter min-width: 768px. Skippen scheelt
      // onnodige reflows tijdens de mobile keyboard-resize-events.
      if (
        window.matchMedia &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        section.style.removeProperty("--vh-available-height");
        return;
      }
      var rect = section.getBoundingClientRect();
      // Top kan negatief worden zodra de user voorbij de hero scrolt; clampen
      // naar 0 zodat de berekening niet plotseling kleiner wordt.
      var topOffset = Math.max(0, rect.top);
      var available = window.innerHeight - topOffset;
      // Sanity-check: extreem kleine waardes (bv. tijdens een transitie)
      // negeren we — chat moet niet ineens naar 100px krimpen.
      if (available < 360) return;
      section.style.setProperty("--vh-available-height", available + "px");
    }
    syncAvailableHeight();
    // Re-meten bij resize én bij scroll-anchor wijzigingen. We gebruiken
    // requestAnimationFrame om resize-storms (window-drag) niet de browser
    // te laten verstoppen met layout-thrashing.
    var availHeightRaf = 0;
    function scheduleSyncAvailableHeight() {
      if (availHeightRaf) return;
      availHeightRaf = requestAnimationFrame(function () {
        availHeightRaf = 0;
        syncAvailableHeight();
      });
    }
    window.addEventListener("resize", scheduleSyncAvailableHeight, {
      passive: true,
    });
    // Bij window resize (bijv. rotatie) eventueel alsnog booten.
    window.addEventListener(
      "resize",
      function () {
        if (!desktopEngine && (isEmbed || !isMobile())) bootDesktop();
      },
      { passive: true },
    );

    // Mobile triggers (FAB + hero-CTA) → overlay
    var fab = section.querySelector("[data-chat-fab]");
    var heroCta = section.querySelector("[data-chat-fab-alt]");
    var overlay = section.querySelector("[data-chat-overlay]");
    var closeBtn = section.querySelector("[data-chat-close]");

    // ── FAB show/hide-on-scroll (per V2-feedback Sander) ───────────────
    // FAB start onzichtbaar (CSS-default). Gedrag:
    //   - scrollY ≥ 150px  → FAB tonen (eerste keer met 700ms delay zodat
    //     hij niet meteen opdringerig verschijnt; daarna instant want de
    //     user heeft 'm al gezien)
    //   - scrollY < 150px  → FAB direct verbergen (user is terug bij de
    //     hero waar de pill al staat)
    var fabShownOnce = false;
    var fabShowTimer = 0;
    var FAB_SCROLL_THRESHOLD_PX = 150;
    var FAB_SHOW_DELAY_MS = 700;
    function updateFabVisibility() {
      if (!fab) return;
      // Overlay open? CSS verbergt de FAB al via :has(); we hoeven niets
      // te doen. Skippen voorkomt class-toggles tijdens chat-gebruik.
      if (overlay && overlay.classList.contains("open")) return;
      var sy = window.scrollY || window.pageYOffset || 0;
      var shouldShow = sy >= FAB_SCROLL_THRESHOLD_PX;
      if (shouldShow) {
        if (fab.classList.contains("visible")) return;
        if (fabShowTimer) return;
        var delay = fabShownOnce ? 0 : FAB_SHOW_DELAY_MS;
        fabShowTimer = setTimeout(function () {
          fabShowTimer = 0;
          if (overlay && overlay.classList.contains("open")) return;
          // Final scroll-check — user kan in deze 700ms alweer terug naar boven
          // gescrolled zijn, dan willen we 'm NIET alsnog tonen.
          var now = window.scrollY || window.pageYOffset || 0;
          if (now < FAB_SCROLL_THRESHOLD_PX) return;
          fab.classList.add("visible");
          fabShownOnce = true;
        }, delay);
      } else {
        // Naar boven gescrolled → direct verbergen + eventuele delay-
        // timer cancellen (anders verschijnt FAB alsnog na de 700ms).
        if (fabShowTimer) {
          clearTimeout(fabShowTimer);
          fabShowTimer = 0;
        }
        fab.classList.remove("visible");
      }
    }
    window.addEventListener("scroll", updateFabVisibility, { passive: true });
    var mobileWrap = section.querySelector('[data-chat-wrap="mobile"]');
    var mobileEngine = null;

    // PORTALING: verplaats overlay naar <body> zodat z-index/stacking werkt
    // ongeacht wat de Shopify-theme of geinjecteerde widgets (WhatsApp, Download-app)
    // doen aan stacking-contexts of fixed positioning. Idem voor de FAB —
    // sommige Shopify-themes wrappen alles in containers met transforms/filters
    // die fixed-positioning binnen scopen tot die container.
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    if (fab && fab.parentNode !== document.body) {
      document.body.appendChild(fab);
    }

    // ── iOS Safari keyboard handling ─────────────────────────────────
    // Vroegere implementatie ging overlay-resize doen op visualViewport-
    // events. Dat gaf glitches: tijdens keyboard-animaties krimpt de overlay
    // frame-by-frame waardoor onder de overlay de Vetts-pagina doorheen
    // schemert (rubber-band, bottom-URL-balk, etc.).
    //
    // Nieuwe aanpak: overlay BLIJFT 100dvh (volledige viewport). We schrijven
    // alleen een CSS-var `--vh-kb-h` met de keyboard-hoogte. De inner content
    // heeft `padding-bottom: var(--vh-kb-h)` zodat de input-rij omhoog
    // geduwd wordt. Geen layout-jumps, geen gaps, geen rubber-band.
    var kbRafId = 0;
    var prevKbH = 0; // vorige keyboard-hoogte — om het OPENEN te detecteren
    function updateKeyboardInset() {
      if (!overlay || !overlay.classList.contains("open")) return;
      var vv = window.visualViewport;
      if (!vv) {
        overlay.style.setProperty("--vh-kb-h", "0px");
        prevKbH = 0;
        return;
      }

      // ── Safety net #1: focus-check ──────────────────────────────────
      // Op iOS Safari is het toetsenbord ALLEEN open als er een input/
      // textarea focus heeft. visualViewport.resize-events worden helaas
      // niet altijd betrouwbaar gevuurd bij keyboard-close (vooral na
      // "Done"-tap of programmatic blur). Daardoor blijft de oude
      // kb-hoogte hangen → knoppen staan halverwege het scherm zonder
      // dat het toetsenbord nog open is. Door eerst op activeElement te
      // checken garanderen we dat we altijd terug naar 0 vallen zodra
      // geen input meer focus heeft.
      var ae = document.activeElement;
      var hasInputFocus =
        ae &&
        overlay.contains(ae) &&
        (ae.tagName === "INPUT" || ae.tagName === "TEXTAREA");
      if (!hasInputFocus) {
        overlay.style.setProperty("--vh-kb-h", "0px");
        prevKbH = 0;
        return;
      }

      // Verschil tussen layout-viewport en visual-viewport = keyboard hoogte.
      // offsetTop houden we erbij voor het geval iOS visual viewport ook
      // vertikaal verschuift (zelden, maar gebeurt bij sommige rotaties).
      var diff = window.innerHeight - vv.height - (vv.offsetTop || 0);
      // Drempel van 100px filtert URL-balk-transities (die geven 30-50px
      // verschil) zonder echte keyboard-events (300-400px) te missen.
      var kbH = diff > 100 ? diff : 0;
      overlay.style.setProperty("--vh-kb-h", kbH + "px");

      // Houd de chat-messages aan de bottom geplakt ALLEEN wanneer de user al
      // (vrijwel) onderaan zat, óf op het exacte moment dat het toetsenbord
      // opengaat (zodat het laatste bericht boven het toetsenbord komt). We
      // forceren NIET continu zolang een input focus heeft — dat duwde de
      // gebruiker meteen terug naar onder zodra die omhoog probeerde te scrollen.
      var msgs = overlay.querySelector(".vh-wmsgs");
      if (msgs) {
        var nearBottom =
          msgs.scrollHeight - msgs.scrollTop - msgs.clientHeight < 120;
        var keyboardJustOpened = prevKbH < 100 && kbH >= 100;
        if (nearBottom || keyboardJustOpened) {
          msgs.scrollTop = msgs.scrollHeight;
        }
      }
      prevKbH = kbH;
    }
    function scheduleKeyboardInset() {
      if (kbRafId) return;
      kbRafId = requestAnimationFrame(function () {
        kbRafId = 0;
        updateKeyboardInset();
      });
    }
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", scheduleKeyboardInset);
      window.visualViewport.addEventListener("scroll", scheduleKeyboardInset);
    }
    // ── Safety net #2: window resize fallback ────────────────────────
    // Op sommige iOS-versies vuurt window.resize wèl bij keyboard-close
    // terwijl visualViewport.resize stil blijft. Goedkope back-up.
    window.addEventListener("resize", scheduleKeyboardInset);

    // ── Safety net #3: focusout listener ─────────────────────────────
    // Wanneer een input/textarea blur'd, sluit het toetsenbord op iOS.
    // We schedulen meerdere updates op verschillende delays omdat het
    // tijdstip waarop iOS de viewport heeft hersteld varieert tussen
    // ~50ms en ~400ms na blur.
    overlay.addEventListener("focusout", function () {
      updateKeyboardInset();
      setTimeout(updateKeyboardInset, 100);
      setTimeout(updateKeyboardInset, 300);
      setTimeout(updateKeyboardInset, 600);
    });

    // ── Safety net #4: polling loop ──────────────────────────────────
    // Als láátste vangnet: terwijl de overlay open is checken we elke
    // 250ms of de kb-state nog klopt. Cheap (één property-read + één
    // CSS-var write per tick) en garandeert dat we nooit langer dan een
    // kwart seconde een stale kb-hoogte hebben.
    var kbPollId = 0;
    function startKeyboardPolling() {
      if (kbPollId) return;
      kbPollId = setInterval(updateKeyboardInset, 250);
    }
    function stopKeyboardPolling() {
      if (kbPollId) {
        clearInterval(kbPollId);
        kbPollId = 0;
      }
    }

    // ── Third-party widget hiding tijdens overlay-open ──────────────────
    // Dondy WhatsApp, Shopify-app downloadknop, etc. plakken zichzelf met
    // z-index 2147483647 (max-int) op de body. Bij gelijke z-index wint
    // DOM-volgorde — die kunnen zij voor ons winnen omdat sommigen zichzelf
    // dynamisch re-appenden. Pragmatische fix: tijdens overlay-open zetten we
    // bekende selectors op display:none en restoren bij close.
    var THIRD_PARTY_SELECTORS = [
      // Dondy WhatsApp (de widget op deze site)
      '[class*="dondy" i]',
      '[id*="dondy" i]',
      '[data-app="dondy"]',
      // Generieke whatsapp/floating buttons
      '[class*="whatsapp" i]:not(.vh-hero *)',
      '[id*="whatsapp" i]',
      '[class*="wa-button" i]',
      // Shopify download-app FABs
      '[class*="download-app" i]',
      '[class*="app-download" i]',
      // iframe-based widgets (Tidio, Crisp, Intercom, ChatGPT widgets)
      'iframe[src*="dondy"]',
      'iframe[src*="whatsapp"]',
      'iframe[name*="whatsapp" i]',
    ];

    var hiddenWidgets = []; // [{el, prevDisplay}]

    function hideThirdPartyWidgets() {
      hiddenWidgets = [];
      var matched = [];
      THIRD_PARTY_SELECTORS.forEach(function (sel) {
        try {
          var els = document.querySelectorAll(sel);
          els.forEach(function (el) {
            if (el === overlay || el === fab || overlay.contains(el)) return;
            if (matched.indexOf(el) !== -1) return;
            matched.push(el);
          });
        } catch (e) {
          /* selector kan crashen op oude browsers, negeer */
        }
      });
      matched.forEach(function (el) {
        hiddenWidgets.push({ el: el, prev: el.style.display });
        el.style.setProperty("display", "none", "important");
      });
    }

    function restoreThirdPartyWidgets() {
      hiddenWidgets.forEach(function (h) {
        if (h.prev) h.el.style.display = h.prev;
        else h.el.style.removeProperty("display");
      });
      hiddenWidgets = [];
    }

    // Bewaarde scroll-Y bij open zodat we 'm exact terugzetten bij sluiten.
    // position:fixed-truc reset anders de scroll naar boven.
    var savedScrollY = 0;
    function lockBodyScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = "-" + savedScrollY + "px";
      document.body.classList.add("vh-overlay-locked");
      document.documentElement.classList.add("vh-overlay-locked");
    }
    function unlockBodyScroll() {
      document.body.classList.remove("vh-overlay-locked");
      document.documentElement.classList.remove("vh-overlay-locked");
      document.body.style.top = "";
      // ScrollBehavior tijdelijk auto zodat scroll-restore niet smooth-animeert
      // (anders zie je de page naar de oude positie scrollen na sluiten).
      var prev = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = "auto";
      window.scrollTo(0, savedScrollY);
      document.documentElement.style.scrollBehavior = prev || "";
    }

    function openOverlay() {
      if (!overlay) return;
      // Re-append zodat overlay altijd LAATSTE child van body is. Bij gelijke
      // z-index wint DOM-order; door dit te forceren overstemmen we de meeste
      // andere fixed widgets ongeacht wanneer die geinjecteerd zijn.
      document.body.appendChild(overlay);
      overlay.classList.add("open");
      overlay.hidden = false;
      lockBodyScroll();
      if (fab) fab.classList.add("has-opened");
      if (!mobileEngine && mobileWrap) {
        mobileEngine = createChatEngine(mobileWrap, config);
        mobileEngine.start("");
      }
      updateKeyboardInset();
      startKeyboardPolling();
      // Verberg WhatsApp / Download-app widgets als laatste laag.
      hideThirdPartyWidgets();
      // GA4: click_start_chat per Sander's definitieve event-lijst. Alleen
      // op mobile (op desktop start de chat automatisch zonder klik). Mag
      // vaker dan 1× per sessie vuren (re-open = nieuwe engagement-actie).
      vetGA("click_start_chat", { surface: "mobile" });
    }

    function closeOverlay() {
      if (!overlay) return;
      // Blur eventueel actieve input zodat het toetsenbord SLUIT vóór de
      // overlay verdwijnt — voorkomt een korte flits van de pagina onder.
      var ae = document.activeElement;
      if (ae && overlay.contains(ae) && typeof ae.blur === "function") {
        ae.blur();
      }
      overlay.classList.remove("open");
      overlay.hidden = true;
      overlay.style.setProperty("--vh-kb-h", "0px");
      stopKeyboardPolling();
      unlockBodyScroll();
      restoreThirdPartyWidgets();
    }

    if (fab) fab.addEventListener("click", openOverlay);
    if (heroCta) heroCta.addEventListener("click", openOverlay);
    if (closeBtn) closeBtn.addEventListener("click", closeOverlay);

    // Externe site-knoppen met href="#stel-je-vraag" (of [data-vh-open-chat]):
    //   - desktop → laat de browser native naar de #stel-je-vraag-anchor scrollen
    //     (de sectie met het chatvenster);
    //   - mobiel  → open de popover-chat i.p.v. (omhoog) te scrollen.
    // Document-level want de knoppen staan elders op de pagina; één keer binden
    // (guard) zodat meerdere secties niet dubbel reageren.
    if (!window.__vhStelJeVraagBound) {
      window.__vhStelJeVraagBound = true;
      document.addEventListener("click", function (e) {
        var t = e.target;
        var link =
          t && t.closest
            ? t.closest('a[href$="#stel-je-vraag"], [data-vh-open-chat]')
            : null;
        if (!link) return;
        if (isMobile()) {
          e.preventDefault();
          openOverlay();
        }
        // desktop: niets doen → native scroll naar #stel-je-vraag.
      });
      // Deep-link: pagina geladen mét #stel-je-vraag in de URL → op mobiel meteen
      // de chat openen (op desktop scrollt de browser zelf naar de anchor).
      if (location.hash === "#stel-je-vraag") {
        requestAnimationFrame(function () {
          if (isMobile() && !window.__vhPayResumeHandled) openOverlay();
        });
      }
    }

    // v2_payment: op mobiel is er geen auto-boot — open de chat zelf zodat de
    // iDEAL-terugkeer hervat (op desktop pakt de auto-boot de vlag al op). Niet
    // doen als een andere engine de resume al claimde (embed dual-boot) → anders
    // een tweede chat naast de lopende betaling.
    if (_payReturnMobileOpen && isMobile() && !window.__vhPayResumeHandled) {
      openOverlay();
    }

    // Escape sluit overlay
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && overlay && overlay.classList.contains("open")) {
        closeOverlay();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
